import { j as Ie } from "./jsx-runtime-944c88e2.js";
import * as a from "react";
import { createContext as zs, useContext as Us, forwardRef as Os, useCallback as Ls, useMemo as Hs } from "react";
import { p as Ps, Z as X } from "./index-efd35e77.js";
import { W as ve, _ as fl, g as Ws, C as je, Y as ze, i as xo, f as xn, R as Ke, d as xr, F as ur, H as Ys, z as $s, k as Gs, K as Bs, P as ie, m as Ks, S as _e, N as Vs, X as jr } from "./index-c07310bf.js";
import { _ as Nr, o as pl, f as qs } from "./operators.enum-58ea56cd.js";
import { C as Qe, S as He } from "./index-93802845.js";
import { B as xe } from "./Button-4c83e316.js";
import { B as Nn } from "./ButtonGroup-a9850ef0.js";
import { D as Zs } from "./DropDownButton-d323264e.js";
import { T as vl } from "./Toolbar-08559716.js";
import { c as Xs } from "./package-metadata-9ad1330d.js";
import { T as js } from "./ToolbarSpacer-8b07ac30.js";
import { D as ke, c as Qt, M as An, b as Jr, f as gl, d as Xe, g as tt, a as Js, R as Ya, u as $a, e as No, h as Rt, l as Qs } from "./index-7c241c5b.js";
import { a as ec } from "./Popup-b6c9078b.js";
import { o as tc, c as rc, a8 as ac, w as nc, x as yl, b as Pt, a as Wt, a9 as _n, aa as hl, ab as oc, q as lc, ac as ic } from "./index.es-6889c727.js";
import * as aa from "react-dom";
import { f as de, E as jt, F as sc, a as cc, b as Jt } from "./form-2514c6d8.js";
import { F as we, c as uc, b as dc } from "./FormElement-65f04cfd.js";
import { a as Fn, D as zn } from "./Dialog-a72b336a.js";
import { L as Te } from "./Label-079ad7bc.js";
import { a as mc, v as ba, y as fc, z as Br, k as Sa } from "./index-a0534bb4.js";
import { y as pc, Z as Lt, h as vc } from "./index-b1011fa6.js";
import { TextAreaFormField as Ao } from "./textArea.js";
import { DateTimePickerFormField as _o } from "./dateTimePicker.js";
import { CheckboxFormField as gc } from "./checkbox.js";
import { Dialog as yc } from "./dialog.js";
import { Button as Fo } from "./button.js";
import { DatePickerFormField as zo } from "./datePicker.js";
import { DropDownListFormField as hc } from "./dropDownList.js";
import "./index-64063129.js";
import "./auto-scroll-b2de6e53.js";
import "./theme-b013fa81.js";
import "./popup-da16fa2b.js";
import "./keys-2b65407d.js";
import "./FloatingLabel-922c628f.js";
import "./package-metadata-3dcf116a.js";
import "./ActionSheet-b5bf2237.js";
import "./Animation-154b683d.js";
import "./TransitionGroup-34043d49.js";
import "./noop-d627517c.js";
import "./package-metadata-a152adb8.js";
import "./surface-71c0d1c6.js";
import "./Chip-cb37946d.js";
import "./TreeView-aa1ef3e3.js";
import "./Reveal-e2f427f6.js";
import "./Animation-d8a017b3.js";
import "./form-field-wrapper.hoc-d784197f.js";
import "./Ripple-5a8cf54c.js";
import "./icon.js";
var Ec = globalThis && globalThis.__extends || function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, o) {
      n.__proto__ = o;
    } || function(n, o) {
      for (var l in o)
        Object.prototype.hasOwnProperty.call(o, l) && (n[l] = o[l]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Un = (
  /** @class */
  function(e) {
    Ec(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._element = null, r;
    }
    return Object.defineProperty(t.prototype, "element", {
      /**
       * Returns the HTML element of the ToolbarItem component.
       */
      get: function() {
        return this._element;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.render = function() {
      var r = this;
      return a.createElement("div", { id: this.props.id, className: Xs("k-toolbar-item", this.props.className), style: this.props.style, ref: function(n) {
        return r._element = n;
      } }, this.props.children);
    }, t.propTypes = {
      className: Ps.string
    }, t;
  }(a.PureComponent)
), Qr = function(e, t) {
  t === void 0 && (t = ke.Sunday);
  for (var r = Qt(e); r.getDay() !== t; )
    r.setDate(r.getDate() - 1);
  return r;
}, On = {
  rules: {},
  titles: {},
  zones: {}
}, Ma = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 }, Uo = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }, Dc = 6e4, Oo = function(e, t, r) {
  var n = t[3], o = t[4], l = t[5], i, s = l[3] === "u" ? -r * Dc : 0;
  if (!isNaN(o))
    i = new Date(Date.UTC(e, Ma[n], o, l[0], l[1], l[2]) + s);
  else if (o.indexOf("last") === 0) {
    i = new Date(Date.UTC(e, Ma[n] + 1, 1, l[0] - 24, l[1], l[2]) + s);
    var c = Uo[o.substr(4, 3)], u = i.getUTCDay();
    i.setUTCDate(i.getUTCDate() + c - u - (c > u ? 7 : 0));
  } else if (o.indexOf(">=") >= 0) {
    i = new Date(Date.UTC(e, Ma[n], o.substr(5), l[0], l[1], l[2], 0) + s);
    var c = Uo[o.substr(0, 3)], u = i.getUTCDay();
    i.setUTCDate(i.getUTCDate() + c - u + (c < u ? 7 : 0));
  }
  return i;
}, Cc = (/* @__PURE__ */ new Date()).getTime(), Tc = function(e, t, r) {
  t === void 0 && (t = Cc), r === void 0 && (r = 0);
  var n = On.rules[e];
  if (!n) {
    var o = e.split(":"), l = 0;
    return o.length > 1 && (l = o[0] * 60 + Number(o[1])), [-1e6, "max", "-", "Jan", 1, [0, 0, 0], l, "-"];
  }
  var i = new Date(t).getUTCFullYear();
  n = n.filter(function(c) {
    var u = c[0], d = c[1];
    return u <= i && (d >= i || u === i && d === "only" || d === "max");
  }), n.push(t), n.sort(function(c, u) {
    return typeof c != "number" && (c = Number(Oo(i, c, r))), typeof u != "number" && (u = Number(Oo(i, u, r))), c - u;
  });
  var s = n[n.indexOf(t) - 1] || n[n.length - 1];
  return isNaN(s) ? s : null;
}, Ga = "The required {0} timezone information is not provided!", kc = /\{(\d+)}?\}/g, bc = function(e) {
  return e.reduce(function(t, r) {
    return t.concat(r);
  }, []);
}, Ba = function(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  var n = bc(t);
  return e.replace(kc, function(o, l) {
    return n[parseInt(l, 10)];
  });
}, Sc = function(e) {
  var t = On.zones;
  if (!t)
    throw new Error(Ba(Ga, e));
  var r = t[e], n = typeof r == "string" ? t[r] : r;
  if (!n)
    throw new Error(Ba(Ga, e));
  return n;
}, Mc = function(e, t) {
  if (t === void 0 && (t = (/* @__PURE__ */ new Date()).getTime()), e === "Etc/UTC" || e === "Etc/GMT")
    return [0, "-", "UTC", null];
  for (var r = Sc(e), n = r.length - 1; n >= 0; n--) {
    var o = r[n][3];
    if (o && t > o)
      break;
  }
  var l = r[n + 1];
  if (!l)
    throw new Error(Ba(Ga, e));
  return l;
}, El = function(e, t) {
  var r = t.getTime(), n = Mc(e, r);
  return {
    rule: Tc(n[1], r, n[0]),
    zone: n
  };
}, wc = function(e, t) {
  if (t === void 0 && (t = /* @__PURE__ */ new Date()), e === "Etc/UTC")
    return "UTC";
  if (e === "Etc/GMT")
    return "GMT";
  if (e === "")
    return "";
  var r = El(e, t), n = r.zone, o = r.rule, l = n[2];
  return l.indexOf("/") >= 0 ? l.split("/")[o && +o[6] ? 1 : 0] : l.indexOf("%s") >= 0 ? l.replace("%s", !o || o[7] === "-" ? "" : o[7]) : l;
}, Mt = function(e, t) {
  if (t === void 0 && (t = /* @__PURE__ */ new Date()), e === "Etc/UTC" || e === "Etc/GMT")
    return 0;
  if (e === "")
    return t.getTimezoneOffset();
  var r = El(e, t), n = r.rule, o = r.zone;
  return parseFloat(n ? o[0] - n[6] : o[0]);
}, Ic = function() {
  return Object.keys(On.zones);
};
function na(e) {
  return new Date(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate(), e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds());
}
var Ka = function(e, t) {
  return new Date(e.getTime() + t * An);
}, Ln = function(e, t) {
  return new Date(e.getTime() + t * Jr);
}, Rc = [
  "Sun",
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat"
], xc = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], Nc = function(e) {
  return Rc[e.getUTCDay()] + " " + xc[e.getUTCMonth()];
}, mr = function(e, t) {
  t === void 0 && (t = 2);
  var r = e < 0 ? "-" : "";
  return r + new Array(t).concat([Math.abs(e)]).join("0").slice(-t);
};
function Dl(e, t) {
  var r = Mt(t, e), n = Ln(e, -1), o = Mt(t, n);
  return r < o;
}
function wa(e, t) {
  var r = Dl(e, t) ? 1 : 0;
  return Ln(e, r);
}
function Lo(e, t, r) {
  if (t === r)
    return e;
  var n = Mt(t, e), o = Mt(r, e), l = n - o, i = Ka(e, l), s = Mt(r, i), c = o - s;
  return Ka(e, l + c);
}
function Ac(e) {
  var t = e <= 0 ? "+" : "-", r = Math.abs(e), n = mr(Math.floor(r / 60)), o = mr(r % 60);
  return "GMT" + t + n + o;
}
var j = (
  /** @class */
  function() {
    function e(t, r) {
      this._utcDate = Qt(t), this.timezone = r;
      var n = Mt(r, t);
      this.timezoneOffset = n;
      var o = wa(t, r);
      this._localDate = Lo(o, r, "Etc/UTC");
    }
    return Object.defineProperty(e.prototype, "cachedLocalDate", {
      /**
       * Returns a cached local date that denotes the exact time in the set timezone.
       *
       * @return Date - A local date that denotes the exact time in the set timezone.
       *
       * This property is an alternative to `toLocalDate()` that returns a cached value instead of cloning it.
       *
       * > Modifying the returned instance will corrupt the `ZonedDate` state.
       */
      get: function() {
        return this._localDate;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "cachedUTCDate", {
      /**
       * Returns a cached `Date` instance with UTC date parts that are set to the local time in the set timezone.
       *
       * @returns Date - A `Date` with UTC date parts that are set to the local time in the set timezone.
       *
       * This property is an alternative to `toUTCDate()` that returns a cached value instead of cloning it.
       *
       * > Modifying the returned instance will corrupt the `ZonedDate` state.
       */
      get: function() {
        return this._utcDate;
      },
      enumerable: !0,
      configurable: !0
    }), e.fromLocalDate = function(t, r) {
      r === void 0 && (r = "");
      var n = Lo(t, "Etc/UTC", r), o = Dl(n, r), l = Mt(r, n), i = 0;
      o && (i = l > 0 ? -1 : 1);
      var s = Ln(n, i);
      return e.fromUTCDate(s, r);
    }, e.fromUTCDate = function(t, r) {
      return r === void 0 && (r = ""), new e(t, r);
    }, e.prototype.toLocalDate = function() {
      return Qt(this._localDate);
    }, e.prototype.toUTCDate = function() {
      return Qt(this._utcDate);
    }, e.prototype.toTimezone = function(t) {
      if (this.timezone === t)
        return this.clone();
      var r = Mt(this.timezone, this._utcDate), n = Ka(this._utcDate, r);
      return e.fromLocalDate(n, t);
    }, e.prototype.clone = function() {
      return e.fromUTCDate(this._utcDate, this.timezone);
    }, e.prototype.addDays = function(t) {
      var r = new Date(this._utcDate.getTime());
      return r.setUTCDate(r.getUTCDate() + t), e.fromUTCDate(r, this.timezone);
    }, e.prototype.addTime = function(t) {
      var r = new Date(this._utcDate.getTime()), n = wa(r, this.timezone);
      n.setTime(n.getTime() + t);
      var o = wa(n, this.timezone);
      return e.fromUTCDate(o, this.timezone);
    }, e.prototype.stripTime = function() {
      var t = this._utcDate, r = Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate(), 0, 0, 0);
      return e.fromUTCDate(new Date(r), this.timezone);
    }, e.prototype.getTime = function() {
      return this._localDate.getTime();
    }, e.prototype.getTimezoneOffset = function() {
      return this.timezoneOffset;
    }, e.prototype.getFullYear = function() {
      return this._utcDate.getUTCFullYear();
    }, e.prototype.getMonth = function() {
      return this._utcDate.getUTCMonth();
    }, e.prototype.getDate = function() {
      return this._utcDate.getUTCDate();
    }, e.prototype.getDay = function() {
      return this._utcDate.getUTCDay();
    }, e.prototype.getHours = function() {
      return this._utcDate.getUTCHours();
    }, e.prototype.getMinutes = function() {
      return this._utcDate.getUTCMinutes();
    }, e.prototype.getSeconds = function() {
      return this._utcDate.getUTCSeconds();
    }, e.prototype.getMilliseconds = function() {
      return this._utcDate.getUTCMilliseconds();
    }, e.prototype.getUTCDate = function() {
      return this._localDate.getUTCDate();
    }, e.prototype.getUTCDay = function() {
      return this._localDate.getUTCDay();
    }, e.prototype.getUTCFullYear = function() {
      return this._localDate.getUTCFullYear();
    }, e.prototype.getUTCHours = function() {
      return this._localDate.getUTCHours();
    }, e.prototype.getUTCMilliseconds = function() {
      return this._localDate.getUTCMilliseconds();
    }, e.prototype.getUTCMinutes = function() {
      return this._localDate.getUTCMinutes();
    }, e.prototype.getUTCMonth = function() {
      return this._localDate.getUTCMonth();
    }, e.prototype.getUTCSeconds = function() {
      return this._localDate.getUTCSeconds();
    }, e.prototype.setTime = function(t) {
      throw new Error("Method not implemented.");
    }, e.prototype.setMilliseconds = function(t) {
      throw new Error("Method not implemented.");
    }, e.prototype.setUTCMilliseconds = function(t) {
      throw new Error("Method not implemented.");
    }, e.prototype.setSeconds = function(t, r) {
      throw new Error("Method not implemented.");
    }, e.prototype.setUTCSeconds = function(t, r) {
      throw new Error("Method not implemented.");
    }, e.prototype.setMinutes = function(t, r, n) {
      throw new Error("Method not implemented.");
    }, e.prototype.setUTCMinutes = function(t, r, n) {
      throw new Error("Method not implemented.");
    }, e.prototype.setHours = function(t, r, n, o) {
      throw new Error("Method not implemented.");
    }, e.prototype.setUTCHours = function(t, r, n, o) {
      throw new Error("Method not implemented.");
    }, e.prototype.setDate = function(t) {
      throw new Error("Method not implemented.");
    }, e.prototype.setUTCDate = function(t) {
      throw new Error("Method not implemented.");
    }, e.prototype.setMonth = function(t, r) {
      throw new Error("Method not implemented.");
    }, e.prototype.setUTCMonth = function(t, r) {
      throw new Error("Method not implemented.");
    }, e.prototype.setFullYear = function(t, r, n) {
      throw new Error("Method not implemented.");
    }, e.prototype.setUTCFullYear = function(t, r, n) {
      throw new Error("Method not implemented.");
    }, e.prototype.toISOString = function() {
      return this._localDate.toISOString();
    }, e.prototype.toJSON = function() {
      return this._localDate.toJSON();
    }, e.prototype.toString = function() {
      var t = Nc(this._utcDate), r = this.toTimeString();
      return t + " " + this.getDate() + " " + this.getFullYear() + " " + r;
    }, e.prototype.toDateString = function() {
      return na(this._utcDate).toDateString();
    }, e.prototype.toTimeString = function() {
      var t = mr(this.getHours()), r = mr(this.getMinutes()), n = mr(this.getSeconds()), o = t + ":" + r + ":" + n, l = Ac(this.timezoneOffset), i = wc(this.timezone, this._utcDate);
      return i && (i = " (" + i + ")"), o + " " + l + i;
    }, e.prototype.toLocaleString = function(t, r) {
      return this._localDate.toLocaleString(t, r);
    }, e.prototype.toLocaleDateString = function(t, r) {
      return this._localDate.toLocaleDateString(t, r);
    }, e.prototype.toLocaleTimeString = function(t, r) {
      return this._localDate.toLocaleTimeString(t, r);
    }, e.prototype.toUTCString = function() {
      return this.toTimezone("Etc/UTC").toString();
    }, e.prototype[Symbol.toPrimitive] = function(t) {
      return t === "string" || t === "default" ? this.toString() : this._localDate.getTime();
    }, e.prototype.valueOf = function() {
      return this.getTime();
    }, e.prototype.getVarDate = function() {
      throw new Error("Not implemented.");
    }, e.prototype.format = function(t) {
      throw new Error("Not implemented.");
    }, e.prototype.formatUTC = function(t) {
      throw new Error("Not implemented.");
    }, e;
  }()
), kt = function(e) {
  return e instanceof Array && e.length > 0;
}, Cl = function(e) {
  return kt(e.bySecond) || kt(e.byMinute) || kt(e.byHour) || kt(e.byYearDay) || kt(e.byMonthDay) || kt(e.byWeekDay) || kt(e.byMonth) || kt(e.byWeekNumber);
}, Tl = function(e) {
  for (var t = e.split(";"), r = [], n = null, o = 0; o < t.length; o++) {
    var l = t[o].split(":"), i = l[0], s = l[1], c = s === void 0 ? "" : s, u = i.indexOf("TZID");
    u !== -1 && (n = i.substring(u).split("=")[1]), r = c.split(",").map(function(d) {
      return Pl(d, n);
    });
  }
  return !r.length || r[0] === null ? null : r;
}, Ho = function(e) {
  var t = Tl(e);
  return t === null ? null : t[0];
}, _c = {
  en: {
    name: "en",
    identity: {
      version: {
        _number: "$Revision: 12418 $",
        _cldrVersion: "29"
      },
      language: "en"
    },
    territory: "US",
    numbers: {
      symbols: {
        decimal: ".",
        group: ",",
        list: ";",
        percentSign: "%",
        plusSign: "+",
        minusSign: "-",
        exponential: "E",
        superscriptingExponent: "×",
        perMille: "‰",
        infinity: "∞",
        nan: "NaN",
        timeSeparator: ":"
      },
      decimal: {
        patterns: [
          "n"
        ],
        groupSize: [
          3
        ]
      },
      scientific: {
        patterns: [
          "nEn"
        ],
        groupSize: []
      },
      percent: {
        patterns: [
          "n%"
        ],
        groupSize: [
          3
        ]
      },
      currency: {
        patterns: [
          "$n"
        ],
        groupSize: [
          3
        ],
        "unitPattern-count-one": "n $",
        "unitPattern-count-other": "n $"
      },
      currencies: {
        BGN: {
          displayName: "Bulgarian Lev",
          "displayName-count-one": "Bulgarian lev",
          "displayName-count-other": "Bulgarian leva",
          symbol: "BGN"
        },
        EUR: {
          displayName: "Euro",
          "displayName-count-one": "euro",
          "displayName-count-other": "euros",
          symbol: "€",
          "symbol-alt-narrow": "€"
        },
        USD: {
          displayName: "US Dollar",
          "displayName-count-one": "US dollar",
          "displayName-count-other": "US dollars",
          symbol: "$",
          "symbol-alt-narrow": "$"
        }
      },
      localeCurrency: "USD",
      accounting: {
        patterns: [
          "$n",
          "($n)"
        ],
        groupSize: [
          3
        ]
      }
    },
    calendar: {
      gmtFormat: "GMT{0}",
      gmtZeroFormat: "GMT",
      patterns: {
        d: "M/d/y",
        D: "EEEE, MMMM d, y",
        m: "MMM d",
        M: "MMMM d",
        y: "MMM y",
        Y: "MMMM y",
        F: "EEEE, MMMM d, y h:mm:ss a",
        g: "M/d/y h:mm a",
        G: "M/d/y h:mm:ss a",
        t: "h:mm a",
        T: "h:mm:ss a",
        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'"
      },
      dateTimeFormats: {
        full: "{1} 'at' {0}",
        long: "{1} 'at' {0}",
        medium: "{1}, {0}",
        short: "{1}, {0}",
        availableFormats: {
          Bh: "h B",
          Bhm: "h:mm B",
          Bhms: "h:mm:ss B",
          d: "d",
          E: "ccc",
          EBhm: "E h:mm B",
          EBhms: "E h:mm:ss B",
          Ed: "d E",
          Ehm: "E h:mm a",
          EHm: "E HH:mm",
          Ehms: "E h:mm:ss a",
          EHms: "E HH:mm:ss",
          Gy: "y G",
          GyMMM: "MMM y G",
          GyMMMd: "MMM d, y G",
          GyMMMEd: "E, MMM d, y G",
          h: "h a",
          H: "HH",
          hm: "h:mm a",
          Hm: "HH:mm",
          hms: "h:mm:ss a",
          Hms: "HH:mm:ss",
          hmsv: "h:mm:ss a v",
          Hmsv: "HH:mm:ss v",
          hmv: "h:mm a v",
          Hmv: "HH:mm v",
          M: "L",
          Md: "M/d",
          MEd: "E, M/d",
          MMM: "LLL",
          MMMd: "MMM d",
          MMMEd: "E, MMM d",
          MMMMd: "MMMM d",
          "MMMMW-count-one": "'week' W 'of' MMMM",
          "MMMMW-count-other": "'week' W 'of' MMMM",
          ms: "mm:ss",
          y: "y",
          yM: "M/y",
          yMd: "M/d/y",
          yMEd: "E, M/d/y",
          yMMM: "MMM y",
          yMMMd: "MMM d, y",
          yMMMEd: "E, MMM d, y",
          yMMMM: "MMMM y",
          yQQQ: "QQQ y",
          yQQQQ: "QQQQ y",
          "yw-count-one": "'week' w 'of' Y",
          "yw-count-other": "'week' w 'of' Y"
        }
      },
      timeFormats: {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      },
      dateFormats: {
        full: "EEEE, MMMM d, y",
        long: "MMMM d, y",
        medium: "MMM d, y",
        short: "M/d/yy"
      },
      days: {
        format: {
          abbreviated: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
          ],
          narrow: [
            "S",
            "M",
            "T",
            "W",
            "T",
            "F",
            "S"
          ],
          short: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
          ],
          wide: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
          ]
        },
        "stand-alone": {
          abbreviated: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
          ],
          narrow: [
            "S",
            "M",
            "T",
            "W",
            "T",
            "F",
            "S"
          ],
          short: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
          ],
          wide: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
          ]
        }
      },
      months: {
        format: {
          abbreviated: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          narrow: [
            "J",
            "F",
            "M",
            "A",
            "M",
            "J",
            "J",
            "A",
            "S",
            "O",
            "N",
            "D"
          ],
          wide: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ]
        },
        "stand-alone": {
          abbreviated: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          narrow: [
            "J",
            "F",
            "M",
            "A",
            "M",
            "J",
            "J",
            "A",
            "S",
            "O",
            "N",
            "D"
          ],
          wide: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ]
        }
      },
      quarters: {
        format: {
          abbreviated: [
            "Q1",
            "Q2",
            "Q3",
            "Q4"
          ],
          narrow: [
            "1",
            "2",
            "3",
            "4"
          ],
          wide: [
            "1st quarter",
            "2nd quarter",
            "3rd quarter",
            "4th quarter"
          ]
        },
        "stand-alone": {
          abbreviated: [
            "Q1",
            "Q2",
            "Q3",
            "Q4"
          ],
          narrow: [
            "1",
            "2",
            "3",
            "4"
          ],
          wide: [
            "1st quarter",
            "2nd quarter",
            "3rd quarter",
            "4th quarter"
          ]
        }
      },
      dayPeriods: {
        format: {
          abbreviated: {
            midnight: "midnight",
            am: "AM",
            "am-alt-variant": "am",
            noon: "noon",
            pm: "PM",
            "pm-alt-variant": "pm",
            morning1: "in the morning",
            afternoon1: "in the afternoon",
            evening1: "in the evening",
            night1: "at night"
          },
          narrow: {
            midnight: "mi",
            am: "a",
            "am-alt-variant": "am",
            noon: "n",
            pm: "p",
            "pm-alt-variant": "pm",
            morning1: "in the morning",
            afternoon1: "in the afternoon",
            evening1: "in the evening",
            night1: "at night"
          },
          wide: {
            midnight: "midnight",
            am: "AM",
            "am-alt-variant": "am",
            noon: "noon",
            pm: "PM",
            "pm-alt-variant": "pm",
            morning1: "in the morning",
            afternoon1: "in the afternoon",
            evening1: "in the evening",
            night1: "at night"
          }
        },
        "stand-alone": {
          abbreviated: {
            midnight: "midnight",
            am: "AM",
            "am-alt-variant": "am",
            noon: "noon",
            pm: "PM",
            "pm-alt-variant": "pm",
            morning1: "morning",
            afternoon1: "afternoon",
            evening1: "evening",
            night1: "night"
          },
          narrow: {
            midnight: "midnight",
            am: "AM",
            "am-alt-variant": "am",
            noon: "noon",
            pm: "PM",
            "pm-alt-variant": "pm",
            morning1: "morning",
            afternoon1: "afternoon",
            evening1: "evening",
            night1: "night"
          },
          wide: {
            midnight: "midnight",
            am: "AM",
            "am-alt-variant": "am",
            noon: "noon",
            pm: "PM",
            "pm-alt-variant": "pm",
            morning1: "morning",
            afternoon1: "afternoon",
            evening1: "evening",
            night1: "night"
          }
        }
      },
      eras: {
        format: {
          wide: {
            0: "Before Christ",
            1: "Anno Domini",
            "0-alt-variant": "Before Common Era",
            "1-alt-variant": "Common Era"
          },
          abbreviated: {
            0: "BC",
            1: "AD",
            "0-alt-variant": "BCE",
            "1-alt-variant": "CE"
          },
          narrow: {
            0: "B",
            1: "A",
            "0-alt-variant": "BCE",
            "1-alt-variant": "CE"
          }
        }
      },
      dateFields: {
        era: {
          wide: "era"
        },
        year: {
          wide: "year",
          short: "yr.",
          narrow: "yr."
        },
        quarter: {
          wide: "quarter",
          short: "qtr.",
          narrow: "qtr."
        },
        month: {
          wide: "month",
          short: "mo.",
          narrow: "mo."
        },
        week: {
          wide: "week",
          short: "wk.",
          narrow: "wk."
        },
        day: {
          wide: "day",
          short: "day",
          narrow: "day"
        },
        weekday: {
          wide: "day of the week"
        },
        dayperiod: {
          wide: "AM/PM"
        },
        hour: {
          wide: "hour",
          short: "hr.",
          narrow: "hr."
        },
        minute: {
          wide: "minute",
          short: "min.",
          narrow: "min."
        },
        second: {
          wide: "second",
          short: "sec.",
          narrow: "sec."
        },
        millisecond: {
          wide: "millisecond",
          short: "ms",
          narrow: "ms"
        },
        zone: {
          wide: "time zone"
        }
      }
    }
  },
  supplemental: {
    likelySubtags: {
      en: "en-Latn-US"
    },
    currencyData: {
      region: {
        US: [
          {
            USD: {
              _from: "1792-01-01"
            }
          }
        ]
      }
    },
    weekData: {
      firstDay: {
        US: "sun"
      },
      weekendStart: {
        "001": "sat"
      },
      weekendEnd: {
        "001": "sun"
      }
    }
  }
};
function Hn(e) {
  return typeof e == "string";
}
const Fc = {
  NoLocale: "Missing locale info for '{0}'",
  NoCurrency: "Cannot determine currency information. Please load the locale currencies data.",
  NoSupplementalCurrency: "Cannot determine currency. Please load the supplemental currencyData.",
  NoCurrencyRegion: "No currency data for region '{0}'",
  NoCurrencyDisplay: "Cannot determine currency display information. Please load the locale currencies data. The default culture does not include the all currencies data.",
  NoGMTInfo: "Cannot determine locale GMT format. Please load the locale timeZoneNames data.",
  NoWeekData: "Cannot determine locale first day of week. Please load the supplemental weekData.",
  NoFirstDay: "Cannot determine locale first day of week. Please load the supplemental weekData. The default culture includes only the 'en-US' first day info.",
  NoValidCurrency: "Cannot determine a default currency for the {0} locale. Please specify explicitly the currency with the format options.",
  NoDateFieldNames: "Cannot determine the locale date field names. Please load the locale dateFields data."
};
var zc = /\{(\d+)}?\}/g, Pn = function(t) {
  var r = t.name, n = t.message;
  if (!r || !n)
    throw new Error("{ name: string, message: string } object is required!");
  this.name = r, this.message = n;
};
Pn.prototype.formatMessage = function() {
  for (var t = [], r = arguments.length; r--; )
    t[r] = arguments[r];
  var n = Uc(t), o = this.message.replace(zc, function(l, i) {
    return n[parseInt(i, 10)];
  });
  return this.name + ": " + o;
};
Pn.prototype.error = function() {
  for (var t = [], r = arguments.length; r--; )
    t[r] = arguments[r];
  return new Error(this.formatMessage(t));
};
var Uc = function(e) {
  return e.reduce(function(t, r) {
    return t.concat(r);
  }, []);
}, Oc = function(e) {
  var t = function(r, n) {
    return r[n] = new Pn({ name: n, message: e[n] }), r;
  };
  return Object.keys(e).reduce(t, {});
}, dt = Oc(Fc);
function Lc(e, t) {
  var r = e.split("-"), n = r[0], o = r[1], l = r[2];
  return qe[e] || t.indexOf(l) !== -1 && qe[n + "-" + l] || t.indexOf(o) !== -1 && qe[n + "-" + o] || qe[n];
}
function Hc(e, t) {
  for (var r = qe.supplemental.likelySubtags, n = 0; n < t.length; n++) {
    var o = r[e + "-" + t[n]];
    if (o)
      return o;
  }
  if (r[e])
    return r[e];
}
var qe = _c;
function oa(e) {
  var t;
  return Hn(e) ? t = la(e) : t = e, t;
}
function la(e) {
  if (qe[e])
    return qe[e];
  var t = qe.supplemental.likelySubtags;
  if (t) {
    var r = e.split("-"), n = r[0], o = r.slice(1), l = Hc(n, o), i = l ? Lc(l, o) : null;
    if (i)
      return i;
  }
  throw dt.NoLocale.error(e);
}
var kl = "decimal", ia = "currency", bl = "accounting", Ar = "percent", Sl = "scientific", Wn = "$", Yn = "%", pr = "n", Pc = ";", Wc = ",", vr = ".", me = "", $n = "en";
function Yc(e, t) {
  var r = qe.supplemental.likelySubtags, n = e.split("-");
  if (r) {
    var o = r[e] || r[n[0]];
    o && (n = o.split("-"));
  }
  if (t)
    for (var l = n.length - 1; l >= 1; l--) {
      var i = n[l];
      (i === t.variant || i === t.script) && n.splice(l, 1);
    }
  var s = n.length;
  if (s > 1) {
    var c = n[s - 1];
    return c.toUpperCase();
  }
}
function Ml(e) {
  if (e.territory)
    return e.territory;
  var t = e.name, r = e.identity, n;
  return r && r.territory ? n = r.territory : n = Yc(t, r), e.territory = n, n;
}
function $c(e) {
  for (var t = [], r = 0; r < e.length; r++)
    t.push(e[r].toLowerCase());
  return t;
}
function Gc(e) {
  var t = {};
  for (var r in e)
    t[r] = e[r].toLowerCase();
  return t;
}
function Bc(e) {
  var t = Array.isArray(e) ? $c(e) : Gc(e);
  return t;
}
function Kc(e, t) {
  var r = t.type, n = t.nameType, o = t.standAlone, l = t.lower, i = oa(e), s = o ? "stand-alone" : "format", c = (l ? "lower-" : me) + n, u = i.calendar[r][s], d = u[c];
  return !d && l && (d = u[c] = Bc(u[n])), d;
}
function Ia(e) {
  var t = e.split("-"), r = parseInt(t[0], 10), n = parseInt(t[1], 10) - 1, o = parseInt(t[2], 10);
  return new Date(r, n, o);
}
var Vc = dt.NoCurrency, qc = dt.NoCurrencyDisplay, Zc = dt.NoSupplementalCurrency, Xc = dt.NoCurrencyRegion, jc = dt.NoValidCurrency, Po = 2, Ra = "symbol", Jc = "XXX", Wo = {
  "001": "USD",
  // 001 refers to world. not sure if it is correct to assume USD but seems better than throw an error
  150: "EUR"
  // 150 territory for Europe
};
function Qc(e, t, r) {
  var n = oa(e), o = n.numbers.currencies;
  if (!o) {
    if (r)
      throw Vc.error();
    return;
  }
  var l = o[t];
  if (!l) {
    if (r)
      throw qc.error();
    return;
  }
  return l;
}
function eu(e) {
  for (var t, r, n, o, l = 0; l < e.length; l++) {
    var i = e[l], s = Object.keys(i)[0], c = i[s];
    if (s !== Jc && c._tender !== "false" && c._from)
      if (c._to) {
        if (!n) {
          var d = Ia(c._from), m = Ia(c._to);
          (!r || r.to < m || r.from < d) && (t = s, r = {
            from: d,
            to: m
          });
        }
      } else {
        var u = Ia(c._from);
        (!o || o < u) && (n = s, o = u);
      }
  }
  return n || t;
}
function tu(e, t) {
  var r = t.value, n = t.currency, o = t.currencyDisplay;
  if (o === void 0 && (o = Ra), o === "code")
    return n;
  var l = Qc(e, n, !0), i;
  return o === Ra ? i = l["symbol-alt-narrow"] || l[Ra] : typeof r === void 0 || r !== 1 ? i = l["displayName-count-other"] : i = l["displayName-count-one"], i;
}
function ru(e) {
  var t = Po, r = Po, n = ((qe.supplemental.currencyData || {}).fractions || {})[e];
  return n && n._digits && (r = t = parseInt(n._digits, 10)), {
    minimumFractionDigits: t,
    maximumFractionDigits: r
  };
}
function au(e, t) {
  if (t === void 0 && (t = !0), Wo[e])
    return Wo[e];
  var r = qe.supplemental.currencyData;
  if (!r) {
    if (t)
      throw Zc.error();
    return;
  }
  var n = r.region[e];
  if (!n) {
    if (t)
      throw Xc.error(e);
    return;
  }
  var o = eu(n);
  return o;
}
function nu(e, t) {
  var r = oa(e), n = r.numbers;
  if (!n.localeCurrency) {
    var o = au(Ml(r), t);
    if (!o && t)
      throw jc.error(r.name);
    n.localeCurrency = o;
  }
  return n.localeCurrency;
}
var ou = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"], lu = "001", iu = dt.NoWeekData, su = dt.NoFirstDay;
function cu(e) {
  var t = oa(e);
  if (!isNaN(t.firstDay))
    return t.firstDay;
  var r = qe.supplemental.weekData;
  if (!r)
    throw iu.error();
  var n = r.firstDay[Ml(t)] || r.firstDay[lu];
  if (!n)
    throw su.error();
  return t.firstDay = ou.indexOf(n), t.firstDay;
}
dt.NoWeekData;
function wl(e) {
  return 1 / e === -1 / 0;
}
function Il(e, t) {
  t === void 0 && (t = {}), t.currency || (t.currency = nu(e, !0));
  var r = tu(e, t);
  return r;
}
function Rl(e, t, r, n, o) {
  var l = o.numbers.symbols, i = e.indexOf(l.decimal), s = n.groupSize.slice(), c = s.shift(), u = i !== -1 ? i : r + 1, d = e.substring(t, u), m = e, p = d.length;
  if (p >= c) {
    for (var f = p, h = []; f > -1; ) {
      var y = d.substring(f - c, f);
      y && h.push(y), f -= c;
      var k = s.shift();
      if (c = k !== void 0 ? k : c, c === 0) {
        y = d.substring(0, f), y && h.push(y);
        break;
      }
    }
    d = h.reverse().join(l.group), m = e.substring(0, t) + d + e.substring(u);
  }
  return m;
}
function xl(e) {
  return e === ia || e === bl;
}
function Ne(e, t, r) {
  t === void 0 && (t = 2), r === void 0 && (r = !1);
  var n = t - String(e).length, o = e;
  if (n > 0) {
    var l = new Array(n + 1).join("0");
    o = r ? e + l : l + e;
  }
  return o;
}
var uu = 20;
function fr(e, t) {
  var r = e, n = t || 0;
  return r = r.toString().split("e"), r = Math.round(+(r[0] + "e" + (r[1] ? Number(r[1]) + n : n))), r = r.toString().split("e"), r = +(r[0] + "e" + (r[1] ? Number(r[1]) - n : -n)), r.toFixed(Math.min(n, uu));
}
var du = 3, mu = 0, fu = /0+$/;
function pu(e) {
  var t = e.minimumFractionDigits, r = e.maximumFractionDigits, n = e.style, o = xl(n), l;
  return o && (l = ru(e.currency)), t === void 0 && (t = o ? l.minimumFractionDigits : 0), r === void 0 && (n === Ar ? r = Math.max(t, mu) : o ? r = Math.max(t, l.maximumFractionDigits) : r = Math.max(t, du)), {
    minimumFractionDigits: t,
    maximumFractionDigits: r
  };
}
function vu(e, t, r) {
  for (var n = me, o = 0, l = t.length; o < l; o++) {
    var i = t.charAt(o);
    i === pr ? n += e : i === Wn || i === Yn ? n += r : n += i;
  }
  return n;
}
function gu(e, t) {
  var r = e.numbers.currency, n = t !== 1 ? r["unitPattern-count-other"] : r["unitPattern-count-one"];
  return t < 0 && (n = n.replace(pr, "-" + pr)), n;
}
function yu(e, t, r) {
  var n = r.numbers.symbols, o = t.style, l = xl(o);
  if (o === Sl) {
    var i = t.minimumFractionDigits !== void 0 ? e.toExponential(t.minimumFractionDigits) : e.toExponential();
    return i.replace(vr, n.decimal);
  }
  var s = e, c;
  l && (t.value = s, c = Il(r, t)), o === Ar && (s *= 100, c = n.percentSign);
  var u = pu(t), d = u.minimumFractionDigits, m = u.maximumFractionDigits;
  s = fr(s, m);
  var p = s < 0, f = wl(e), h = s.split(vr), y = h[0], k = Ne(h[1] ? h[1].replace(fu, me) : me, d, !0);
  p && (y = y.substring(1)), t.minimumIntegerDigits && (y = Ne(y, t.minimumIntegerDigits));
  var M = t.useGrouping !== !1 ? Rl(y, 0, y.length, t, r) : y;
  k && (M += n.decimal + k);
  var I;
  if (l && t.currencyDisplay === "name")
    I = gu(r, e);
  else {
    var D = t.patterns;
    I = p || f ? D[1] || "-" + D[0] : D[0];
  }
  if (I === pr && !p)
    return M;
  var x = vu(M, I, c);
  return x;
}
var hu = /(\\.)|(['][^']*[']?)|(["][^"]*["]?)/g, Nl = "__??__";
function Eu(e, t) {
  var r = e.format;
  r.indexOf(Yn) !== -1 && (e.style = Ar, e.symbol = t.numbers.symbols.percentSign, e.number *= 100), r.indexOf(Wn) !== -1 && (e.style = ia, e.symbol = Il(t));
}
function Du(e) {
  var t = e.format;
  if (t.indexOf("'") > -1 || t.indexOf('"') > -1 || t.indexOf("\\") > -1) {
    var r = e.literals = [];
    e.format = t.replace(hu, function(n) {
      var o = n.charAt(0).replace("\\", me), l = n.slice(1).replace(o, me);
      return r.push(l), Nl;
    });
  }
}
function Cu(e, t) {
  var r = e;
  if (t)
    for (var n = t.length, o = 0; o < n; o++)
      r = r.replace(Nl, t[o]);
  return r;
}
var gr = "#", yr = "0", Tu = /(\.(?:[0-9]*[1-9])?)0+$/g, ku = /\.$/, bu = /\,/g;
function Su(e, t) {
  var r;
  return t === 0 ? r = Tu : r = new RegExp("(\\.[0-9]{" + t + "}[1-9]*)0+$", "g"), e.replace(r, "$1").replace(ku, me);
}
function Mu(e) {
  var t = e.number, r = e.format, n = r.indexOf(vr);
  if (n !== -1) {
    var o = r.lastIndexOf(yr) - n, l = r.lastIndexOf(gr) - n, i = o > -1, s = l > -1, c = t.toString().split("e");
    c[1] ? c = fr(t, Math.abs(c[1])) : c = c[0], c = c.split(vr)[1] || me;
    var u = c.length, d = -1;
    !i && !s ? (e.format = r.substring(0, n) + r.substring(n + 1), n = -1, u = 0) : i && o > l ? u = o : l > o && (s && u > l ? u = l : i && u < o && (u = o), d = i ? o : 0), u > -1 && (t = fr(t, u), d > -1 && (t = Su(t, d)));
  } else
    t = fr(t);
  e.negative && t * -1 >= 0 && !e.negativeZero && (e.negative = !1), e.number = t, e.decimalIndex = n;
}
function wu(e) {
  return e.indexOf(gr) === -1 && e.indexOf(yr) === -1;
}
function Iu(e) {
  var t = e.number, r = e.format;
  if (r = r.split(Pc), (e.negative || e.negativeZero) && r[1])
    r = r[1], e.hasNegativeFormat = !0;
  else if (t === 0) {
    var n = r[2];
    r = n || r[0], n && wu(n) && (e.constant = n);
  } else
    r = r[0];
  e.format = r;
}
function Ru(e) {
  e.hasGroup = e.format.indexOf(Wc) > -1, e.hasGroup && (e.format = e.format.replace(bu, me));
}
function Yo(e, t, r) {
  var n;
  return e === -1 && t !== -1 ? n = t : e !== -1 && t === -1 ? n = e : n = r ? Math.min(e, t) : Math.max(e, t), n;
}
function xu(e) {
  var t = e.format, r = t.indexOf(gr), n = t.indexOf(yr), o = Yo(r, n, !0);
  r = t.lastIndexOf(gr), n = t.lastIndexOf(yr);
  var l = Yo(r, n);
  o === t.length && (l = o), e.start = o, e.end = l, e.lastZeroIndex = n;
}
function Nu(e, t, r) {
  var n = e;
  if (t === ia || t === Ar) {
    n = me;
    for (var o = 0, l = e.length; o < l; o++) {
      var i = e.charAt(o);
      n += i === Wn || i === Yn ? r : i;
    }
  }
  return n;
}
function Au(e, t) {
  var r = e.start, n = e.end, o = e.negative, l = e.negativeZero, i = e.format, s = e.decimalIndex, c = e.lastZeroIndex, u = e.hasNegativeFormat, d = e.hasGroup, m = e.number, p = m.toString().split(vr), f = i.length, h = p[0], y = p[1] || me, k = h.length, M = me;
  m = i.substring(0, r), (o || l) && !u && (m += "-");
  for (var I = r; I < f; I++) {
    var D = i.charAt(I);
    if (s === -1) {
      if (n - I < k) {
        m += h;
        break;
      }
    } else if (c !== -1 && c < I && (M = me), s - I <= k && s - I > -1 && (m += h, I = s), s === I) {
      m += (y ? t.numbers.symbols.decimal : me) + y, I += n - s + 1;
      continue;
    }
    D === yr ? (m += D, M = D) : D === gr && (m += M);
  }
  return d && (m = Rl(m, r + (o && !u ? 1 : 0), Math.max(n, k + r), t.numbers.decimal, t)), n >= r && (m += i.substring(n + 1)), m;
}
function _u(e, t) {
  var r = e.number;
  return e.start !== -1 && (r = Au(e, t), r = Nu(r, e.style, e.symbol), r = Cu(r, e.literals)), r;
}
function Fu(e, t, r) {
  var n = {
    negative: e < 0,
    number: Math.abs(e),
    negativeZero: wl(e),
    format: t
  };
  return Iu(n), n.constant ? n.constant : (Du(n), Eu(n, r), Ru(n), Mu(n), xu(n), _u(n, r));
}
var zu = /^(n|c|p|e|a)(\d*)$/i;
function Uu(e) {
  var t = zu.exec(e);
  if (t) {
    var r = {
      style: kl
    }, n = t[1].toLowerCase();
    return n === "c" ? r.style = ia : n === "a" ? r.style = bl : n === "p" ? r.style = Ar : n === "e" && (r.style = Sl), t[2] && (r.minimumFractionDigits = r.maximumFractionDigits = parseInt(t[2], 10)), r;
  }
}
function Ou(e) {
  var t;
  return Hn(e) ? t = Uu(e) : t = e, t;
}
function Lu(e, t, r) {
  if (t === void 0 && (t = pr), r === void 0 && (r = $n), e == null)
    return me;
  if (!isFinite(e))
    return String(e);
  var n = la(r), o = Ou(t), l;
  if (o) {
    var i = o.style || kl;
    l = yu(e, Object.assign({}, n.numbers[i], o), n);
  } else
    l = Fu(e, t, n);
  return l;
}
function Hu(e) {
  return typeof e == "number";
}
var Pu = /\{(\d+)}/g;
function Gn(e) {
  var t = arguments;
  return e.replace(Pu, function(r, n) {
    var o = t[parseInt(n, 10) + 1];
    return o;
  });
}
var Wu = 120, Yu = 20, $o = [2, 1, 5, 3, 4], $u = -2, Gu = -1, Bu = 1, Ku = 2, _r = {};
_r[$u.toString()] = 8;
_r[Gu.toString()] = 6;
_r[Ku.toString()] = 6;
_r[Bu.toString()] = 3;
var Vu = {
  numeric: 1,
  "2-digit": 2,
  short: 3,
  long: 4,
  narrow: 5
}, qu = /[hHmsSzZoOvVxX]/;
function Zu(e) {
  return e.hour12 ? "h" : "H";
}
var Go = [{
  key: "era",
  specifier: "G"
}, {
  key: "year",
  specifier: "y"
}, {
  key: "month",
  specifier: "M"
}, {
  key: "day",
  specifier: "d"
}, {
  key: "weekday",
  specifier: "E"
}, {
  key: "hour",
  getSpecifier: Zu
}, {
  key: "minute",
  specifier: "m"
}, {
  key: "second",
  specifier: "s"
}, {
  key: "timeZoneName",
  specifier: "z"
}], Bo = {
  e: "c",
  E: "c",
  M: "L",
  Q: "q"
}, xa = {}, er = {};
function Na(e) {
  return xa[e] || (xa[e] = new RegExp(e + "+")), xa[e];
}
function Zr(e) {
  for (var t = [], r = e.charAt(0), n = r, o = 1; o < e.length; o++) {
    var l = e.charAt(o);
    l === n ? r += l : (t.push(r), r = n = l);
  }
  return t.push(r), t;
}
function Aa(e, t) {
  var r = e.length, n = -Number.MAX_VALUE, o, l;
  for (var i in t) {
    for (var s = [], c = i.replace("v", "z"), u = 0, d = 0; d < r; d++) {
      var m = e[d], p = Na(m[0]), f = (p.exec(c) || [])[0];
      if (!f)
        u -= Wu;
      else if (c = c.replace(f, me), f.length !== m.length) {
        var h = Math.max(Math.min($o[f.length] - $o[m.length], 2), -2);
        u -= _r[h];
      }
      if (s.push(f), u < n)
        break;
    }
    c.length && (u -= Zr(c).length * Yu), u > n && (n = u, o = s, l = t[i]);
  }
  l = l.replace("v", "z");
  for (var y = 0; y < r; y++) {
    var k = o[y];
    if (k && k !== e[y]) {
      var M = o[y][0];
      l = l.replace(Na(M), e[y]), Bo[M] && (l = l.replace(Na(Bo[M]), e[y]));
    }
  }
  return l;
}
function Xu(e, t, r) {
  er[r] || (er[r] = {}), er[r][e] = t;
}
function ju(e, t) {
  var r = t.calendar.dateTimeFormats.availableFormats;
  if (r[e])
    return r[e];
  if (er[t.name] && er[t.name][e])
    return er[t.name][e];
  var n = e.search(qu), o;
  if (n > 0) {
    var l = e.substr(0, n), i = e.substr(n);
    o = Gn(
      t.calendar.dateTimeFormats.short,
      //should be deterimed based on specifiers
      r[i] || Aa(Zr(i), r),
      r[l] || Aa(Zr(l), r)
    );
  } else
    o = Aa(Zr(e), r);
  return Xu(e, o, t.name), o;
}
function Ju(e) {
  for (var t = [], r = 0; r < Go.length; r++) {
    var n = Go[r], o = n.key, l = e[o];
    if (l) {
      var i = n.specifier || n.getSpecifier(e);
      t.push(i.repeat(Vu[l]));
    }
  }
  return t.join(me);
}
function Al(e, t) {
  var r = t.calendar, n;
  if (Hn(e))
    r.patterns[e] ? n = r.patterns[e] : n = e;
  else if (e) {
    if (e.pattern)
      return e.pattern;
    var o = e.skeleton;
    o || (e.datetime ? n = Gn(r.dateTimeFormats[e.datetime], r.timeFormats[e.datetime], r.dateFormats[e.datetime]) : e.date ? n = r.dateFormats[e.date] : e.time ? n = r.timeFormats[e.time] : o = Ju(e)), o && (n = ju(o, t));
  }
  return n || (n = r.patterns.d), n;
}
function Qu(e) {
  var t;
  return e <= 3 ? t = "abbreviated" : e === 4 ? t = "wide" : e === 5 ? t = "narrow" : e === 6 && (t = "short"), t;
}
function rt(e, t, r, n, o) {
  return Kc(e, {
    type: t,
    nameType: Qu(r),
    standAlone: n,
    lower: o
  });
}
function Ko(e) {
  return typeof e == "function";
}
function Bn(e) {
  return !!e && Ko(e.getTime) && Ko(e.getMonth);
}
var ed = /d{1,2}|E{1,6}|e{1,6}|c{3,6}|c{1}|M{1,5}|L{1,5}|y{1,4}|H{1,2}|h{1,2}|k{1,2}|K{1,2}|m{1,2}|a{1,5}|s{1,2}|S{1,3}|z{1,4}|Z{1,5}|x{1,5}|X{1,5}|G{1,5}|q{1,5}|Q{1,5}|"[^"]*"|'[^']*'/g;
function td(e, t, r) {
  var n = cu(r), o;
  return e < n ? o = 7 - n + e : o = e - n, o + 1;
}
function _l(e, t, r, n) {
  return t <= 2 ? Ne(e + 1, t) : rt(r, "months", t, n)[e];
}
function Fl(e, t, r, n) {
  var o = Math.floor(e.getMonth() / 3);
  return t < 3 ? o + 1 : rt(r, "quarters", t, n)[o];
}
function sa(e, t, r) {
  var n = r.shortHours, o = r.optionalMinutes, l = r.separator, i = r.localizedName, s = r.zZeroOffset, c = e.getTimezoneOffset() / 60;
  if (c === 0 && s)
    return "Z";
  var u = c <= 0 ? "+" : "-", d = Math.abs(c).toString().split("."), m = d[1] || 0, p = u + (n ? d[0] : Ne(d[0], 2));
  if ((m || !o) && (p += (l ? ":" : me) + Ne(m, 2)), i) {
    var f = c === 0 ? t.calendar.gmtZeroFormat : t.calendar.gmtFormat;
    p = Gn(f, p);
  }
  return p;
}
function zl(e, t, r, n) {
  var o;
  return t < 3 ? o = td(e.getDay(), t, r) : o = rt(r, "days", t, n)[e.getDay()], o;
}
var fe = {};
fe.d = function(e, t) {
  return Ne(e.getDate(), t);
};
fe.E = function(e, t, r) {
  return rt(r, "days", t)[e.getDay()];
};
fe.M = function(e, t, r) {
  return _l(e.getMonth(), t, r, !1);
};
fe.L = function(e, t, r) {
  return _l(e.getMonth(), t, r, !0);
};
fe.y = function(e, t) {
  var r = e.getFullYear();
  return t === 2 && (r = r % 100), Ne(r, t);
};
fe.h = function(e, t) {
  var r = e.getHours() % 12 || 12;
  return Ne(r, t);
};
fe.H = function(e, t) {
  return Ne(e.getHours(), t);
};
fe.k = function(e, t) {
  return Ne(e.getHours() || 24, t);
};
fe.K = function(e, t) {
  return Ne(e.getHours() % 12, t);
};
fe.m = function(e, t) {
  return Ne(e.getMinutes(), t);
};
fe.s = function(e, t) {
  return Ne(e.getSeconds(), t);
};
fe.S = function(e, t) {
  var r = e.getMilliseconds(), n;
  return r !== 0 ? n = Ne(String(r / 1e3).split(".")[1].substr(0, t), t, !0) : n = Ne(me, t), n;
};
fe.a = function(e, t, r) {
  return rt(r, "dayPeriods", t)[e.getHours() < 12 ? "am" : "pm"];
};
fe.z = function(e, t, r) {
  return sa(e, r, {
    shortHours: t < 4,
    optionalMinutes: t < 4,
    separator: !0,
    localizedName: !0
  });
};
fe.Z = function(e, t, r) {
  return sa(e, r, {
    separator: t > 3,
    localizedName: t === 4,
    zZeroOffset: t === 5
  });
};
fe.x = function(e, t, r) {
  return sa(e, r, {
    optionalMinutes: t === 1,
    separator: t === 3 || t === 5
  });
};
fe.X = function(e, t, r) {
  return sa(e, r, {
    optionalMinutes: t === 1,
    separator: t === 3 || t === 5,
    zZeroOffset: !0
  });
};
fe.G = function(e, t, r) {
  var n = e.getFullYear() >= 0 ? 1 : 0;
  return rt(r, "eras", t)[n];
};
fe.e = zl;
fe.c = function(e, t, r) {
  return zl(e, t, r, !0);
};
fe.q = function(e, t, r) {
  return Fl(e, t, r, !0);
};
fe.Q = Fl;
function Ul(e, t, r) {
  if (r === void 0 && (r = $n), !Bn(e))
    return e ?? me;
  var n = la(r), o = Al(t, n);
  return o.replace(ed, function(l) {
    var i = l.length, s;
    return l.includes("'") || l.includes('"') ? s = l.slice(1, i - 1) : s = fe[l[0]](e, i, n), s;
  });
}
function Vo(e, t, r) {
  var n = e.getTimezoneOffset(), o = new Date(e.getTime() + (t - r) * 6e4), l = o.getTimezoneOffset();
  return new Date(o.getTime() + (l - n) * 6e4);
}
function rd(e, t) {
  !t && e.getHours() === 23 && e.setHours(e.getHours() + 2);
}
var ad = /([+|\-]\d{1,2})(:?)(\d{2})?/, nd = /^\/Date\((.*?)\)\/$/, od = /[+-]\d*/, ld = {
  2: /^\d{1,2}/,
  3: /^\d{1,3}/,
  4: /^\d{4}/
}, id = /\d+/, qo = "{0}", sd = /^ */, cd = / *$/, ud = [
  "yyyy/MM/dd HH:mm:ss",
  "yyyy/MM/dd HH:mm",
  "yyyy/MM/dd",
  "E MMM dd yyyy HH:mm:ss",
  "yyyy-MM-ddTHH:mm:ss.SSSSSSSXXX",
  "yyyy-MM-ddTHH:mm:ss.SSSXXX",
  "yyyy-MM-ddTHH:mm:ss.SSXXX",
  "yyyy-MM-ddTHH:mm:ssXXX",
  "yyyy-MM-ddTHH:mm:ss.SSSSSSS",
  "yyyy-MM-ddTHH:mm:ss.SSS",
  "yyyy-MM-ddTHH:mmXXX",
  "yyyy-MM-ddTHH:mmX",
  "yyyy-MM-ddTHH:mm:ss",
  "yyyy-MM-ddTHH:mm",
  "yyyy-MM-dd HH:mm:ss",
  "yyyy-MM-dd HH:mm",
  "yyyy-MM-dd",
  "HH:mm:ss",
  "HH:mm"
], Zo = ["G", "g", "F", "Y", "y", "M", "m", "D", "d", "y", "T", "t"], dd = 2029;
function Je(e, t, r) {
  return !(e >= t && e <= r);
}
function Se(e, t) {
  for (var r = t.format, n = t.idx, o = 0; r[n] === e; )
    o++, n++;
  return o > 0 && (n -= 1), t.idx = n, o;
}
function mt(e, t) {
  var r = e ? ld[e] || new RegExp("^\\d{1," + e + "}") : id, n = t.value.substr(t.valueIdx, e).match(r);
  return n ? (n = n[0], t.valueIdx += n.length, parseInt(n, 10)) : null;
}
function Yt(e, t, r) {
  for (var n = 0, o = e.length, l, i, s = 0, c = 0, u; n < o; n++)
    l = e[n], i = l.length, u = t.value.substr(t.valueIdx, i), r && (u = u.toLowerCase()), u === l && i > s && (s = i, c = n);
  return s ? (t.valueIdx += s, c + 1) : null;
}
function _a(e) {
  var t = !1;
  return e.value.charAt(e.valueIdx) === e.format[e.idx] && (e.valueIdx++, t = !0), t;
}
function md(e) {
  var t = e.gmtFormat, r = e.gmtZeroFormat;
  if (!t)
    throw dt.NoGMTInfo.error();
  return [t.replace(qo, me).toLowerCase(), r.replace(qo, me).toLowerCase()];
}
function ca(e, t, r) {
  var n = r.shortHours, o = r.noSeparator, l = r.optionalMinutes, i = r.localizedName, s = r.zLiteral;
  if (e.UTC = !0, s && e.value.charAt(e.valueIdx) === "Z")
    return e.valueIdx++, !1;
  if (i && !Yt(md(t.calendar), e, !0))
    return !0;
  var c = ad.exec(e.value.substr(e.valueIdx, 6));
  if (!c)
    return !i;
  var u = c[1], d = c[3], m = parseInt(u, 10), p = c[2], f = parseInt(d, 10);
  if (isNaN(m) || !n && u.length !== 3 || !l && isNaN(f) || o && p || (isNaN(f) && (f = null), Je(m, -12, 13) || f && Je(f, 0, 59)))
    return !0;
  e.valueIdx += c[0].length, e.hoursOffset = m, e.minutesOffset = f;
}
function Ol(e, t, r) {
  var n = Se(e, t), o = rt(r, "months", n, e === "L", !0), l = n < 3 ? mt(2, t) : Yt(o, t, !0);
  if (l === null || Je(l, 1, 12))
    return !0;
  t.month = l - 1;
}
function Ll(e, t, r) {
  var n = Se(e, t), o = rt(r, "days", n, e === "c", !0), l = n < 3 ? mt(1, t) : Yt(o, t, !0);
  if (!l && l !== 0 || Je(l, 1, 7))
    return !0;
}
var ge = {};
ge.d = function(e) {
  Se("d", e);
  var t = mt(2, e);
  if (t === null || Je(t, 1, 31))
    return !0;
  e.day === null && (e.day = t);
};
ge.E = function(e, t) {
  var r = Se("E", e), n = Yt(rt(t, "days", r, !1, !0), e, !0);
  if (n === null)
    return !0;
};
ge.M = function(e, t) {
  return Ol("M", e, t);
};
ge.L = function(e, t) {
  return Ol("L", e, t);
};
ge.y = function(e) {
  var t = Se("y", e), r = mt(t === 1 ? void 0 : t, e);
  if (r === null)
    return !0;
  if (t === 2) {
    var n = (/* @__PURE__ */ new Date()).getFullYear();
    r = n - n % 100 + r, r > dd && (r -= 100);
  }
  e.year = r;
};
ge.h = function(e) {
  Se("h", e);
  var t = mt(2, e);
  if (t === 12 && (t = 0), t === null || Je(t, 0, 11))
    return !0;
  e.hours = t;
};
ge.K = function(e) {
  Se("K", e);
  var t = mt(2, e);
  if (t === null || Je(t, 0, 11))
    return !0;
  e.hours = t;
};
ge.a = function(e, t) {
  var r = Se("a", e), n = rt(t, "dayPeriods", r, !1, !0), o = Yt([n.pm], e, !0);
  if (!o && !Yt([n.am], e, !0))
    return !0;
  e.pmHour = o;
};
ge.H = function(e) {
  Se("H", e);
  var t = mt(2, e);
  if (t === null || Je(t, 0, 23))
    return !0;
  e.hours = t;
};
ge.k = function(e) {
  Se("k", e);
  var t = mt(2, e);
  if (t === null || Je(t, 1, 24))
    return !0;
  e.hours = t === 24 ? 0 : t;
};
ge.m = function(e) {
  Se("m", e);
  var t = mt(2, e);
  if (t === null || Je(t, 0, 59))
    return !0;
  e.minutes = t;
};
ge.s = function(e) {
  Se("s", e);
  var t = mt(2, e);
  if (t === null || Je(t, 0, 59))
    return !0;
  e.seconds = t;
};
ge.S = function(e) {
  var t = Se("S", e), r = e.value.substr(e.valueIdx, t), n = null;
  if (isNaN(parseInt(r, 10)) || (n = parseFloat("0." + r, 10), n = fr(n, 3), n *= 1e3, e.valueIdx += t), n === null || Je(n, 0, 999))
    return !0;
  e.milliseconds = n;
};
ge.z = function(e, t) {
  var r = Se("z", e), n = r < 4, o = ca(e, t, {
    shortHours: n,
    optionalMinutes: n,
    localizedName: !0
  });
  if (o)
    return o;
};
ge.Z = function(e, t) {
  var r = Se("Z", e), n = ca(e, t, {
    noSeparator: r < 4,
    zLiteral: r === 5,
    localizedName: r === 4
  });
  if (n)
    return n;
};
ge.x = function(e, t) {
  var r = Se("x", e), n = ca(e, t, {
    noSeparator: r !== 3 && r !== 5,
    optionalMinutes: r === 1
  });
  if (n)
    return n;
};
ge.X = function(e, t) {
  var r = Se("X", e), n = ca(e, t, {
    noSeparator: r !== 3 && r !== 5,
    optionalMinutes: r === 1,
    zLiteral: !0
  });
  if (n)
    return n;
};
ge.G = function(e, t) {
  var r = Se("G", e), n = rt(t, "eras", r, !1, !0), o = Yt([n[0], n[1]], e, !0);
  if (o === null)
    return !0;
};
ge.e = function(e, t) {
  return Ll("e", e, t);
};
ge.c = function(e, t) {
  return Ll("c", e, t);
};
function fd(e) {
  var t = e.year, r = e.month, n = e.day, o = e.hours, l = e.minutes, i = e.seconds, s = e.milliseconds, c = e.pmHour, u = e.UTC, d = e.hoursOffset, m = e.minutesOffset, p = o !== null || l !== null || i || null, f = /* @__PURE__ */ new Date(), h;
  return t === null && r === null && n === null && p ? (t = f.getFullYear(), r = f.getMonth(), n = f.getDate()) : (t === null && (t = f.getFullYear()), n === null && (n = 1)), c && o < 12 && (o += 12), u ? (d && (o += -d), m && (l += -m * (d < 0 ? -1 : 1)), h = new Date(Date.UTC(t, r, n, o, l, i, s))) : (h = new Date(t, r, n, o, l, i, s), rd(h, o)), t < 100 && h.setFullYear(t), h.getDate() !== n && u === void 0 ? null : h;
}
function pd(e, t) {
  var r = sd.exec(t)[0], n = cd.exec(t)[0];
  return "" + r + e + n;
}
function vd(e, t, r) {
  for (var n = Al(t, r).split(me), o = {
    format: n,
    idx: 0,
    value: pd(e, t),
    valueIdx: 0,
    year: null,
    month: null,
    day: null,
    hours: null,
    minutes: null,
    seconds: null,
    milliseconds: null
  }, l = n.length, i = !1; o.idx < l; o.idx++) {
    var s = n[o.idx];
    if (i)
      s === "'" && (i = !1), _a(o);
    else if (ge[s]) {
      var c = ge[s](o, r);
      if (c)
        return null;
    } else if (s === "'")
      i = !0, _a(o);
    else if (!_a(o))
      return null;
  }
  return o.valueIdx < e.length ? null : fd(o) || null;
}
function gd(e) {
  var t = e.substr(0, 1) === "-" ? -1 : 1, r = e.substring(1);
  return r = parseInt(r.substr(0, 2), 10) * 60 + parseInt(r.substring(2), 10), t * r;
}
function yd(e) {
  if (e && e.indexOf("/D") === 0) {
    var t = nd.exec(e);
    if (t) {
      t = t[1];
      var r = od.exec(t.substring(1));
      return t = new Date(parseInt(t, 10)), r && (r = gd(r[0]), t = Vo(t, t.getTimezoneOffset(), 0), t = Vo(t, 0, -1 * r)), t;
    }
  }
}
function hd(e) {
  for (var t = [], r = e.patterns, n = Zo.length, o = 0; o < n; o++)
    t.push(r[Zo[o]]);
  return t.concat(ud);
}
function Xo(e, t, r) {
  if (r === void 0 && (r = $n), !e)
    return null;
  if (Bn(e))
    return e;
  var n = String(e).trim(), o = yd(n);
  if (o)
    return o;
  var l = la(r), i = t || hd(l.calendar);
  i = Array.isArray(i) ? i : [i];
  for (var s = i.length, c = 0; c < s; c++)
    if (o = vd(n, i[c], l), o)
      return o;
  return o;
}
function Ed(e, t, r) {
  if (t) {
    if (Bn(e))
      return Ul(e, t, r);
    if (Hu(e))
      return Lu(e, t, r);
  }
  return e ?? me;
}
var Fa = function(e) {
  if (!e || e.length === 0)
    return "";
  var t = e[0].timezone, r = t === "Etc/UTC", n = r ? "Z" : "", o = e.map(function(i) {
    return Ul(i, "yyyyMMddTHHmmss") + n;
  }), l = t && !r ? ";TZID=" + t : "";
  return l + ":" + o.join(",") + " ";
}, Dd = function(e, t) {
  return t.getTime() - e.getTime();
}, Cd = function(e, t) {
  if (!t)
    return !1;
  var r = t.start, n = t.end;
  return e < r || e > n || e === 0 && r < 0;
}, Td = function(e, t) {
  return e - t;
}, bt = function(e, t) {
  for (var r = [], n = 0; n < e.length; n++) {
    var o = parseInt(e[n], 10);
    if (isNaN(o) || Cd(o, t))
      return [];
    r.push(o);
  }
  return r.sort(Td);
}, kd = [
  "yyyyMMddTHHmmssSSSXXX",
  "yyyyMMddTHHmmssXXX",
  "yyyyMMddTHHmmss",
  "yyyyMMddTHHmm",
  "yyyyMMddTHH",
  "yyyyMMdd"
];
function Hl(e) {
  return new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
}
var Pl = function(e, t) {
  var r = Xo(e) || Xo(e, kd);
  if (!r)
    return null;
  var n = t ? Hl(r) : r;
  return j.fromUTCDate(n, t || "Etc/UTC");
}, bd = {
  SU: ke.Sunday,
  MO: ke.Monday,
  TU: ke.Tuesday,
  WE: ke.Wednesday,
  TH: ke.Thursday,
  FR: ke.Friday,
  SA: ke.Saturday
}, Wl = function(e) {
  return bd[e];
}, Sd = function(e) {
  for (var t = [], r = 0; r < e.length; r++) {
    var n = e[r], o = Wl(n.substring(n.length - 2).toUpperCase());
    if (o === void 0)
      return [];
    t.push({
      offset: parseInt(n.substring(0, n.length - 2), 10) || 0,
      day: o
    });
  }
  return t;
}, wt = function(e, t, r) {
  r === void 0 && (r = 1), t = (t - e.getUTCDay() + 7 * r) % 7, e.setUTCDate(e.getUTCDate() + t);
}, Ht = function(e, t) {
  return e + (e < t ? 7 : 0);
}, Kn = function(e, t) {
  return e - t;
}, tr = function(e, t) {
  var r = Hl(gl(e)).getUTCDay(), n = 7 - (r + 7 - (t || 7)) || 7;
  return n < 0 && (n += 7), Math.ceil((e.getUTCDate() - n) / 7) + 1;
}, Md = function(e, t) {
  e = new Date(Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()));
  var r = e.getUTCFullYear();
  t !== void 0 ? (wt(e, t, -1), e.setUTCDate(e.getUTCDate() + 4)) : e.setUTCDate(e.getUTCDate() + (4 - (e.getUTCDay() || 7)));
  var n = Math.floor((e.getTime() - Date.UTC(r, 0, 1, -6)) / 864e5);
  return 1 + Math.floor(n / 7);
}, Yl = function(e, t, r) {
  var n = t.offset;
  if (!n)
    return tr(e, r);
  var o = new Date(Date.UTC(e.getUTCFullYear(), e.getUTCMonth() + 1, 0)), l = tr(o, r), i = Ht(t.day, r), s = i < Ht(new Date(Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), 1)).getUTCDay(), r), c = i > Ht(o.getUTCDay(), r);
  return n < 0 ? n = l + (n + 1 - (c ? 1 : 0)) : s && (n += 1), l -= c ? 1 : 0, n < (s ? 1 : 0) || n > l ? null : n;
}, wd = function(e, t, r) {
  return tr(e, r) === Yl(e, t, r);
}, Id = function(e, t) {
  return tr(new Date(Date.UTC(e.getUTCFullYear(), e.getUTCMonth() + 1, 0)), t);
}, Rd = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366], xd = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365], $l = function(e) {
  return e = e.getUTCFullYear(), e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}, Nd = function(e) {
  var t = e.getUTCMonth(), r = $l(e) ? Rd[t] : xd[t];
  return r + e.getUTCDate();
}, Ad = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], _d = function(e) {
  var t = e.getUTCMonth();
  return t === 1 ? new Date(Date.UTC(e.getUTCFullYear(), 1, 29)).getUTCMonth() === 1 ? 29 : 28 : Ad[t];
}, Kt = function(e, t, r) {
  for (var n = e.length, o = [], l = 0; l < n; l++) {
    var i = e[l];
    if (r && (i = r(i)), t === i)
      return null;
    t < i && o.push(i);
  }
  return o;
}, Fd = function(e, t, r) {
  for (var n = Ht(t.getUTCDay(), r), o = e.length, l, i, s, c, u = [], d = 0; d < o; d++)
    if (i = e[d], c = tr(t, r), l = Yl(t, i, r), l !== null) {
      if (c < l)
        u.push(i);
      else if (c === l) {
        if (s = Ht(i.day, r), n < s)
          u.push(i);
        else if (n === s)
          return null;
      }
    }
  return u;
}, zd = function(e, t, r) {
  var n = r.byMonth, o = Kt(n, e.getUTCMonth() + 1), l = !1;
  return o !== null && (o.length ? e.setUTCMonth(o[0] - 1, 1) : e.setUTCFullYear(e.getUTCFullYear() + 1, n[0] - 1, 1), l = !0), l;
}, Ud = function(e, t, r) {
  var n, o = !1;
  function l(c) {
    return c < 0 && (c = n + c + 1), c;
  }
  for (; e <= t; ) {
    var i = e.getUTCMonth();
    n = _d(e);
    var s = Kt(r.byMonthDay, e.getUTCDate(), l);
    if (s === null)
      return o;
    if (o = !0, s.length) {
      if (e.setUTCMonth(i, s.sort(Kn)[0]), i === e.getUTCMonth())
        break;
    } else
      e.setUTCMonth(i + 1, 1);
  }
  return o;
}, Od = function(e, t, r) {
  var n, o = !1;
  function l(s) {
    return s < 0 && (s = n + s), s;
  }
  for (; e < t; ) {
    n = $l(e) ? 366 : 365;
    var i = Kt(r.byYearDay, Nd(e), l);
    if (i === null)
      return o;
    if (o = !0, n = e.getUTCFullYear(), i.length) {
      e.setUTCFullYear(n, 0, i.sort(Kn)[0]);
      break;
    } else
      e.setUTCFullYear(n + 1, 0, 1);
  }
  return o;
}, Ld = function(e, t, r) {
  var n = r.weekStart || ke.Monday, o = !1;
  function l(u) {
    return u < 0 && (u = 53 + u), u;
  }
  for (; e < t; ) {
    var i = Kt(r.byWeekNumber, Md(e, n), l);
    if (i === null)
      return o;
    o = !0;
    var s = e.getUTCFullYear();
    if (i.length) {
      var c = i.sort(Kn)[0] * 7 - 1;
      e.setUTCFullYear(s, 0, c), wt(e, n, -1);
      break;
    } else
      e.setUTCFullYear(s + 1, 0, 1);
  }
  return o;
}, Hd = function(e, t, r) {
  var n = r.byWeekDay, o = r.weekStart || ke.Monday, l = Fd(n, e, o);
  if (l === null)
    return !1;
  l[0] || (l = n, wt(e, o));
  var i = l.map(function(c) {
    var u = Qt(e), d = c.day;
    if (c.offset)
      for (; u <= t && !wd(u, c, o); )
        tr(u, o) === Id(u, o) ? u.setUTCMonth(u.getUTCMonth() + 1, 1) : (u.setUTCDate(u.getUTCDate() + 7), wt(u, o, -1));
    return u.getUTCDay() !== d && wt(u, d), u;
  }).sort(function(c, u) {
    return c.getTime() - u.getTime();
  }), s = i[0];
  return s && e.setTime(s), !0;
}, Pd = function(e, t, r) {
  var n = r.byHour, o = !1, l = r._startTime, i = l.getUTCHours(), s = Kt(n, i);
  return s !== null && (o = !0, e.setUTCHours(i), s.length ? (s = s[0], e.setUTCHours(s)) : (s = e.getUTCHours(), e.setUTCDate(e.getUTCDate() + 1), s = n[0], e.setUTCHours(s)), r.byMinute && e.setUTCMinutes(0), l.setUTCHours(s, e.getUTCMinutes())), o;
}, Wd = function(e, t, r) {
  var n = r.byMinute, o = e.getUTCMinutes(), l = Kt(n, o), i = r._startTime.getUTCHours(), s = !1;
  return l !== null && (s = !0, l.length ? l = l[0] : (i += 1, l = n[0]), r.bySecond && e.setUTCSeconds(0), e.setUTCHours(i, l), i = i % 24, r._startTime.setUTCHours(i, l, e.getUTCSeconds())), s;
}, Yd = function(e, t, r) {
  var n = r.bySecond, o = Kt(n, e.getUTCSeconds()), l = r._startTime.getUTCHours(), i = e.getUTCMinutes(), s = !1;
  return o !== null && (s = !0, o.length ? e.setUTCSeconds(o[0]) : (i += 1, e.setUTCMinutes(i, n[0]), i > 59 && (i = i % 60, l = (l + 1) % 24)), r._startTime.setUTCHours(l, i, e.getUTCSeconds())), s;
};
const $d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  byHour: Pd,
  byMinute: Wd,
  byMonth: zd,
  byMonthDay: Ud,
  bySecond: Yd,
  byWeekDay: Hd,
  byWeekNumber: Ld,
  byYearDay: Od
}, Symbol.toStringTag, { value: "Module" }));
var Gl = ["byMonth", "byWeekNumber", "byYearDay", "byMonthDay", "byWeekDay", "byHour", "byMinute", "bySecond"], jo = Gl.length, dr = function(e, t) {
  var r;
  return e !== 0 && e < t ? r = t - e : (r = e % t, r && (r = t - r)), r;
}, Gd = function(e, t) {
  e.setTime(e.getTime() + t);
}, $t = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.next = function(t, r) {
      var n = r._startTime, o, l;
      if (r.bySecond)
        l = t.getUTCSeconds() + 1, t.setUTCSeconds(l), n.setUTCSeconds(l);
      else if (r.byMinute)
        o = t.getUTCMinutes() + 1, t.setUTCMinutes(o), n.setUTCMinutes(o);
      else
        return !1;
      return !0;
    }, e.prototype.normalize = function(t) {
      var r = t.rule;
      t.idx === 4 && r.byHour && (r._startTime.setUTCHours(0), this._hour(t.date, r));
    }, e.prototype.limit = function(t, r, n) {
      for (var o = n.interval || 1, l; t <= r; ) {
        var i = void 0, s = void 0, c = t.getUTCDate();
        for (l = 0; l < jo; l++) {
          var u = Gl[l];
          if (n[u]) {
            if (i = $d[u](t, r, n), s !== void 0 && i)
              break;
            s = i;
          }
          i && this.normalize({ date: t, rule: n, day: c, idx: l });
        }
        if ((o === 1 || !this.interval(n, t)) && l === jo)
          break;
      }
    }, e.prototype.interval = function(t, r) {
      var n = t._startPeriod.toUTCDate(), o = r.getUTCHours(), l = t.weekStart, i = t.interval, s = t.freq, c = new Date(r), u = !1, d = 0, m = 0, p = 1, f, h;
      if (s === "hourly")
        h = t._startTime.getUTCHours(), c = c.getTime(), o !== h && (c += (h - o) * Jr), c -= n.getTime(), f = Math.floor(c / Jr), d = dr(f, i), d !== 0 && (this._hour(r, t, d), u = !0);
      else if (s === "daily")
        Gd(c, -n), f = Math.round(c / Xe), d = dr(f, i), d !== 0 && (this._date(r, t, d), u = !0);
      else if (s === "weekly") {
        d = this.getNumberOfWeeksBetweenDates(n, r);
        var y = Ht(r.getUTCDay(), l), k = Ht(n.getUTCDay(), l);
        y < k && (d += 1), d = dr(d, i), d !== 0 && (wt(r, t.weekStart, -1), r.setUTCDate(r.getUTCDate() + d * 7), u = !0);
      } else
        s === "monthly" ? (f = r.getUTCFullYear() - n.getUTCFullYear(), f = r.getUTCMonth() - n.getUTCMonth() + f * 12, d = dr(f, i), d !== 0 && (p = Cl(t) ? 1 : r.getDate(), r.setUTCFullYear(r.getUTCFullYear(), r.getUTCMonth() + d, p), u = !0)) : s === "yearly" && (f = r.getUTCFullYear() - n.getUTCFullYear(), d = dr(f, i), t.byMonth || (m = r.getUTCMonth()), !t.byYearDay && !t.byMonthDay && !t.byWeekDay && (p = r.getUTCDate()), d !== 0 && (r.setUTCFullYear(r.getUTCFullYear() + d, m, p), u = !0));
      return u;
    }, e.prototype._hour = function(t, r, n) {
      var o = r._startTime, l = o.getUTCHours();
      n && (l += n), t.setUTCHours(l), l = l % 24, o.setUTCHours(l);
    }, e.prototype._date = function(t, r, n) {
      t.setUTCDate(t.getUTCDate() + n);
    }, e.prototype.getNumberOfWeeksBetweenDates = function(t, r) {
      var n = (r.getTime() - t.getTime()) / 6048e5, o = Math.floor(n);
      return n - o > 0.99 && (o = Math.round(n)), o;
    }, e;
  }()
), Bd = (
  /** @class */
  function(e) {
    Nr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.next = function(r, n) {
      return $t.prototype.next.call(this, r, n) || this._hour(r, n, 1), !1;
    }, t.prototype.normalize = function(r) {
      var n = r.rule;
      r.idx === 4 && (n._startTime.setUTCHours(0), this._hour(r.date, n));
    }, t;
  }($t)
), Bl = (
  /** @class */
  function(e) {
    Nr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.next = function(r, n) {
      return $t.prototype.next.call(this, r, n) || this[n.byHour ? "_hour" : "_date"](r, n, 1), !1;
    }, t;
  }($t)
), Kd = (
  /** @class */
  function(e) {
    Nr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.setup = function(r, n) {
      r.byWeekDay || (r.byWeekDay = [{
        day: n.getUTCDay(),
        offset: 0
      }]);
    }, t;
  }(Bl)
), Kl = (
  /** @class */
  function(e) {
    Nr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.next = function(r, n) {
      var o;
      if (!$t.prototype.next.call(this, r, n))
        if (n.byHour)
          this._hour(r, n, 1);
        else if (n.byMonthDay || n.byWeekDay || n.byYearDay || n.byWeekNumber)
          this._date(r, n, 1);
        else {
          for (o = r.getUTCDate(), r.setUTCMonth(r.getUTCMonth() + 1); r.getUTCDate() !== o; )
            r.setUTCDate(o);
          this._hour(r, n);
        }
      return !1;
    }, t.prototype.normalize = function(r) {
      var n = r.rule, o = r.date;
      r.idx === 0 && !n.byMonthDay && !n.byWeekDay ? o.setUTCDate(r.day) : e.prototype.normalize.call(this, r);
    }, t.prototype.setup = function(r, n, o) {
      !r.byMonthDay && !r.byWeekDay && o.setUTCDate(n.getUTCDate());
    }, t;
  }($t)
), Vd = (
  /** @class */
  function(e) {
    Nr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.next = function(r, n) {
      var o;
      if (!$t.prototype.next.call(this, r, n))
        if (n.byHour)
          this._hour(r, n, 1);
        else if (n.byMonthDay || n.byWeekDay || n.byYearDay || n.byWeekNumber)
          this._date(r, n, 1);
        else if (n.byMonth) {
          for (o = r.getUTCDate(), r.setUTCMonth(r.getUTCMonth() + 1); r.getUTCDate() !== o; )
            r.setUTCDate(o);
          this._hour(r, n);
        } else
          r.setUTCFullYear(r.getUTCFullYear() + 1), this._hour(r, n);
      return !1;
    }, t.prototype.setup = function() {
    }, t;
  }(Kl)
), qd = {
  hourly: new Bd(),
  daily: new Bl(),
  weekly: new Kd(),
  monthly: new Kl(),
  yearly: new Vd()
}, za = function(e) {
  return j.fromLocalDate(e.toLocalDate(), e.timezone);
}, Kr = function(e) {
  return e.getHours() * Jr + e.getMinutes() * An + e.getSeconds() * 1e3 + e.getMilliseconds();
}, Vl = function(e, t) {
  if (!e)
    return !1;
  for (var r = t.getTime() - t.getMilliseconds(), n = e.length, o = 0; o < n; o++)
    if (e[o].getTime() === r)
      return !0;
  return !1;
}, Zd = function(e, t) {
  var r = e.toUTCDate();
  switch (t.freq) {
    case "yearly":
      r.setUTCFullYear(r.getFullYear(), 0, 1);
      break;
    case "monthly":
      r.setUTCFullYear(r.getFullYear(), r.getMonth(), 1);
      break;
    case "weekly":
      wt(r, t.weekStart, -1);
      break;
  }
  return t.byHour && r.setUTCHours(0), t.byMinute && r.setUTCMinutes(0), t.bySecond && r.setUTCSeconds(0), j.fromUTCDate(r, e.timezone);
}, Ua = function(e, t) {
  var r = e.toUTCDate();
  switch (t.freq) {
    case "yearly":
      r.setUTCFullYear(r.getUTCFullYear(), 11, 31);
      break;
    case "monthly":
      r.setUTCFullYear(r.getUTCFullYear(), r.getUTCMonth() + 1, 0);
      break;
    case "weekly":
      wt(r, t.weekStart, -1), r.setUTCDate(r.getUTCDate() + 6);
      break;
  }
  return t.byHour && r.setUTCHours(23), t.byMinute && r.setUTCMinutes(59), t.bySecond && r.setUTCSeconds(59), j.fromUTCDate(r, e.timezone);
}, Xd = function(e, t, r) {
  for (var n = e.length, o = [], l, i = 0, s = r.length; i < s; i++) {
    l = r[i], l < 0 ? l = n + l : l -= 1;
    var c = e[l];
    c && c.start >= t && o.push(c);
  }
  return o;
}, jd = function(e, t) {
  for (var r = [], n = 0; n < e.length; n++) {
    var o = e[n];
    o && !Vl(t, o.start) && r.push(o);
  }
  return r;
};
function Jd(e, t) {
  var r = t.rangeStart, n = t.rangeEnd;
  if (!e)
    return {
      success: !0,
      errorMessage: "",
      events: []
    };
  var o = e.freq, l = qd[o], i = e.start, s = Dd(e.start, e.end), c;
  if (e.start.getTime() > e.end.getTime())
    return {
      success: !1,
      errorMessage: "Invalid recurrence rule: Start date (" + e.start + ")" + ("is greater than End date " + e.start),
      events: []
    };
  if (!l)
    return {
      success: !1,
      errorMessage: 'Invalid recurrence frequency "' + o + '"',
      events: []
    };
  var u = [], d = e.bySetPosition, m = d ? 0 : 1, p = e.exceptionDates, f = r.toTimezone(i.timezone), h = f, y = n.toTimezone(i.timezone), k = e.count;
  e.until && e.until.getTime() < y.getTime() && (y = e.until.clone());
  var M = f.getHours(), I = f.getMinutes(), D = f.getSeconds(), x = o === "yearly" || o === "monthly" || o === "weekly";
  if (f.getTime() < i.getTime() || k || e.interval > 1 || x)
    f = i.clone();
  else {
    e.byHour || (M = i.getHours()), e.byMinute || (I = i.getMinutes()), e.bySecond || (D = i.getSeconds());
    var A = f.toUTCDate();
    A.setUTCHours(M, I, D, i.getMilliseconds()), f = j.fromUTCDate(A, f.timezone);
  }
  if (e._startPeriod = f.clone(), d) {
    f = Zd(f, e), y = Ua(y, e);
    var O = Kr(y) - Kr(f);
    if (O < 0) {
      var v = y.toUTCDate();
      v.setUTCHours(f.getHours(), f.getMinutes(), f.getSeconds(), f.getMilliseconds()), y = j.fromUTCDate(v, y.timezone);
    }
    e._startPeriod = f.clone(), c = Ua(f, e);
  }
  var w = Kr(f);
  e._startTime = new Date(w);
  var T = f.toUTCDate();
  for (l.setup && (l.setup(e, i, T), f = j.fromUTCDate(T, f.timezone)), T = f.toUTCDate(), l.limit(T, y.toUTCDate(), e), f = j.fromUTCDate(T, f.timezone); f <= y; ) {
    var R = f.addTime(s), F = f >= h || R > h;
    if ((F && !Vl(p, f) || d) && (u.push({
      start: za(f),
      end: za(R)
    }), (o === "hourly" || o === "minutely" || o === "secondly") && (w = Kr(za(f)), e._startTime = new Date(w))), d) {
      if (T = f.toUTCDate(), l.next(T, e), l.limit(T, y.toUTCDate(), e), f = j.fromUTCDate(T, f.timezone), f > c) {
        var V = Xd(u.slice(m), i, d);
        V = jd(V, p), u = u.slice(0, m).concat(V), c = Ua(f, e), m = u.length;
      }
      if (k && k === m)
        break;
    } else {
      if (k && k === m)
        break;
      m += 1, T = f.toUTCDate(), l.next(T, e), l.limit(T, y.toUTCDate(), e), f = j.fromUTCDate(T, f.timezone);
    }
  }
  return {
    success: !0,
    errorMessage: "",
    events: u
  };
}
var Jo = function(e, t) {
  return e + (e < t ? 7 : 0);
}, Qd = function(e) {
  return function(t, r) {
    return Jo(t.day, e) - Jo(r.day, e);
  };
}, em = function(e) {
  var t = e.byWeekDay, r = e.weekStart;
  t && t.sort(Qd(r));
}, ql = function(e) {
  if (!e)
    return null;
  var t = e.recurrenceRule, r = e.weekStart, n = r === void 0 ? 0 : r, o = {}, l, i, s = 0, c, u, d;
  if (!t)
    return null;
  var m = t.split(`
`);
  for (!m[1] && (t.indexOf("DTSTART") !== -1 || t.indexOf("DTEND") !== -1 || t.indexOf("EXDATE") !== -1) && (m = t.split(" ")), s = 0, c = m.length; s < c; s++) {
    var p = (m[s] || "").trim();
    p.indexOf("DTSTART") !== -1 ? o.start = Ho(p) : p.indexOf("DTEND") !== -1 ? o.end = Ho(p) : p.indexOf("EXDATE") !== -1 ? o.exceptionDates = Tl(p) : p.indexOf("RRULE") !== -1 ? u = p.substring(6) : p.trim() && (u = p);
  }
  for (u = u.split(";"), s = 0, c = u.length; s < c; s++)
    switch (d = u[s], l = d.split("="), i = (l[1] || "").trim().split(","), l[0].trim().toUpperCase()) {
      case "FREQ":
        o.freq = i[0].toLowerCase();
        break;
      case "UNTIL":
        o.until = Pl(i[0]);
        break;
      case "COUNT":
        o.count = parseInt(i[0], 10);
        break;
      case "INTERVAL":
        o.interval = parseInt(i[0], 10);
        break;
      case "BYSECOND":
        o.bySecond = bt(i, { start: 0, end: 60 });
        break;
      case "BYMINUTE":
        o.byMinute = bt(i, { start: 0, end: 59 });
        break;
      case "BYHOUR":
        o.byHour = bt(i, { start: 0, end: 23 });
        break;
      case "BYMONTHDAY":
        o.byMonthDay = bt(i, { start: -31, end: 31 });
        break;
      case "BYYEARDAY":
        o.byYearDay = bt(i, { start: -366, end: 366 });
        break;
      case "BYMONTH":
        o.byMonth = bt(i, { start: 1, end: 12 });
        break;
      case "BYDAY":
        o.byWeekDay = Sd(i);
        break;
      case "BYWEEKNO":
        o.byWeekNumber = bt(i, { start: -53, end: 53 });
        break;
      case "BYSETPOS":
        o.bySetPosition = bt(i, { start: -366, end: 366 });
        break;
      case "WKST":
        o.weekStart = Wl(i[0]);
        break;
    }
  return o.freq === void 0 || o.count !== void 0 && o.until ? null : (o.weekStart === void 0 && (o.weekStart = n), o.interval || (o.interval = 1), o.bySetPosition && !Cl(o) && (o.bySetPosition = []), em(o), o);
}, Zl = {
  0: "SU",
  1: "MO",
  2: "TU",
  3: "WE",
  4: "TH",
  5: "FR",
  6: "SA"
}, tm = function(e) {
  for (var t = e.length, r = [], n, o = 0; o < t; o++) {
    var l = e[o];
    typeof l == "string" ? n = l : (n = "" + Zl[l.day], l.offset && (n = l.offset + n)), r.push(n);
  }
  return r.toString();
}, rm = function(e, t) {
  if (!e || !e.freq)
    return null;
  var r = e.weekStart, n = "FREQ=" + e.freq.toUpperCase(), o = "", l = "", i = "", s = e.until;
  return e.interval > 1 && (n += ";INTERVAL=" + e.interval), e.count && (n += ";COUNT=" + e.count), s && (n += ";UNTIL=" + Ed(s.toTimezone("Etc/UTC"), "yyyyMMddTHHmmss") + "Z"), e.byMonth && (n += ";BYMONTH=" + e.byMonth), e.byWeekNumber && (n += ";BYWEEKNO=" + e.byWeekNumber), e.byYearDay && (n += ";BYYEARDAY=" + e.byYearDay), e.byMonthDay && (n += ";BYMONTHDAY=" + e.byMonthDay), e.byWeekDay && (n += ";BYDAY=" + tm(e.byWeekDay)), e.byHour && (n += ";BYHOUR=" + e.byHour), e.byMinute && (n += ";BYMINUTE=" + e.byMinute), e.bySecond && (n += ";BYSECOND=" + e.bySecond), e.bySetPosition && (n += ";BYSETPOS=" + e.bySetPosition), r !== void 0 && (n += ";WKST=" + Zl[r]), e.start && (l = "DTSTART" + Fa([e.start])), e.end && (i = "DTEND" + Fa([e.end])), e.exceptionDates && (o = "EXDATE" + Fa(e.exceptionDates)), (l || i || o) && (n = l + i + o + "RRULE:" + n), n;
};
const Xl = (e, t = 0, r = 0, n = []) => {
  if (e.length <= t)
    return [n];
  let o = [];
  return e[t].data.map((l) => {
    o.push(
      ...Xl(
        e,
        t + 1,
        r + 1,
        [...n, {
          ...l,
          field: e[t].field,
          valueField: e[t].valueField,
          colorField: e[t].colorField,
          multiple: e[t].multiple
        }]
      )
    );
  }), o;
};
function Vn(e, t) {
  const r = [];
  if (!t || !t.length)
    return r;
  if (e && e.resources && e.resources.length) {
    const n = e.resources;
    for (let o = 0; o < n.length; o++) {
      const l = t.find((i) => i.name === n[o]);
      r.push(l);
    }
  }
  return r;
}
const jl = (e, t = e.length - 1) => {
  const r = Math.max(0, t), n = [];
  e && e.length || (e = [{}]);
  const o = (e[r].data || []).map((s) => ({ ...s, text: s[e[r].textField] })) || [], l = o.length;
  let i = 1;
  for (let s = 0; s <= r; s++)
    i *= (e[s].data || []).length || 1;
  for (let s = 0; s < i; s++)
    o[s % l] && n.push(o[s % l]);
  return n;
}, Ze = (e) => {
  if (!e)
    return { top: 0, left: 0, width: 0, height: 0, right: 0 };
  const t = e.offsetTop, r = e.offsetLeft, n = e.offsetParent ? e.offsetParent.offsetWidth - (e.offsetLeft + e.offsetWidth) : 0, o = e.offsetWidth, l = e.offsetHeight;
  return {
    top: t,
    left: r,
    right: n,
    width: o,
    height: l
  };
}, qn = (e, t = !1) => parseFloat(window.getComputedStyle(e)[t ? "paddingLeft" : "paddingTop"] || "0") + parseFloat(window.getComputedStyle(e)[t ? "paddingRight" : "paddingBottom"] || "0"), am = (e, t = !1) => parseFloat(window.getComputedStyle(e)[t ? "borderLeftWidth" : "borderTopWidth"] || "0") + parseFloat(window.getComputedStyle(e)[t ? "borderRightWidth" : "borderBottomWidth"] || "0"), rr = (e, t, r = !1) => {
  e && (t.top !== void 0 && (e.style.top = `${t.top}px`), t.left !== void 0 && (e.style.left = `${t.left}px`), t.width !== void 0 && (e.style.width = `${t.width}px`), t.height !== void 0 && !r && (e.style.height = typeof t.height == "number" ? `${t.height}px` : t.height), r && (e.style.minHeight = t.height !== void 0 && t.height > 0 ? `${t.height}px` : ""));
}, nm = 1e3, Va = 60 * nm, Re = 1, ut = 7, om = [{}], lm = {
  index: 0,
  resources: []
}, im = new Date(1900, 0, 1), sm = new Date(2099, 11, 31);
j.fromLocalDate(im), j.fromLocalDate(sm);
var Ue = /* @__PURE__ */ ((e) => (e[e.create = 0] = "create", e[e.update = 1] = "update", e[e.remove = 2] = "remove", e))(Ue || {});
const xt = (e) => e[0], hr = (e) => e[e.length - 1], cm = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((r) => {
    t.add(r.field);
  }), t.size === e.length;
};
function um(e, t, r, n) {
  const o = { skeleton: "yMMMMEEEEdhm" }, l = { skeleton: "yMMMMEEEEd" }, i = "t";
  return n ? `${e.formatDate(t, l)}` : `${e.formatDate(t, o)}–${e.formatDate(r, i)}`;
}
const dm = () => tt(/* @__PURE__ */ new Date()), ft = (e, t, r, n = 0) => {
  if (n === r)
    return null;
  let o = null;
  const l = document.elementFromPoint(e, t);
  if (!l)
    return o;
  if (l.getAttribute("data-slot") === "true")
    return l;
  {
    const i = l.style.pointerEvents;
    l.style.pointerEvents = "none", o = ft(e, t, r, n + 1), l.style.pointerEvents = i;
  }
  return o;
}, Z = (e, t) => _e(t)(e), J = (e, t, r) => {
  if (t)
    return Vs(t)(e, r);
}, gt = (e) => e != null;
function Le(e) {
  return new Date(Date.UTC(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ));
}
const St = (e, t, r) => {
  const n = Zn(e, t) ? Z(e, t.id) : Z(e, t.recurrenceId);
  return r.find((o) => Z(o, t.id) === n);
}, Zn = (e, t) => {
  const r = Z(e, t.id), n = Z(e, t.recurrenceId), o = Z(e, t.recurrenceRule);
  return !!(r && o && n == null);
}, Qo = (e, t) => Math.max(e.getTime(), t.getTime()), el = (e, t) => Math.min(e.getTime(), t.getTime()), Ye = (e, t, r, n, o = !1) => o ? Qo(t, n) - el(e, r) <= t.getTime() - e.getTime() + (n.getTime() - r.getTime()) : Qo(t, n) - el(e, r) < t.getTime() - e.getTime() + (n.getTime() - r.getTime()), Jl = {
  id: "id",
  start: "start",
  startTimezone: "startTimezone",
  originalStart: "originalStart",
  end: "end",
  endTimezone: "endTimezone",
  isAllDay: "isAllDay",
  title: "title",
  description: "description",
  recurrenceRule: "recurrenceRule",
  recurrenceId: "recurrenceId",
  recurrenceExceptions: "recurrenceExceptions"
}, mm = (e) => ({ fields: { ...Jl, ...e } }), Ve = (e, t, r) => (t.getHours() < e.getHours() || t.getHours() === e.getHours() && t.getMinutes() <= e.getMinutes()) && (e.getHours() < r.getHours() || r.getHours() === e.getHours() && e.getMinutes() < r.getMinutes()), Ql = (e, t, r) => t < r ? t <= e && e <= r : e <= r || t <= e, fm = (e, t) => {
  const r = Vn(e, t), n = Xl(r);
  return n.length === 1 ? [{
    index: 0,
    // resources: []
    resources: (t || []).reduce(
      (o, l) => [...o, ...l.data.map((i) => ({
        ...i,
        field: l.field,
        valueField: l.valueField,
        colorField: l.colorField,
        multiple: l.multiple
      }))],
      []
    )
  }] : n.map((o, l) => ({
    index: l,
    resources: o
  }));
}, pm = (e) => e == null, vm = (e) => pm(e) || e.trim && e.trim().length === 0, ei = (e) => {
  let t = 0;
  const r = e.slice();
  return r.sort((n, o) => n - o).forEach((n, o) => {
    r[o] === o && (t = o + 1);
  }), t;
}, ti = (e, t, r, n = !1) => {
  let o;
  return r.forEach((l) => {
    const i = [];
    t.sort((s, c) => s.props.start.getTime() - c.props.start.getTime()).forEach((s) => {
      if ((n || s.props.isAllDay === l.current.props.isAllDay) && s.props.range.index === l.current.props.range.index && s.props.group.index === l.current.props.group.index && Ye(s.props.start, s.props.end, l.current.props.start, l.current.props.end)) {
        const c = ei(i);
        s === e && o === void 0 && (o = c), i.splice(c, 0, c);
      }
    });
  }), o;
}, Er = (e, t, r = !1) => {
  t.forEach((n) => n.items.splice(0, n.items.length)), t.forEach((n) => {
    const o = [];
    e.forEach((l) => {
      if ((r || l.isAllDay === n.isAllDay) && l.range.index === n.range.index && l.group.index === n.group.index && Ye(l.start, l.end, n.start, n.end)) {
        const i = ei(o);
        (l.order === null || l.order === void 0 || l.order < i) && (l.order = i), o.splice(l.order, 0, l.order), n.items.push(l);
      }
    });
  });
}, Gt = (e, t, r = !1) => {
  e.forEach((n) => n.slots.splice(0, n.slots.length)), e.forEach((n) => {
    t.forEach((o) => {
      (r || n.isAllDay === o.isAllDay) && n.range.index === o.range.index && n.group.index === o.group.index && Ye(n.start, n.end, o.start, o.end) && n.slots.push(o);
    });
  });
}, ht = (...e) => {
}, gm = (e) => {
  const t = e.props.items.find((r) => r.order === 0) || e.props.items[0];
  return t && t._ref.current;
}, ea = (e, t, r = !1, n = !1) => {
  const o = e.current;
  if (!o || !t)
    return null;
  const l = t.filter((c) => c.current !== null && c.current.element !== null), i = pl(
    l,
    [
      { field: "current.props.group.index", dir: "asc" },
      { field: "current.props.range.index", dir: "asc" },
      r ? { field: "" } : { field: "current.props.isAllDay", dir: "desc" },
      { field: "current.props.start", dir: "asc" }
    ]
  ), s = i.findIndex((c) => c.current !== null && !!(c.current.props.uid === o.props.uid && (c.current.props.occurrenceId === void 0 || c.current.props.occurrenceId === o.props.occurrenceId) && c.current.props.group.index === o.props.group.index && c.current.props.range.index === o.props.range.index && (r || c.current.props.isAllDay === o.props.isAllDay)));
  return i[s + (n ? -1 : 1)];
}, ri = (e, t) => (e.order || 0) - (t.order || 0), Xn = a.createContext({ current: null }), Fr = () => a.useContext(Xn);
Xn.displayName = "SchedulerElementContext";
const ua = a.createContext({}), at = () => a.useContext(ua);
ua.displayName = "SchedulerPropsContext";
const jn = a.createContext([]), ai = () => a.useContext(jn);
jn.displayName = "SchedulerViewsContext";
const Jn = a.createContext(Jl), $e = () => a.useContext(Jn);
Jn.displayName = "SchedulerFieldsContext";
const Qn = a.createContext({ dateFormat: "{0:D}", shortDateFormat: "{0:d}" }), ym = () => a.useContext(Qn);
Qn.displayName = "SchedulerDateFormatContext";
const eo = a.createContext([lm]), Vt = () => a.useContext(eo);
eo.displayName = "SchedulerGroupsContext";
const to = a.createContext({ start: /* @__PURE__ */ new Date(), end: /* @__PURE__ */ new Date(), zonedStart: j.fromLocalDate(/* @__PURE__ */ new Date()), zonedEnd: j.fromLocalDate(/* @__PURE__ */ new Date()) }), At = () => a.useContext(to);
to.displayName = "SchedulerDateRangeContext";
const ro = a.createContext(null), ao = () => a.useContext(ro);
ro.displayName = "SchedulerOrientationContext";
const no = a.createContext([/* @__PURE__ */ new Date(), ht]), ni = () => a.useContext(no);
no.displayName = "SchedulerDateContext";
const oo = a.createContext([[], ht]), ar = () => a.useContext(oo);
oo.displayName = "SchedulerDataContext";
const lo = a.createContext(["day", ht]), io = () => a.useContext(lo);
lo.displayName = "SchedulerActiveViewContext";
const so = a.createContext([null, () => {
}]);
so.displayName = "SchedulerItemSelectionContext";
const hm = ({
  children: e,
  element: t,
  props: r,
  views: n,
  fields: o,
  groups: l,
  dateRange: i,
  dateFormat: s,
  orientation: c,
  date: u,
  data: d,
  activeView: m,
  selection: p
}) => /* @__PURE__ */ a.createElement(Xn.Provider, { value: t }, /* @__PURE__ */ a.createElement(ua.Provider, { value: r }, /* @__PURE__ */ a.createElement(jn.Provider, { value: n }, /* @__PURE__ */ a.createElement(Jn.Provider, { value: o }, /* @__PURE__ */ a.createElement(Qn.Provider, { value: s }, /* @__PURE__ */ a.createElement(eo.Provider, { value: l }, /* @__PURE__ */ a.createElement(to.Provider, { value: i }, /* @__PURE__ */ a.createElement(ro.Provider, { value: c }, /* @__PURE__ */ a.createElement(no.Provider, { value: u }, /* @__PURE__ */ a.createElement(oo.Provider, { value: d }, /* @__PURE__ */ a.createElement(lo.Provider, { value: m }, /* @__PURE__ */ a.createElement(so.Provider, { value: p }, e)))))))))))), Oe = (e, t, r) => {
  const [n, o] = a.useState(t || e), l = a.useCallback(
    (i, s) => {
      o(i), r && r.call(void 0, { ...s, value: i });
    },
    [r, o]
  );
  return [t !== void 0 ? t : n, l];
}, oi = a.forwardRef((e, t) => {
  const {
    className: r,
    ...n
  } = e, o = a.useRef(null), l = a.useRef(null);
  a.useImperativeHandle(l, () => ({ element: o.current, props: e })), a.useImperativeHandle(t, () => l.current);
  const i = a.useMemo(() => ve("k-scheduler-toolbar", r), [r]);
  return /* @__PURE__ */ a.createElement(
    vl,
    {
      id: e.id,
      ref: (s) => {
        s && (o.current = s.element);
      },
      className: i,
      ...n
    },
    e.children
  );
});
oi.displayName = "KendoReactSchedulerHeader";
const co = a.forwardRef((e, t) => {
  const {
    className: r,
    ...n
  } = e, o = a.useRef(null);
  return a.useImperativeHandle(t, () => ({ element: o.current, props: e })), /* @__PURE__ */ a.createElement(
    Un,
    {
      ref: (l) => {
        l && (o.current = l.element);
      },
      className: ve(r),
      ...n
    },
    e.children
  );
});
co.displayName = "KendoReactSchedulerSchedulerNavigation";
const li = a.forwardRef((e, t) => {
  const {
    className: r,
    ...n
  } = e, o = a.useRef(null);
  return a.useImperativeHandle(t, () => ({ element: o.current, props: e })), /* @__PURE__ */ a.createElement(
    Un,
    {
      ref: (l) => {
        l && (o.current = l.element);
      },
      className: ve("k-scheduler-views", r),
      ...n
    },
    e.children
  );
});
li.displayName = "KendoReactSchedulerViewSelector";
const Em = a.forwardRef((e, t) => {
  const {
    className: r,
    style: n,
    ...o
  } = e, l = a.useRef(null), i = a.useRef(null);
  a.useImperativeHandle(l, () => ({ element: i.current, props: e })), a.useImperativeHandle(t, () => l.current);
  const s = a.useMemo(() => ve("k-scheduler-footer", e.className), [e.className]);
  return /* @__PURE__ */ a.createElement(
    vl,
    {
      ref: (c) => {
        c && (i.current = c.element);
      },
      className: s,
      style: { boxShadow: "none", ...n },
      ...o
    },
    e.children
  );
}), qa = "scheduler.allEvents", Dr = "scheduler.allDay", Za = "scheduler.today", Xa = "scheduler.timelineViewTitle", ja = "scheduler.weekViewTitle", Ja = "scheduler.workWeekViewTitle", Qa = "scheduler.agendaViewTitle", en = "scheduler.dayViewTitle", tn = "scheduler.monthViewTitle", Cr = "scheduler.deleteTitle", rn = "scheduler.previousTitle", an = "scheduler.nextTitle", nn = "scheduler.showFullDay", on = "scheduler.showWorkDay", ii = "scheduler.editOccurrence", si = "scheduler.editSeries", ci = "scheduler.editRecurringConfirmation", ui = "scheduler.editRecurringDialogTitle", ln = "scheduler.editSave", Tr = "scheduler.editCancel", sn = "scheduler.editorTitle", cn = "scheduler.editorEventTitle", un = "scheduler.editorEventStart", dn = "scheduler.editorEventStartTimeZone", mn = "scheduler.editorEventEnd", fn = "scheduler.editorEventEndTimeZone", pn = "scheduler.editorEventAllDay", vn = "scheduler.editorEventDescription", gn = "scheduler.editorEventSeparateTimeZones", yn = "scheduler.editorEventTimeZone", hn = "scheduler.recurrenceEditorRepeat", Dm = "scheduler.recurrenceEditorDailyInterval", Cm = "scheduler.recurrenceEditorDailyRepeatEvery", Tm = "scheduler.recurrenceEditorWeeklyInterval", km = "scheduler.recurrenceEditorWeeklyRepeatEvery", di = "scheduler.recurrenceEditorWeeklyRepeatOn", mi = "scheduler.recurrenceEditorMonthlyDay", bm = "scheduler.recurrenceEditorMonthlyInterval", Sm = "scheduler.recurrenceEditorMonthlyRepeatEvery", fi = "scheduler.recurrenceEditorMonthlyRepeatOn", pi = "scheduler.recurrenceEditorYearlyOf", Mm = "scheduler.recurrenceEditorYearlyRepeatEvery", vi = "scheduler.recurrenceEditorYearlyRepeatOn", wm = "scheduler.recurrenceEditorYearlyInterval", Im = "scheduler.recurrenceEditorFrequenciesDaily", Rm = "scheduler.recurrenceEditorFrequenciesMonthly", xm = "scheduler.recurrenceEditorFrequenciesNever", Nm = "scheduler.recurrenceEditorFrequenciesWeekly", Am = "scheduler.recurrenceEditorFrequenciesYearly", _m = "scheduler.recurrenceEditorOffsetPositionsFirst", Fm = "scheduler.recurrenceEditorOffsetPositionsSecond", zm = "scheduler.recurrenceEditorOffsetPositionsThird", Um = "scheduler.recurrenceEditorOffsetPositionsFourth", Om = "scheduler.recurrenceEditorOffsetPositionsLast", Lm = "scheduler.recurrenceEditorWeekdaysDay", Hm = "scheduler.recurrenceEditorWeekdaysWeekday", Pm = "scheduler.recurrenceEditorWeekdaysWeekendday", gi = "scheduler.recurrenceEditorEndAfter", yi = "scheduler.recurrenceEditorEndOccurrence", hi = "scheduler.recurrenceEditorEndLabel", Ei = "scheduler.recurrenceEditorEndNever", Di = "scheduler.recurrenceEditorEndOn", En = "scheduler.editorDelete", Dn = "scheduler.deleteConfirmation", Ci = "scheduler.deleteRecurringConfirmation", Ti = "scheduler.deleteOccurrence", ki = "scheduler.deleteSeries", Cn = "scheduler.deleteDialogTitle", bi = "scheduler.deleteRecurringDialogTitle", Tn = "scheduler.dateTitle", kn = "scheduler.timeTitle", bn = "scheduler.eventTitle", kr = "scheduler.editorValidationRequired", Sn = "scheduler.editorValidationStart", Mn = "scheduler.editorValidationEnd", wn = "scheduler.noEvents", In = "scheduler.moreEvents", Q = {
  [kr]: "Field is required.",
  [Sn]: "Start time must be before End time.",
  [Mn]: "End time must be after Start time.",
  [qa]: "All events",
  [Dr]: "all day",
  [Za]: "Today",
  [en]: "Day",
  [tn]: "Month",
  [ja]: "Week",
  [Ja]: "Work Week",
  [Xa]: "Timeline",
  [Qa]: "Agenda",
  [Cr]: "Delete",
  [rn]: "Previous",
  [an]: "Next",
  [nn]: "Show full day",
  [on]: "Show business hours",
  [ii]: "Edit current occurrence",
  [si]: "Edit the series",
  [ci]: "Do you want to edit only this event occurrence or the whole series?",
  [ui]: "Edit Recurring Item",
  [ln]: "Save",
  [Tr]: "Cancel",
  [En]: "Delete",
  [sn]: "Event",
  [cn]: "Title",
  [un]: "Start",
  [dn]: "Start Time Zone",
  [mn]: "End",
  [fn]: "End Time Zone",
  [pn]: "All Day Event",
  [vn]: "Description",
  [gn]: "End in different Time Zone",
  [yn]: "Specify Time Zone",
  [hn]: "Repeat",
  [Dm]: "day(s)",
  [Cm]: "Repeat every",
  [Tm]: "week(s)",
  [km]: "Repeat every",
  [di]: "Repeat on",
  [mi]: "Day",
  [bm]: "month(s)",
  [Sm]: "Repeat every",
  [fi]: "Repeat on",
  [pi]: "of",
  [Mm]: "Repeat every",
  [vi]: "Repeat on",
  [wm]: "year(s)",
  [Im]: "Daily",
  [Rm]: "Monthly",
  [xm]: "Never",
  [Nm]: "Weekly",
  [Am]: "Yearly",
  [_m]: "First",
  [Fm]: "Second",
  [zm]: "Third",
  [Um]: "Fourth",
  [Om]: "Last",
  [Lm]: "Day",
  [Hm]: "Weekday",
  [Pm]: "Weekend Day",
  [gi]: "After",
  [yi]: "occurrence(s)",
  [hi]: "End",
  [Ei]: "Never",
  [Di]: "On",
  [Dn]: "Are you sure you want to delete this event?",
  [Ci]: "Do you want to delete only this event occurrence or the whole series?",
  [Ti]: "Delete current occurrence",
  [ki]: "Delete the series",
  [Cn]: "Delete Event",
  [bi]: "Delete Recurring Item",
  [Tn]: "Date",
  [kn]: "Time",
  [bn]: "Event",
  [wn]: "no events",
  [In]: "More events"
}, Si = a.forwardRef((e, t) => {
  var r;
  const n = a.useRef(null), o = a.useRef(null);
  a.useImperativeHandle(
    t,
    () => n.current
  );
  const { timezone: l } = at(), i = j.fromLocalDate(e.value, l), s = tt(i), c = Fr(), u = fl(c), [d, m] = a.useState("desktop"), [p, f] = a.useState(!1), [h, y] = a.useState(!1), k = Qe(), { dateFormat: M, shortDateFormat: I } = ym(), D = At(), [x] = ni(), A = D.end.getTime() - D.start.getTime() > Xe * 27, O = k.format(
    M,
    A ? x : D.zonedStart,
    A ? x : D.zonedEnd.addDays(-1)
  ), v = k.format(
    I,
    A ? x : D.zonedStart,
    A ? x : D.zonedEnd.addDays(-1)
  ), w = a.useCallback(
    () => {
      f(!p);
    },
    [p]
  ), T = a.useCallback(
    () => {
      y(!0);
    },
    []
  ), R = a.useCallback(
    () => {
      f(!1), y(!1);
    },
    []
  ), F = a.useCallback(
    (L) => {
      if (e.onChange) {
        const U = j.fromUTCDate(Le(L.value), l);
        e.onChange.call(void 0, {
          ...L,
          value: U
        });
      }
      f(!1);
    },
    [e.onChange, l]
  ), V = a.useCallback(() => {
    u().matchMedia && m(u().matchMedia("(min-width: 1024px)").matches ? "desktop" : "mobile");
  }, [u]);
  a.useEffect(() => {
    V();
    const L = u().ResizeObserver, U = L && new L(V);
    return U && U.observe(c.current), () => {
      L && U.disconnect();
    };
  }, [V, c, u]), a.useEffect(
    () => {
      p && h && o.current && o.current.focus();
    },
    [h, p]
  );
  const { onFocus: z, onBlur: P } = Ws({ onFocus: T, onBlur: R });
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
    xe,
    {
      ref: n,
      onFocus: z,
      onBlur: P,
      fillMode: "flat",
      className: "k-nav-current",
      icon: "calendar",
      svgIcon: tc,
      "aria-live": "polite",
      tabIndex: -1,
      onClick: w
    },
    d === "desktop" ? O : v
  ), /* @__PURE__ */ a.createElement(
    ec,
    {
      anchor: (r = n.current) == null ? void 0 : r.element,
      show: p
    },
    /* @__PURE__ */ a.createElement(
      Js,
      {
        ref: o,
        onFocus: z,
        onBlur: P,
        onChange: F,
        value: s
      }
    )
  ));
});
Si.displayName = "KendoReactSchedulerNavigationDatePicker";
const Mi = a.createContext([null]);
Mi.displayName = "SchedulerEditItemPropsContext";
const wi = a.createContext([null, je, je]);
wi.displayName = "SchedulerEditItemFormItemContext";
const Ii = a.createContext([null, je, je]);
Ii.displayName = "SchedulerEditItemDragItemContext";
const Ri = a.createContext([null, je, je]);
Ri.displayName = "SchedulerEditItemResizeItemContext";
const xi = a.createContext([null, je, je]);
xi.displayName = "SchedulerEditItemRemoveItemContext";
const Ni = a.createContext([!1, je, je]);
Ni.displayName = "SchedulerEditItemShowRemoveDialogContext";
const Ai = a.createContext([!1, je, je]);
Ai.displayName = "SchedulerEditItemShowOccurrenceDialogContext";
const Wm = ({
  props: e,
  form: t,
  drag: r,
  resize: n,
  remove: o,
  showRemoveDialog: l,
  showOccurrenceDialog: i,
  children: s
}) => /* @__PURE__ */ a.createElement(Mi.Provider, { value: e }, /* @__PURE__ */ a.createElement(wi.Provider, { value: t }, /* @__PURE__ */ a.createElement(Ii.Provider, { value: r }, /* @__PURE__ */ a.createElement(Ri.Provider, { value: n }, /* @__PURE__ */ a.createElement(xi.Provider, { value: o }, /* @__PURE__ */ a.createElement(Ni.Provider, { value: l }, /* @__PURE__ */ a.createElement(Ai.Provider, { value: i }, s))))))), _i = a.createContext([null]);
_i.displayName = "SchedulerEditSlotPropsContext";
const Fi = a.createContext([null]);
Fi.displayName = "SchedulerEditSlotFormItemContext";
const Ym = ({
  props: e,
  form: t,
  children: r
}) => /* @__PURE__ */ a.createElement(_i.Provider, { value: e }, /* @__PURE__ */ a.createElement(Fi.Provider, { value: t }, r)), $m = a.createContext([null]), Gm = a.createContext([!1]), Bm = a.createContext([!1]), Km = (e) => /* @__PURE__ */ a.createElement($m.Provider, { value: e.remove }, /* @__PURE__ */ a.createElement(Gm.Provider, { value: e.showRemoveDialog }, /* @__PURE__ */ a.createElement(Bm.Provider, { value: e.showOccurrenceDialog }, e.children))), zi = a.createContext({});
zi.displayName = "SchedulerViewPropsContext";
const uo = a.createContext([]), Ui = () => a.useContext(uo);
uo.displayName = "SchedulerViewRangesContext";
const mo = a.createContext([[], ht]), qt = () => a.useContext(mo);
mo.displayName = "SchedulerViewSlotsContext";
const fo = a.createContext([[], ht]), zr = () => a.useContext(fo);
fo.displayName = "SchedulerViewItemsContext";
const po = a.createContext([[], ht]), Vm = () => a.useContext(po);
po.displayName = "SchedulerViewSelectedSlotsContext";
const vo = a.createContext([[], ht]), go = () => a.useContext(vo);
vo.displayName = "SchedulerViewSelectedItemsContext";
const yo = a.createContext([[], ht]), qm = () => a.useContext(yo);
yo.displayName = "SchedulerViewFocusedItemsContext";
const ho = a.createContext([[], ht]), Oi = () => a.useContext(ho);
ho.displayName = "SchedulerViewFocusedSlotsContext";
const Zm = ({
  children: e,
  // Static
  props: t,
  ranges: r,
  // Ref
  slots: n,
  items: o,
  // State
  // State.Selection
  selectedSlots: l,
  selectedItems: i,
  // State.Focus
  focusedItems: s,
  focusedSlots: c
}) => /* @__PURE__ */ a.createElement(zi.Provider, { value: t }, /* @__PURE__ */ a.createElement(uo.Provider, { value: r }, /* @__PURE__ */ a.createElement(mo.Provider, { value: n }, /* @__PURE__ */ a.createElement(fo.Provider, { value: o }, /* @__PURE__ */ a.createElement(po.Provider, { value: l }, /* @__PURE__ */ a.createElement(vo.Provider, { value: i }, /* @__PURE__ */ a.createElement(yo.Provider, { value: s }, /* @__PURE__ */ a.createElement(ho.Provider, { value: c }, e)))))))), Xm = (e) => {
  const [t, r] = io(), n = He(), o = a.useMemo(
    () => typeof e.view.title == "function" ? e.view.title.call(void 0, n) : e.view.title,
    [e.view.title, n]
  ), l = a.useCallback(
    () => {
      e.view.name && r(e.view.name);
    },
    [r, e.view.name]
  );
  return /* @__PURE__ */ a.createElement(
    xe,
    {
      className: "k-toolbar-button",
      role: "button",
      type: "button",
      tabIndex: -1,
      togglable: !0,
      selected: e.view.name === t,
      onClick: l
    },
    o
  );
}, Li = a.forwardRef(() => {
  const e = a.useRef(null), [t, r] = a.useState("desktop"), n = ai(), o = fl(e), [l, i] = io(), s = n.find((m) => m.props.name === l), c = He(), u = a.useCallback(
    (m) => {
      i && (m.syntheticEvent.preventDefault(), i(m.item.name));
    },
    [i]
  ), d = () => {
    o().matchMedia && r(o().matchMedia("(min-width: 1024px)").matches ? "desktop" : "mobile");
  };
  return a.useEffect(() => {
    d();
    const m = o().ResizeObserver, p = m && new m(d);
    return p && p.observe(e.current), () => {
      p && p.disconnect();
    };
  }, []), /* @__PURE__ */ a.createElement(
    "div",
    {
      className: ve(
        "k-toolbar-button-group k-button-group k-button-group-solid",
        {
          "k-scheduler-views": t === "desktop",
          "k-scheduler-tools": t === "mobile"
        }
      ),
      role: "group",
      ref: e
    },
    s && t === "mobile" && /* @__PURE__ */ a.createElement(
      Zs,
      {
        className: "k-views-dropdown",
        onItemClick: u,
        popupSettings: { popupClass: "k-scheduler-toolbar" },
        textField: "title",
        items: n.map((m) => ({
          ...m.props,
          selected: m.props.name === l,
          title: typeof m.props.title == "function" ? m.props.title.call(void 0, c) : m.props.title
        })),
        text: /* @__PURE__ */ a.createElement(a.Fragment, null, typeof s.props.title == "function" ? s.props.title.call(void 0, c) : s.props.title, /* @__PURE__ */ a.createElement(ze, { name: "caret-alt-down", icon: rc }))
      }
    ),
    t === "desktop" && /* @__PURE__ */ a.createElement(a.Fragment, null, n.map((m) => /* @__PURE__ */ a.createElement(Xm, { key: m.props.name, view: m.props })))
  );
});
Li.displayName = "KendoReactSchedulerViewSelectorList";
const jm = a.forwardRef((e, t) => {
  const {
    className: r,
    ...n
  } = e, o = a.useRef(null);
  return a.useImperativeHandle(t, () => ({ element: o.current, props: e })), /* @__PURE__ */ a.createElement(
    Un,
    {
      ref: (l) => {
        l && (o.current = l.element);
      },
      className: ve("k-scheduler-navigation", r),
      ...n
    },
    e.children
  );
}), br = (e, t) => {
  const { element: r } = e, n = () => {
    if (!r || !r.current)
      return;
    let o = [], l = [], i = [];
    const s = r.current.querySelectorAll(e.selector);
    s.forEach((c) => {
      const u = c.getBoundingClientRect().width, d = e.explicitDepth && e.attribute !== void 0 ? c.getAttribute(e.attribute) : 0, m = qn(c, !0), p = am(c, !0);
      d !== null && ((!i[d] || p > i[d]) && (i[d] = p), (!l[d] || m > l[d]) && (l[d] = m), (!o[d] || u > o[d]) && (o[d] = u));
    }), s.forEach((c) => {
      const u = e.explicitDepth ? c.getAttribute(e.attribute) : 0;
      u !== null && (c.style.minWidth = `${o[u] - l[u] - i[u]}px`);
    });
  };
  a.useLayoutEffect(n, t);
}, Jm = (e) => e.slice(1, e.length), Hi = (e, t) => {
  const { element: r } = e, n = () => {
    if (!r || !e.syncHeight)
      return;
    let o = [[]];
    Array.from(r.querySelectorAll(e.selector)).filter((l) => !l.classList.contains(Jm(e.applyTo))).forEach((l) => {
      const i = l.clientHeight, s = l.getAttribute(e.horizontalAttribute), c = l.getAttribute(e.verticalAttribute);
      s === null || c === null || (o[s] || (o[s] = []), (!o[s][c] || i > o[s][c]) && (o[s][c] = i - Re));
    }), Array.from(r.querySelectorAll(e.applyTo)).forEach((l) => {
      const i = l.getAttribute(e.horizontalAttribute), s = l.getAttribute(e.verticalAttribute);
      if (i === null || s === null)
        return;
      const c = qn(l), u = o[i][s] - c;
      rr(l, { height: u }, !0);
    });
  };
  a.useEffect(n, t);
}, nr = (e) => {
  const t = a.useContext(ua), r = e !== void 0 ? e : t.editable || !1, n = r === !0 || r !== void 0 && r !== !1 && r.edit === !0, o = r === !0 || r !== void 0 && r !== !1 && r.resize === !0, l = r === !0 || r !== void 0 && r !== !1 && r.remove === !0, i = r === !0 || r !== void 0 && r !== !1 && r.drag === !0, s = r === !0 || r !== void 0 && r !== !1 && r.add === !0, c = r === !0 || r !== void 0 && r !== !1 && r.select === !0;
  return {
    add: s,
    edit: n,
    drag: i,
    remove: l,
    resize: o,
    select: c
  };
}, Qm = (e, t) => {
  const r = a.useRef(), n = a.useRef(0), o = Fr(), l = () => {
    if (!e.current)
      return;
    const c = e.current.element;
    c && (n.current = c.clientHeight);
  }, i = a.useCallback(() => {
    if (!t || !e.current)
      return;
    const c = e.current.element, u = e.current.props;
    if (!c)
      return;
    const d = qn(c);
    let m = 0;
    const p = u.items.filter((h) => h._ref.current);
    p.forEach((h) => {
      if (!h._ref.current)
        return;
      const { height: y } = Ze(h._ref.current.element);
      m += y;
    });
    const f = p.length * Re * 2 + m - (d || 0) + (typeof t == "object" && t.offsetTop ? t.offsetTop : 0) + (typeof t == "object" && t.offsetBottom ? t.offsetBottom : 0);
    p.length ? f > n.current - d && rr(
      c,
      { height: f },
      !0
    ) : c && (c.style.minHeight = "");
  }, [t, e]), s = a.useCallback(() => {
    r.current !== void 0 && window.cancelAnimationFrame(r.current), r.current = window.requestAnimationFrame(() => {
      i();
    });
  }, [i]);
  a.useLayoutEffect(l, []), a.useEffect(i, [e, e.current && e.current.props, t]), a.useEffect(
    () => {
      if (!e.current)
        return;
      const c = e.current.props.items.filter((u) => u._ref.current).map((u) => {
        if (!u._ref.current || !u._ref.current.element || !o.current)
          return;
        const d = window.ResizeObserver, m = d && new d(s);
        return m && m.observe(u._ref.current.element), () => {
          m && m.disconnect();
        };
      });
      return () => {
        c.forEach((u) => u && u());
      };
    },
    [s, o, e]
  );
}, ef = (e, t) => {
  const { _ref: r, itemRef: n } = e, o = a.useRef(null), l = a.useRef(null), [, i] = zr();
  return a.useImperativeHandle(o, () => ({ element: l.current, props: e })), a.useImperativeHandle(t, () => o.current), a.useImperativeHandle(r, () => o.current), a.useImperativeHandle(n, () => o.current), a.useLayoutEffect(
    () => (i({
      type: jr.add,
      item: o
    }), () => {
      i({
        type: jr.remove,
        item: o
      });
    })
  ), {
    item: o,
    element: l
  };
};
var Sr = /* @__PURE__ */ ((e) => (e.next = "ITEMS_FOCUS_NEXT", e.prev = "ITEMS_FOCUS_PREV", e))(Sr || {});
const tf = (e) => [[], (t, r) => {
  switch (t.type) {
    case "ITEMS_FOCUS_NEXT": {
      if (!t.item || !t.item.current || !e)
        return;
      const n = ea(
        t.item,
        e,
        t.ignoreIsAllDay,
        !1
      );
      n && n.current && n.current.element && (r.preventDefault(), n.current.element.focus());
      break;
    }
    case "ITEMS_FOCUS_PREV": {
      if (!t.item || !t.item.current || !e)
        return;
      const n = ea(
        t.item,
        e,
        t.ignoreIsAllDay,
        !0
      );
      n && n.current && n.current.element && (r.preventDefault(), n.current.element.focus());
      break;
    }
  }
}];
var We = /* @__PURE__ */ ((e) => (e.up = "SLOT_FOCUS_UP", e.down = "SLOT_FOCUS_DOWN", e.left = "SLOT_FOCUS_LEFT", e.right = "SLOT_FOCUS_RIGHT", e))(We || {});
const rf = (e) => [[], (t, r) => {
  switch (t.type) {
    case "SLOT_FOCUS_UP": {
      if (!t.slot.current || !e)
        return;
      const n = af(t.slot, e);
      n && n.current && n.current.element && (r.preventDefault(), n.current.element.focus());
      break;
    }
    case "SLOT_FOCUS_DOWN": {
      if (!t.slot || !e)
        return;
      const n = lf(t.slot, e);
      n && n.current && n.current.element && (r.preventDefault(), n.current.element.focus());
      break;
    }
    case "SLOT_FOCUS_LEFT": {
      if (!t.slot || !e)
        return;
      const n = nf(t.slot, e);
      n && n.current && n.current.element && (r.preventDefault(), n.current.element.focus());
      break;
    }
    case "SLOT_FOCUS_RIGHT": {
      if (!t.slot || !e)
        return;
      const n = of(t.slot, e);
      n && n.current && n.current.element && (r.preventDefault(), n.current.element.focus());
      break;
    }
  }
}], af = (e, t) => t.find((r) => r.current !== null && e.current !== null && r.current.props.row === e.current.props.row - 1 && r.current.props.col === e.current.props.col), nf = (e, t) => t.find((r) => r.current !== null && e.current !== null && r.current.props.row === e.current.props.row && r.current.props.col === e.current.props.col - 1), of = (e, t) => t.find((r) => r.current !== null && e.current !== null && r.current.props.row === e.current.props.row && r.current.props.col === e.current.props.col + 1), lf = (e, t) => t.find((r) => r.current !== null && e.current !== null && r.current.props.row === e.current.props.row + 1 && r.current.props.col === e.current.props.col);
var Pe = /* @__PURE__ */ ((e) => (e.select = "ITEMS_SELECT_SELECT", e.selectNext = "ITEMS_SELECT_SELECT_NEXT", e.selectPrev = "ITEMS_SELECT_SELECT_PREV", e.reset = "ITEMS_SELECT_RESET", e.add = "ITEMS_SELECT_ADD", e.remove = "ITEMS_SELECT_REMOVE", e))(Pe || {});
const sf = (e) => {
  const [t, r] = a.useState([]), n = a.useCallback(
    (o, l) => {
      switch (o.type) {
        case "ITEMS_SELECT_SELECT":
          if (!o.item)
            return;
          r([o.item]);
          break;
        case "ITEMS_SELECT_SELECT_NEXT": {
          if (!o.item || !o.item.current || !e)
            return;
          const i = ea(
            o.item,
            e,
            o.ignoreIsAllDay,
            !1
          );
          i && (l.preventDefault(), r([i]));
          break;
        }
        case "ITEMS_SELECT_SELECT_PREV": {
          if (!o.item || !o.item.current || !e)
            return;
          const i = ea(
            o.item,
            e,
            o.ignoreIsAllDay,
            !0
          );
          i && (l.preventDefault(), r([i]));
          break;
        }
        case "ITEMS_SELECT_RESET":
          r([]);
          break;
        case "ITEMS_SELECT_ADD":
          if (!o.item)
            return;
          t.some((i) => i === o.item) || r([...t, o.item]);
          break;
        case "ITEMS_SELECT_REMOVE":
          if (!o.item)
            return;
          r([...t.filter((i) => i !== o.item)]);
          break;
      }
    },
    [e, t]
  );
  return [t, n];
};
var Eo = /* @__PURE__ */ ((e) => (e.select = "SLOTS_SELECT_SELECT", e.reset = "SLOTS_SELECT_RESET", e.add = "SLOTS_SELECT_ADD", e))(Eo || {});
const cf = (e) => {
  const [t, r] = a.useState([]), n = a.useCallback(
    (o) => {
      switch (o.type) {
        case "SLOTS_SELECT_SELECT":
          if (!o.slot)
            return;
          r([o.slot]);
          break;
        case "SLOTS_SELECT_RESET":
          r([]);
          break;
        case "SLOTS_SELECT_ADD":
          if (!o.slot)
            return;
          t.some((l) => l === o.slot) || r([...t, o.slot]);
          break;
      }
    },
    [t]
  );
  return [t, n];
}, Ur = a.forwardRef((e, t) => {
  const r = a.useRef(null);
  a.useImperativeHandle(t, () => r.current);
  const [n, o] = xo([]), [l, i] = xo([]), [s, c] = tf(n), [u, d] = rf(l), [m, p] = sf(n), [f, h] = cf(), y = a.useCallback(
    (I, D) => {
      h({ type: Eo.reset }), p(I, D);
    },
    [p, h]
  ), k = a.useCallback(
    (I, D) => {
      p({ type: Pe.reset }, D), h(I);
    },
    [p, h]
  ), M = a.useMemo(
    () => ve("k-scheduler-layout k-scheduler-layout-flex", e.className),
    [e.className]
  );
  return br({ element: r, selector: ".k-group-cell", attribute: "data-depth-index", explicitDepth: !0 }), br({ element: r, selector: ".k-side-cell", attribute: "data-depth-index", explicitDepth: !1 }), /* @__PURE__ */ a.createElement(
    Zm,
    {
      props: e.props,
      ranges: e.ranges,
      items: [n, o],
      slots: [l, i],
      selectedItems: [m, y],
      selectedSlots: [f, k],
      focusedItems: [s, c],
      focusedSlots: [u, d]
    },
    /* @__PURE__ */ a.createElement(
      "div",
      {
        ref: r,
        style: e.style,
        className: M,
        role: "presentation"
      },
      e.children
    )
  );
});
Ur.displayName = "KendoReactSchedulerBaseView";
const Fe = a.createContext({
  resource: {},
  groupIndex: 0
}), It = (e) => {
  const { nested: t, children: r, rowContentProps: n } = e, o = e.rowContent || uf, l = e.childRowContent || o, i = Vn(e.group, e.resources), s = 0;
  return /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-group k-group-horizontal" }, t ? Pi({ resources: i, children: r, nested: t, groupIndex: s, rowContent: o, rowContentProps: n, childRowContent: l }) : Wi({ resources: i, children: r, rowContent: o, nested: !!t, groupIndex: s, rowContentProps: n, childRowContent: l }));
}, Pi = (e) => {
  const { resources: t, rowContent: r, nested: n, children: o, groupIndex: l, rowContentProps: i, childRowContent: s } = e;
  if (l === t.length)
    return Wi({ resources: t, rowContent: r, children: o, nested: n, groupIndex: l, rowContentProps: i, childRowContent: s });
  const c = jl(t, l), u = r;
  return /* @__PURE__ */ a.createElement(a.Fragment, null, n ? /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row" }, /* @__PURE__ */ a.createElement(u, { resources: t, groupIndex: l, ...i }, c.map((d, m) => /* @__PURE__ */ a.createElement("div", { key: m, className: "k-scheduler-cell k-heading-cell" }, d.text)))) : /* @__PURE__ */ a.createElement(u, { resources: t, groupIndex: l, ...i }, c.map((d, m) => /* @__PURE__ */ a.createElement("div", { key: m, className: "k-scheduler-cell k-heading-cell" }, d.text))), Pi({
    resources: t,
    children: o,
    nested: n,
    rowContent: r,
    childRowContent: s,
    groupIndex: l + 1
  }));
}, Wi = (e) => {
  const { resources: t, childRowContent: r, children: n, rowContentProps: o } = e, l = jl(t, t.length - 1), i = r, s = t.length > 0;
  return /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row" }, /* @__PURE__ */ a.createElement(i, { resources: t, ...o }, (l.length ? l : om).map((c, u) => /* @__PURE__ */ a.createElement("div", { key: u, className: "k-scheduler-cell k-group-cell" }, /* @__PURE__ */ a.createElement(Fe.Provider, { value: { resource: c, groupIndex: s ? u : 0 } }, n)))));
};
It.displayName = "KendoReactSchedulerHorizontalResourceIterator";
const uf = (e) => e.children, tl = (e) => /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-side-cell", "data-range-index": e.rangeIndex }), e.children), yt = (e) => {
  const { nested: t, wrapGroup: r, children: n } = e, o = e.cellContent || vf, l = Vn(e.group, e.resources), i = 0, s = 0;
  return /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-group" }, t ? r ? /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row" }, /* @__PURE__ */ a.createElement("div", { className: "k-sticky-cell" }, Yi({ resources: l, children: n, cellContent: o, depth: i, groupIndex: s })), /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-group-content" }, Rn({ resources: l, children: n, cellContent: o, depth: i, groupIndex: s }, !1))) : Rn({ resources: l, children: n, cellContent: o, depth: i, groupIndex: s }, !0) : r ? /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row" }, /* @__PURE__ */ a.createElement("div", { className: "k-sticky-cell" }, df({ resources: l, children: n, cellContent: o, depth: i, groupIndex: s })), /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-group-content" }, n)) : mf({ resources: l, children: n, cellContent: o, depth: i, groupIndex: s }));
}, df = (e) => /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row" }, /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row" }, e.resources.map((t, r) => /* @__PURE__ */ a.createElement("div", { key: r, className: "k-scheduler-cell k-resource-cell k-heading-cell", "data-depth-index": r })))), Rn = (e, t = !0) => {
  const { resources: r, children: n, cellContent: o, groupIndex: l, depth: i } = e, s = r.length > 0;
  if (i === r.length || !s)
    return /* @__PURE__ */ a.createElement(
      Fe.Provider,
      {
        value: { resource: r[i], groupIndex: s ? l : 0 }
      },
      n
    );
  const c = r[i].data.length;
  return r[i].data.map((u, d) => /* @__PURE__ */ a.createElement("div", { key: d, className: "k-scheduler-row" }, t && /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-group-cell k-heading-cell", "data-depth-index": i }, u.text), /* @__PURE__ */ a.createElement(
    "div",
    {
      className: "k-scheduler-cell k-group-content k-resource-row",
      "data-depth-index": i,
      "data-resource-index": c * l + d
    },
    Rn(
      {
        resources: r,
        children: n,
        cellContent: o,
        groupIndex: c * l + d,
        depth: i + 1
      },
      t
    )
  )));
}, Yi = (e) => {
  const { resources: t, children: r, cellContent: n, groupIndex: o, depth: l } = e, i = t.length ? t[l].data.length : 0;
  return t[l] ? t[l].data.map((s, c) => /* @__PURE__ */ a.createElement("div", { key: c, className: "k-scheduler-row" }, /* @__PURE__ */ a.createElement(
    "div",
    {
      className: "k-scheduler-cell k-resource-cell k-resource-row k-heading-cell",
      "data-depth-index": l,
      "data-resource-index": i * o + c
    },
    s.text
  ), l + 1 !== t.length && /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-resource-content" }, Yi({
    resources: t,
    children: r,
    cellContent: n,
    groupIndex: i * o + c,
    depth: l + 1
  })))) : null;
}, mf = (e) => {
  const { resources: t, children: r, groupIndex: n, cellContent: o } = e;
  return /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row" }, pf(t), o, ff(r, t, n));
}, ff = (e, t, r) => {
  const n = t.length > 0;
  return /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-group-content" }, /* @__PURE__ */ a.createElement(
    Fe.Provider,
    {
      value: { resource: t[r], groupIndex: n ? r : void 0 }
    },
    e
  ));
}, pf = (e) => e.map((t, r) => /* @__PURE__ */ a.createElement("div", { key: r, className: "k-scheduler-cell k-group-cell k-heading-cell", "data-depth-index": r }));
yt.displayName = "KendoReactSchedulerVerticalResourceIterator";
const vf = null, Oa = (e) => {
  const t = He();
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-heading-cell k-side-cell k-scheduler-times-all-day" }, t.toLanguageString(Dr, Q[Dr])), e.children);
}, Do = a.forwardRef((e, t) => {
  const {
    as: r = La.as,
    ...n
  } = e, o = a.useRef(null), l = a.useRef(null), i = Qe(), s = a.useMemo(
    () => ve("k-scheduler-cell k-heading-cell", e.className),
    [e.className]
  );
  return a.useImperativeHandle(l, () => ({
    element: o.current && o.current.element ? o.current.element : o.current,
    props: e
  })), a.useImperativeHandle(t, () => l.current), /* @__PURE__ */ a.createElement(
    r,
    {
      ref: r !== La.as ? void 0 : o,
      ...n,
      className: s
    },
    i.formatDate(
      e.date,
      e.format ? e.format : La.format
    )
  );
}), La = {
  as: a.forwardRef(({ as: e, format: t, start: r, end: n, ...o }, l) => /* @__PURE__ */ a.createElement("div", { ...o, ref: l })),
  format: "t"
};
Do.displayName = "KendoReactSchedulerTimeHeaderCell";
const rl = (e) => {
  const { slot: t, children: r } = e;
  return /* @__PURE__ */ a.createElement(a.Fragment, null, e.isMaster ? /* @__PURE__ */ a.createElement(
    Do,
    {
      as: e.timeHeaderCell,
      date: t.zonedStart,
      start: t.zonedStart,
      end: t.zonedEnd,
      className: ve(
        "k-side-cell",
        {
          "k-major-cell": !e.isLast
        }
      )
    }
  ) : /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-heading-cell k-side-cell" }), r);
}, Bt = (e, { timezone: t }, { groups: r, ranges: n }) => {
  const o = [];
  return pl(
    e,
    [
      { field: "start", dir: "asc" },
      { field: "end", dir: "desc" },
      { field: "isAllDay", dir: "desc" }
    ]
  ).forEach((l) => {
    r.forEach((i) => {
      const s = r.length === 1 ? gf(l, i) : i;
      hf(l, s) && n.forEach((c) => {
        if (Ef(l, c)) {
          const u = a.createRef(), d = a.createRef(), m = c.end < l.end, p = l.start < c.start, f = j.fromLocalDate(l.start, t), h = j.fromLocalDate(l.end, t), y = {
            ...l,
            _ref: d,
            itemRef: u,
            head: m,
            tail: p,
            order: null,
            zonedStart: f,
            zonedEnd: h,
            group: s,
            range: c,
            slots: [],
            isRecurring: !!l.recurrenceRule,
            isException: !l.recurrenceRule && l.recurrenceId !== null && l.recurrenceId !== void 0,
            isAllDay: !!l.isAllDay
          };
          o.push(y);
        }
      });
    });
  }), o;
}, gf = (e, t) => ({
  index: 0,
  resources: t.resources.filter((r) => yf(e, r))
}), yf = (e, t) => t.multiple ? (e.dataItem[t.field] || []).some((r) => t[t.valueField] === r) : e.dataItem[t.field] === t[t.valueField], hf = (e, t) => !t.resources.some((r) => r.multiple ? !e.dataItem[r.field].some((n) => r[r.valueField] === n) : e.dataItem[r.field] !== r[r.valueField]), Ef = (e, t) => Ye(t.start, t.end, e.start, e.end) && (t.isAllDay === void 0 || e.isAllDay === void 0 || e.isAllDay === t.isAllDay), Mr = (e, { step: t }, { groups: r, ranges: n }) => {
  const o = [];
  return r.forEach((l) => {
    n.forEach((i) => {
      const s = i.zonedStart, c = i.zonedEnd, u = c.timezoneOffset - s.timezoneOffset;
      for (let d = s.clone(), m = 0, p = u < 0 ? u * Va * -1 : 0; d.getTime() < c.getTime(); m++, d = d.addTime(t)) {
        const f = a.createRef(), h = d.clone(), y = d.addTime(t), k = (y.timezoneOffset - h.timezoneOffset) * Va, M = t <= Math.abs(k);
        p && M && (p -= t, d = d.addTime(-t));
        const I = new Date(h.getTime()), D = new Date(y.getTime()), x = {
          _ref: f,
          index: m,
          end: D,
          start: I,
          zonedStart: h,
          zonedEnd: y,
          range: i,
          group: l,
          items: [],
          isAllDay: Xe <= t
        };
        o.push(x);
      }
    });
  }), o;
}, or = (e, { dateRange: t, fields: r, timezone: n }) => e.map(Df(r)).reduce(Cf(t, n, r), []).filter((o) => !Zn(o.dataItem, r)), Df = (e) => (t) => ({
  uid: _e(e.id || "id")(t),
  start: _e(e.start || "start")(t),
  startTimezone: _e(e.startTimezone || "startTimezone")(t),
  originalStart: _e(e.originalStart || "originalStart")(t),
  end: _e(e.end || "end")(t),
  endTimezone: _e(e.endTimezone || "endTimezone")(t),
  isAllDay: _e(e.isAllDay || "isAllDay")(t),
  title: _e(e.title || "title")(t),
  description: _e(e.description || "description")(t),
  occurrenceId: _e("occurrenceId")(t),
  recurrenceRule: _e(e.recurrenceRule || "recurrenceRule")(t),
  recurrenceExceptions: _e(e.recurrenceExceptions || "recurrenceExceptions")(t),
  recurrenceId: _e(e.recurrenceId || "recurrenceId")(t),
  dataItem: ie(t)
}), Cf = (e, t, r) => (n, o) => [
  ...n,
  ...o.recurrenceRule && (o.recurrenceId === null || o.recurrenceId === void 0) && Zn(o.dataItem, r) ? [...Tf(o, { dateRange: e, timezone: t, fields: r })] : [o]
], Tf = (e, { dateRange: t, timezone: r, fields: n }) => {
  const o = e.recurrenceRule, l = ql({ recurrenceRule: o });
  l.start || (l.start = j.fromLocalDate(e.start, r)), l.end || (l.end = j.fromLocalDate(e.end, r));
  const i = e.recurrenceExceptions;
  i && (l.exceptionDates = i.map(
    (d) => j.fromLocalDate(d, r)
  ));
  const s = t.zonedStart, c = t.zonedEnd, u = Jd(l, {
    rangeStart: s,
    rangeEnd: c
  });
  return u.events.length ? u.events.map((d, m) => {
    const p = ie(e), f = ie(e.dataItem);
    return p.recurrenceId = p.uid, J(f, n.recurrenceId, e.uid), p.originalStart = d.start.toLocalDate(), J(f, n.originalStart, d.start.toLocalDate()), p.start = d.start.toLocalDate(), J(f, n.start, d.start.toLocalDate()), p.end = d.end.toLocalDate(), J(f, n.end, d.end.toLocalDate()), p.occurrenceId = String(m), J(f, "occurrenceId", String(m)), p.dataItem = f, p;
  }) : [];
}, wr = (e, { step: t, timezone: r }) => {
  const n = [], o = j.fromLocalDate(e.start, r), l = j.fromLocalDate(e.end, r);
  for (let i = o.clone(), s = 0; i.getTime() < l.getTime(); s++, i = i.addTime(t)) {
    const c = i.clone(), u = c.clone().addTime(t), d = new Date(c.getTime()), m = new Date(u.getTime()), p = {
      index: s,
      end: m,
      start: d,
      zonedStart: c,
      zonedEnd: u
    };
    n.push(p);
  }
  return n;
}, al = (e) => {
  const { onChange: t, data: r, validationMessage: n, visited: o, touched: l, modified: i, ...s } = e, [c, u] = a.useState(r), d = a.useCallback(
    (p) => t(p),
    [t]
  ), m = a.useCallback(
    (p) => {
      const f = qs(r || [], p.filter);
      u(f);
    },
    []
  );
  return /* @__PURE__ */ a.createElement(
    pc,
    {
      style: { width: "100%" },
      data: c,
      filterable: !0,
      onFilterChange: m,
      onChange: d,
      ...s
    }
  );
}, kf = (e) => {
  const { value: t, data: r, onChange: n, ...o } = e, l = a.useCallback(
    (i) => {
      n && n.call(void 0, i.currentTarget.dataset.value);
    },
    [n]
  );
  return /* @__PURE__ */ a.createElement(
    Nn,
    {
      className: "k-scheduler-recurrence-repeat",
      width: "100%",
      ...o
    },
    r.map((i) => /* @__PURE__ */ a.createElement(
      xe,
      {
        type: "button",
        key: i.value,
        selected: i.value === t,
        onClick: l,
        "data-value": i.value,
        togglable: !0
      },
      i.text
    ))
  );
}, Ir = (e) => e.charAt(0).toUpperCase() + e.slice(1), bf = ["first", "second", "third", "fourth", "last"], Sf = ["never", "daily", "weekly", "monthly", "yearly"], Mf = [
  { day: 0, offset: 0 },
  { day: 1, offset: 0 },
  { day: 2, offset: 0 },
  { day: 3, offset: 0 },
  { day: 4, offset: 0 },
  { day: 5, offset: 0 },
  { day: 6, offset: 0 }
], wf = [
  { day: 1, offset: 0 },
  { day: 2, offset: 0 },
  { day: 3, offset: 0 },
  { day: 4, offset: 0 },
  { day: 5, offset: 0 }
], If = [
  { day: 0, offset: 0 },
  { day: 6, offset: 0 }
], nl = (e) => {
  switch (e) {
    case "day":
      return Mf;
    case "weekday":
      return wf;
    case "weekend":
      return If;
  }
}, Rf = (e) => ql({ recurrenceRule: e }) || {}, xf = (e) => Sf.map((t) => ({
  value: t,
  text: e("Frequencies" + Ir(t))
})), Nf = (e) => gt(e) && !vm(e.freq) ? e.freq : "never", Af = (e) => gt(e.until) ? na(e.until) : null, _f = (e) => e.dateFormatNames({
  type: "months",
  nameType: "wide",
  standAlone: !0
}).map((t, r) => ({
  text: t,
  value: r + 1
})), Ff = (e) => {
  const t = e.firstDay(), r = e.dateFormatNames({
    type: "days",
    nameType: "abbreviated"
  }).map((n, o) => ({
    text: n,
    value: o
  }));
  return r.slice(t).concat(r.slice(0, t));
}, zf = (e, t, r) => e.find((n) => {
  let o;
  if (gt(t.byWeekDay))
    switch (t.byWeekDay.length) {
      case 7:
        o = "day";
        break;
      case 5:
        o = "weekday";
        break;
      case 2:
        o = "weekend";
        break;
      case 1:
        o = t.byWeekDay[0].day;
        break;
      default:
        o = r.getDay();
        break;
    }
  return o === n.value;
}) || e[0], Uf = (e, t) => {
  const r = e.firstDay();
  let n = e.dateFormatNames({
    type: "days",
    nameType: "wide"
  }).map((l, i) => ({
    text: l,
    value: i
  }));
  const o = n.slice(r).concat(n.slice(0, r));
  return [
    { text: t("WeekdaysDay"), value: "day" },
    { text: t("WeekdaysWeekday"), value: "weekday" },
    { text: t("WeekdaysWeekendday"), value: "weekend" }
  ].concat(o);
}, Of = (e, t) => e.find((r) => r.value === (t.bySetPosition ? t.bySetPosition[0] : t.byWeekDay && t.byWeekDay[0] ? t.byWeekDay[0].offset : 1)) || e[0], Lf = (e) => {
  const t = [1, 2, 3, 4, -1];
  return bf.map((r, n) => ({
    text: e("OffsetPositions" + Ir(r)),
    value: t[n]
  }));
}, Hf = (e) => gt(e.count) ? "count" : gt(e.until) ? "until" : "never", Pf = (e) => {
  if (gt(e.byWeekDay))
    return "weekday";
  if (gt(e.byMonthDay))
    return "monthday";
}, Wf = (e, t) => e.find((r) => (t.byMonth ? t.byMonth[0] : null) === r.value) || e[0], Yf = (e, t) => gt(e.byMonthDay) && e.byMonthDay.length > 0 ? e.byMonthDay[0] : t.getDate(), $f = (e) => {
  const { value: t, data: r, onChange: n, ...o } = { ...ol, ...e }, l = (i) => {
    const s = Number(i.currentTarget.dataset.key);
    e.onChange && e.onChange.call(void 0, t.some((c) => c === s) ? t.filter((c) => c !== s) : [...t, s]);
  };
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(Nn, { width: "auto", ...o }, (e.data || ol.data).map((i) => /* @__PURE__ */ a.createElement(
    xe,
    {
      type: "button",
      key: i.value,
      "data-key": i.value,
      selected: t.some((s) => s === i.value),
      togglable: !0,
      onClick: l
    },
    Ir(i.text)
  ))));
}, ol = {
  data: [],
  value: []
}, $i = (e) => {
  const t = Qe(), r = He(), { timezone: n } = at(), [o, l] = a.useState(1), [i, s] = a.useState(j.fromUTCDate(e.start)), c = a.useCallback(
    (b, g) => {
      const _ = g ? b : "scheduler.recurrenceEditor" + b;
      return r.toLanguageString(_, Q[_]);
    },
    [r]
  ), u = a.useMemo(
    () => Rf(e.value ?? Gf.value),
    [e.value]
  ), d = a.useMemo(
    () => xf(c),
    [c]
  ), m = a.useMemo(
    () => Nf(u),
    [u]
  ), p = a.useMemo(
    () => Uf(t, c),
    [t, c]
  ), f = a.useMemo(
    () => zf(p, u, e.start),
    [p, u, e.start]
  ), h = a.useMemo(
    () => _f(t),
    [t]
  ), y = a.useMemo(
    () => Wf(h, u),
    [h, u]
  ), k = a.useMemo(
    () => Lf(c),
    [c]
  ), M = a.useMemo(
    () => Of(k, u),
    [k, u]
  ), I = a.useMemo(
    () => Hf(u),
    [u]
  ), D = a.useMemo(
    () => Yf(u, e.start),
    [u, e.start]
  ), x = a.useMemo(
    () => Af(u),
    [u.until]
  ), A = a.useMemo(
    () => Ff(t),
    [t]
  ), O = a.useMemo(
    () => Pf(u),
    [u.byWeekDay, u.byMonthDay]
  ), v = a.useCallback(
    (b) => {
      b.freq === "never" ? e.onChange({ value: null }) : (b.weekStart === void 0 && (b.weekStart = t.firstDay()), e.onChange({ value: rm(b, e.timezone) }));
    },
    [e.onChange, e.timezone]
  ), w = a.useCallback(
    (b) => {
      const g = {};
      g.freq = b, g.interval = 1, b === "weekly" && (g.byWeekDay = [{
        day: j.fromLocalDate(e.start, n).getDay(),
        offset: 0
      }]), (b === "monthly" || b === "yearly") && (g.byMonthDay = [e.start.getDate()]), b === "yearly" && (g.byMonth = [e.start.getMonth() + 1]), v(g);
    },
    [v, e.start, n]
  ), T = a.useCallback(
    (b) => {
      const g = b.value;
      v(Object.assign({}, u, {
        interval: g
      }));
    },
    [v, u]
  ), R = a.useCallback(
    (b) => {
      const g = b.value;
      v(Object.assign({}, u, {
        count: g
      })), g !== null && l(g);
    },
    [v, u]
  ), F = a.useCallback(
    (b) => {
      const g = b.value;
      if (!g)
        return;
      const _ = j.fromLocalDate(g, e.timezone);
      v(Object.assign({}, u, {
        until: _
      })), s(_);
    },
    [v, u, e.timezone]
  ), V = a.useCallback(
    (b) => {
      v(Object.assign({}, u, {
        byWeekDay: A.filter((g) => b.some((_) => _ === g.value)).map((g) => ({ offset: 0, day: g.value }))
      }));
    },
    [v, u, A]
  ), z = a.useCallback(
    (b) => {
      const g = Object.assign({}, u), _ = b.target.value;
      typeof _.value == "string" ? (g.byWeekDay = nl(_.value), g.bySetPosition = [M.value]) : g.byWeekDay = [{
        day: _.value,
        offset: M.value
      }], v(g);
    },
    [v, u]
  ), P = a.useCallback(
    (b) => {
      v(Object.assign({}, u, {
        byMonthDay: [b.value]
      }));
    },
    [v, u]
  ), L = a.useCallback(
    (b) => {
      const g = b.value;
      v(Object.assign({}, u, {
        byMonth: [g.value]
      }));
    },
    [v, u]
  ), U = a.useCallback(
    (b) => {
      const g = b.value, _ = Object.assign({}, u);
      switch (g) {
        case "never":
          _.until = void 0, _.count = void 0;
          break;
        case "count":
          _.until = void 0, _.count = o;
          break;
        case "until":
          _.until = i, _.count = void 0;
          break;
      }
      v(_);
    },
    [v, u, e.timezone]
  ), C = a.useCallback(
    (b) => {
      const g = Object.assign({}, u);
      b.value === "monthday" ? (g.byWeekDay = void 0, g.bySetPosition = void 0, g.byMonthDay = [D]) : b.value === "weekday" && (g.byMonthDay = void 0, typeof f.value == "string" ? (g.bySetPosition = [M.value], g.byWeekDay = nl(f.value)) : g.byWeekDay = [{
        day: f.value,
        offset: M.value
      }]), v(g);
    },
    [v, u, D, f]
  ), $ = a.useCallback(
    (b) => {
      const g = Object.assign({}, u), _ = b.value;
      if (g.byWeekDay)
        switch (g.byWeekDay.length) {
          case 7:
          case 5:
          case 2:
            g.bySetPosition = [_.value];
            break;
          case 1:
            g.byWeekDay[0].offset = _.value;
            break;
        }
      v(g);
    },
    [v, u]
  );
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(Te, { className: "k-form-label" }, r.toLanguageString(hn, Q[hn])), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
    kf,
    {
      value: m,
      data: d,
      onChange: w
    }
  ))), m !== "never" && /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(Te, { editorId: "interval-editor", className: "k-form-label" }, c(Ir(m) + "RepeatEvery")), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
    Br,
    {
      min: 1,
      step: 1,
      defaultValue: 1,
      value: u.interval,
      onChange: T,
      id: "interval-editor",
      className: "k-recur-interval"
    }
  ), /* @__PURE__ */ a.createElement(a.Fragment, null, " "), /* @__PURE__ */ a.createElement(Te, { editorId: "interval-editor", className: "k-form-label" }, c(Ir(m) + "Interval")))), m === "weekly" && /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(Te, { className: "k-form-label" }, c(di, !0)), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
    $f,
    {
      data: A,
      value: (u.byWeekDay || []).map(({ day: b }) => b),
      onChange: V
    }
  ))), m === "monthly" && /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(Te, { key: "recurrence-repeat-on-monthly-label", className: "k-form-label" }, c(fi, !0)), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
    Sa,
    {
      value: O,
      onChange: C,
      item: Ha,
      className: "k-reset",
      data: [
        {
          value: "monthday",
          label: c(mi, !0),
          children: [
            /* @__PURE__ */ a.createElement(a.Fragment, { key: "separator" }, " "),
            /* @__PURE__ */ a.createElement(
              Br,
              {
                key: "weekday-day",
                min: 1,
                max: 31,
                disabled: O !== "monthday",
                value: u && u.byMonthDay && u.byMonthDay[0],
                onChange: P,
                width: "auto"
              }
            )
          ]
        },
        {
          value: "weekday",
          label: " ",
          children: [
            /* @__PURE__ */ a.createElement(
              Lt,
              {
                key: "weekday-offset",
                textField: "text",
                dataItemKey: "value",
                disabled: O !== "weekday",
                data: k,
                value: M,
                onChange: $,
                style: { width: "auto" }
              }
            ),
            /* @__PURE__ */ a.createElement(a.Fragment, { key: "separator" }, " "),
            /* @__PURE__ */ a.createElement(
              Lt,
              {
                key: "weekday-value",
                disabled: O !== "weekday",
                value: f,
                data: p,
                onChange: z,
                textField: "text",
                dataItemKey: "value",
                style: { width: "auto" }
              }
            )
          ]
        }
      ]
    }
  ))), m === "yearly" && /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(Te, null, c(vi, !0)), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
    Sa,
    {
      value: O,
      item: Ha,
      onChange: C,
      className: "k-reset",
      data: [
        {
          value: "monthday",
          label: " ",
          children: [
            /* @__PURE__ */ a.createElement(
              Lt,
              {
                key: "monthday-month",
                disabled: O !== "monthday",
                value: y,
                data: h,
                textField: "text",
                dataItemKey: "value",
                onChange: L,
                style: { width: "auto" }
              }
            ),
            /* @__PURE__ */ a.createElement(a.Fragment, { key: "separator" }, " "),
            /* @__PURE__ */ a.createElement(
              Br,
              {
                key: "monthday-day",
                min: 1,
                max: 31,
                disabled: O !== "monthday",
                value: D,
                onChange: P,
                width: "auto"
              }
            )
          ]
        },
        {
          value: "weekday",
          label: " ",
          children: [
            /* @__PURE__ */ a.createElement(
              Lt,
              {
                key: "yearly-weekday-offset",
                textField: "text",
                dataItemKey: "value",
                disabled: O !== "weekday",
                data: k,
                value: M,
                onChange: $,
                style: { width: "auto" }
              }
            ),
            /* @__PURE__ */ a.createElement(a.Fragment, { key: "yearly-separator-1" }, " "),
            /* @__PURE__ */ a.createElement(
              Lt,
              {
                key: "yearly-weekday-day",
                textField: "text",
                dataItemKey: "value",
                disabled: O !== "weekday",
                value: f,
                data: p,
                onChange: z,
                style: { width: "auto" }
              }
            ),
            /* @__PURE__ */ a.createElement(a.Fragment, { key: "yearly-separator-2" }, " "),
            /* @__PURE__ */ a.createElement("span", { key: "yearly-weekday-of-label" }, c(pi, !0)),
            /* @__PURE__ */ a.createElement(a.Fragment, { key: "yearly-separator-3" }, " "),
            /* @__PURE__ */ a.createElement(
              Lt,
              {
                key: "yearly-weekday-month",
                textField: "text",
                dataItemKey: "value",
                disabled: O !== "weekday",
                value: y,
                data: h,
                onChange: L,
                style: { width: "auto" }
              }
            )
          ]
        }
      ]
    }
  ))), m !== "never" && /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-recurrence-end-rule-editor" }, /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(Te, { className: "k-form-label" }, c(hi, !0)), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
    Sa,
    {
      item: Ha,
      value: I,
      onChange: U,
      data: [
        {
          value: "never",
          label: c(Ei, !0)
        },
        {
          value: "count",
          label: c(gi, !0),
          children: [
            /* @__PURE__ */ a.createElement(a.Fragment, { key: "separator-1" }, " "),
            /* @__PURE__ */ a.createElement(
              Br,
              {
                key: "endrule-after-editor",
                id: "k-endrule-after",
                className: "k-recur-count",
                min: 1,
                width: "70px",
                value: I === "count" ? u.count : o,
                onChange: R,
                disabled: I !== "count"
              }
            ),
            /* @__PURE__ */ a.createElement(a.Fragment, { key: "separator-2" }, " "),
            /* @__PURE__ */ a.createElement(
              Te,
              {
                key: "endrule-after-label",
                className: "k-radio-label",
                editorId: "k-endrule-after"
              },
              c(yi, !0)
            )
          ]
        },
        {
          value: "until",
          label: c(Di, !0),
          children: [
            /* @__PURE__ */ a.createElement(a.Fragment, { key: "separator" }, " "),
            /* @__PURE__ */ a.createElement(
              Ya,
              {
                key: "k-endrule-until-editor",
                id: "k-endrule-until",
                disabled: I !== "until",
                min: e.start,
                value: I === "until" ? x : na(i),
                onChange: F,
                width: "auto"
              }
            )
          ]
        }
      ]
    }
  )))));
}, Ha = (e) => /* @__PURE__ */ a.createElement("li", { ...e }, e.children), Gf = {
  value: ""
};
$i.displayName = "KendoReactSchedulerRepeatEditor";
const Bf = (e) => {
  const t = e.multiple ? vc : Lt, r = a.useCallback(
    (i) => {
      const s = i.target.props.dataItemKey, c = e.multiple ? (i.target.value || []).map((u) => u[s]) : i.target.value[s];
      e.onChange.call(void 0, { value: c });
    },
    [e.multiple, e.onChange]
  ), n = a.useCallback(
    (i, s) => {
      const c = /* @__PURE__ */ a.createElement(a.Fragment, null, e.colorField && /* @__PURE__ */ a.createElement(
        "span",
        {
          key: 1,
          className: "k-scheduler-mark",
          style: {
            backgroundColor: s.dataItem[e.colorField],
            marginRight: gt(s.dataItem[e.valueField]) ? "8px" : "4px"
          }
        },
        " "
      ), /* @__PURE__ */ a.createElement("span", { key: 2 }, "  ", i.props.children));
      return a.cloneElement(i, { ...i.props }, c);
    },
    [e.colorField, e.valueField]
  ), o = a.useCallback(
    (i, s) => {
      const c = /* @__PURE__ */ a.createElement(a.Fragment, null, e.colorField && s && /* @__PURE__ */ a.createElement(
        "span",
        {
          key: 1,
          className: "k-scheduler-mark",
          style: {
            backgroundColor: s[e.colorField],
            marginRight: s[e.valueField] ? "8px" : "4px"
          }
        },
        " "
      ), i.props.children);
      return a.cloneElement(i, {}, c);
    },
    [e.colorField, e.valueField]
  ), l = Array.isArray(e.value) ? e.data.filter((i) => e.value.some((s) => i[e.valueField] === s)) : e.data.find((i) => i[e.valueField] === e.value);
  return /* @__PURE__ */ a.createElement(
    t,
    {
      value: l,
      onChange: r,
      data: e.data,
      textField: e.textField,
      dataItemKey: e.valueField,
      valid: e.valid,
      validationMessage: e.validationMessage,
      itemRender: n,
      valueRender: o
    }
  );
}, ll = (e) => {
  const {
    as: t = qf.as,
    ...r
  } = e, { timezone: n } = at(), o = (l) => {
    r.onChange && r.onChange({ value: Vf(l.target.value, n) });
  };
  return /* @__PURE__ */ a.createElement(
    t,
    {
      ...r,
      value: Kf(r.value, n),
      onChange: o
    }
  );
}, Kf = (e, t) => e && na(j.fromLocalDate(e, t).toUTCDate()), Vf = (e, t) => e && j.fromUTCDate(
  new Date(Date.UTC(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  )),
  t
).toLocalDate(), qf = {
  as: $a
}, Gi = a.forwardRef((e, t) => {
  const r = a.useRef(null), n = a.useRef(null), o = Ic(), l = He(), i = $e(), { resources: s, timezone: c } = at();
  a.useImperativeHandle(n, () => ({
    element: r.current && r.current.element ? r.current.element : r.current,
    props: e
  })), a.useImperativeHandle(t, () => n.current);
  const {
    as: u = le.as,
    ...d
  } = e, {
    titleLabel: m = le.titleLabel,
    titleError: p = le.titleError,
    titleEditor: f = le.titleEditor,
    startLabel: h = le.startLabel,
    startError: y = le.startError,
    startEditor: k = le.startEditor,
    startTimezoneLabel: M = le.startTimezoneLabel,
    startTimezoneError: I = le.startTimezoneError,
    startTimezoneEditor: D = le.startTimezoneEditor,
    startTimezoneCheckedLabel: x = le.startTimezoneCheckedLabel,
    startTimezoneCheckedEditor: A = le.startTimezoneCheckedEditor,
    endLabel: O = le.endLabel,
    endError: v = le.endError,
    endEditor: w = le.endEditor,
    endTimezoneLabel: T = le.endTimezoneLabel,
    endTimezoneError: R = le.endTimezoneError,
    endTimezoneEditor: F = le.endTimezoneEditor,
    endTimezoneCheckedLabel: V = le.endTimezoneCheckedLabel,
    endTimezoneCheckedEditor: z = le.endTimezoneCheckedEditor,
    allDayLabel: P = le.allDayLabel,
    allDayEditor: L = le.allDayEditor,
    recurrenceEditor: U = le.recurrenceEditor,
    descriptionLabel: C = le.descriptionLabel,
    descriptionEditor: $ = le.descriptionEditor,
    descriptionError: b = le.descriptionError,
    resourceLabel: g = le.resourceLabel,
    resourceEditor: _ = le.resourceEditor
  } = e, W = e.valueGetter(i.start) || /* @__PURE__ */ new Date(), ee = e.valueGetter(i.startTimezone) || c || "", re = e.valueGetter(i.endTimezone) || c || "", B = a.useMemo(() => l.toLanguageString(kr, Q[kr]), [l]), [ae, ue] = a.useState(!!e.valueGetter(i.startTimezone)), [ye, ne] = a.useState(!!e.valueGetter(i.endTimezone)), Ae = a.useCallback(
    (G) => {
      G.value || (e.onChange(i.startTimezone, { value: null }), e.onChange(i.endTimezone, { value: null }), ne(G.value)), ue(G.value);
    },
    [e.onChange, i.startTimezone, i.endTimezone]
  ), he = a.useCallback(
    (G) => {
      G.value || e.onChange(i.endTimezone, { value: null }), ne(G.value);
    },
    [e.onChange]
  ), Me = a.useCallback(
    (G) => G ? void 0 : B,
    [B]
  ), Ee = a.useCallback(
    (G, se) => ae ? Me(se(i.startTimezone)) : void 0,
    [Me, ae, i.startTimezone]
  ), Ge = a.useCallback(
    (G, se) => ae && ye ? Me(se(i.endTimezone)) || Me(se(i.startTimezone)) : void 0,
    [Me, ae, ye, i.startTimezone, i.endTimezone]
  ), H = a.useMemo(
    () => ve("k-scheduler-edit-form", e.className),
    [e.className]
  );
  return /* @__PURE__ */ a.createElement(
    u,
    {
      ref: u === le.as ? r : void 0,
      ...d,
      className: H
    },
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.title,
        component: m,
        editorId: "k-scheduler-editor-title",
        className: "k-form-label"
      },
      l.toLanguageString(cn, Q[cn])
    ), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
      de,
      {
        id: "k-scheduler-editor-title",
        name: i.title,
        field: i.title,
        component: f
      }
    ), e.errors[i.title] && /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.title,
        component: p
      },
      e.errors[i.title]
    ))), /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.start,
        component: h,
        editorId: "k-scheduler-editor-start",
        className: "k-form-label"
      },
      l.toLanguageString(un, Q[un])
    ), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
      de,
      {
        id: "k-scheduler-editor-start",
        name: i.start,
        width: "auto",
        component: k,
        as: e.valueGetter(i.isAllDay) ? Ya : $a,
        timezone: c
      }
    ), e.errors[i.start] && /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.start,
        component: y
      },
      e.errors[i.start]
    ))), /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(
      x,
      {
        className: "k-form-label"
      }
    ), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
      A,
      {
        id: "k-scheduler-editor-set-start-timezone",
        onChange: Ae,
        value: ae
      }
    ), /* @__PURE__ */ a.createElement(
      x,
      {
        className: "k-checkbox-label",
        editorId: "k-scheduler-editor-set-start-timezone"
      },
      l.toLanguageString(yn, Q[yn])
    ))), ae && /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.start,
        component: M,
        className: "k-form-label"
      },
      l.toLanguageString(dn, Q[dn])
    ), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
      de,
      {
        component: D,
        value: ee,
        validator: Ee,
        data: o,
        name: i.startTimezone
      }
    ), e.errors[i.startTimezone] && /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.startTimezone,
        component: I
      },
      e.errors[i.startTimezone]
    ))), /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.end,
        component: O,
        editorId: "k-scheduler-editor-end",
        className: "k-form-label"
      },
      l.toLanguageString(mn, Q[mn])
    ), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
      de,
      {
        id: "k-scheduler-editor-end",
        name: i.end,
        width: "auto",
        component: w,
        as: e.valueGetter(i.isAllDay) ? Ya : $a,
        timezone: c
      }
    ), e.errors[i.end] && /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.end,
        component: v
      },
      e.errors[i.end]
    ))), ae && /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
      z,
      {
        id: "k-scheduler-editor-set-end-timezone",
        onChange: he,
        value: ye
      }
    )), /* @__PURE__ */ a.createElement(
      V,
      {
        editorId: "k-scheduler-editor-set-end-timezone",
        className: "k-form-label"
      },
      l.toLanguageString(gn, Q[gn])
    )), ye && /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.endTimezone,
        component: T,
        className: "k-form-label"
      },
      l.toLanguageString(fn, Q[fn])
    ), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
      de,
      {
        value: re,
        data: o,
        validator: Ge,
        component: F,
        name: i.endTimezone
      }
    ), e.errors[i.endTimezone] && /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.endTimezone,
        component: R
      },
      e.errors[i.endTimezone]
    ))), /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.isAllDay,
        component: Te,
        className: "k-form-label"
      }
    ), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
      de,
      {
        id: "k-is-allday-checkbox",
        name: i.isAllDay,
        component: L
      }
    ), /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.isAllDay,
        field: i.isAllDay,
        editorId: "k-is-allday-checkbox",
        className: "k-checkbox-label",
        component: P
      },
      l.toLanguageString(pn, Q[pn])
    ))), /* @__PURE__ */ a.createElement("div", { className: "k-recurrence-editor" }, /* @__PURE__ */ a.createElement(
      de,
      {
        component: U,
        field: i.recurrenceRule,
        name: i.recurrenceRule,
        start: W
      }
    )), /* @__PURE__ */ a.createElement(we, null, /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.description,
        component: C,
        className: "k-form-label"
      },
      l.toLanguageString(vn, Q[vn])
    ), /* @__PURE__ */ a.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ a.createElement(
      de,
      {
        component: $,
        name: i.description,
        rows: 1,
        id: "k-event-description"
      }
    ), e.errors[i.description] && /* @__PURE__ */ a.createElement(
      de,
      {
        name: i.description,
        component: b
      },
      e.errors[i.description]
    ))), (s || []).map((G) => /* @__PURE__ */ a.createElement(we, { key: G.field }, /* @__PURE__ */ a.createElement(
      de,
      {
        name: G.field,
        component: g,
        className: "k-form-label"
      }
    ), /* @__PURE__ */ a.createElement(Te, { className: "k-form-label" }, G.name), /* @__PURE__ */ a.createElement(
      de,
      {
        name: G.field,
        component: _,
        resource: G,
        multiple: G.multiple,
        data: G.data,
        textField: G.textField,
        valueField: G.valueField,
        colorField: G.colorField
      }
    ))))
  );
}), le = {
  as: a.forwardRef((e, t) => /* @__PURE__ */ a.createElement(
    uc,
    {
      ref: t,
      id: e.id,
      style: e.style,
      tabIndex: e.tabIndex,
      className: e.className,
      horizontal: e.horizontal,
      children: e.children
    }
  )),
  titleLabel: Te,
  titleError: jt,
  titleEditor: mc,
  startLabel: Te,
  startError: jt,
  startEditor: ll,
  startTimezoneLabel: Te,
  startTimezoneError: jt,
  startTimezoneEditor: al,
  startTimezoneCheckedLabel: Te,
  startTimezoneCheckedEditor: ba,
  endLabel: Te,
  endError: jt,
  endEditor: ll,
  endTimezoneLabel: Te,
  endTimezoneError: jt,
  endTimezoneEditor: al,
  endTimezoneCheckedLabel: Te,
  endTimezoneCheckedEditor: ba,
  allDayLabel: Te,
  allDayEditor: ba,
  recurrenceEditor: $i,
  descriptionLabel: Te,
  descriptionEditor: fc,
  descriptionError: jt,
  resourceLabel: Te,
  resourceEditor: Bf
};
Gi.displayName = "KendoReactSchedulerFormEditor";
const Co = a.forwardRef((e, t) => {
  const {
    onCancel: r,
    onClose: n,
    onSubmit: o,
    editor: l,
    dialog: i = il.dialog,
    validator: s = il.validator,
    ...c
  } = e, u = a.useRef(null);
  a.useImperativeHandle(u, () => ({ props: e })), a.useImperativeHandle(t, () => u.current);
  const d = He(), m = $e(), p = a.useMemo(() => d.toLanguageString(kr, Q[kr]), [d]), f = a.useMemo(() => d.toLanguageString(Mn, Q[Mn]), [d]), h = a.useMemo(() => d.toLanguageString(ln, Q[ln]), [d]), y = a.useMemo(() => d.toLanguageString(Tr, Q[Tr]), [d]), k = a.useMemo(() => d.toLanguageString(sn, Q[sn]), [d]), M = a.useMemo(() => d.toLanguageString(Sn, Q[Sn]), [d]), I = a.useCallback(
    (T) => {
      r && r.call(void 0, { value: null, syntheticEvent: T, target: u.current });
    },
    [r]
  ), D = a.useCallback(
    ({ syntheticEvent: T }) => {
      n && n.call(void 0, { value: null, syntheticEvent: T, target: u.current });
    },
    [n]
  ), x = a.useCallback(
    (T, R) => {
      o && o.call(void 0, { value: T, syntheticEvent: R, target: u.current });
    },
    [o]
  ), A = a.useCallback(
    (T, R) => T && R(m.end) && T.getTime() > R(m.end).getTime() ? M : void 0,
    [m, M]
  ), O = a.useCallback(
    (T, R) => T && R(m.start) && T.getTime() < R(m.start).getTime() ? f : void 0,
    [m, f]
  ), v = a.useCallback(
    (T) => T ? void 0 : p,
    [p]
  ), w = a.useCallback(
    (T, R) => {
      let F = {};
      F[m.start] = [
        v(R(m.start)),
        A(R(m.start), R)
      ].filter(Boolean).reduce((z, P) => z || P, ""), F[m.end] = [
        v(R(m.start)),
        O(R(m.start), R)
      ].filter(Boolean).reduce((z, P) => z || P, "");
      const V = s(T, R);
      return { ...F, ...V };
    },
    [O, m.end, m.start, v, A, s]
  );
  return xn ? aa.createPortal(
    /* @__PURE__ */ a.createElement(
      dc,
      {
        initialValues: e.dataItem,
        onSubmit: x,
        validator: w,
        render: (T) => /* @__PURE__ */ a.createElement(
          i,
          {
            title: k,
            minWidth: 400,
            onClose: D,
            className: "k-scheduler-edit-dialog"
          },
          /* @__PURE__ */ a.createElement(Gi, { ...T, as: l }),
          /* @__PURE__ */ a.createElement(Fn, { layout: "start" }, /* @__PURE__ */ a.createElement(
            xe,
            {
              themeColor: "primary",
              disabled: !T.allowSubmit,
              onClick: T.onSubmit,
              icon: "save",
              svgIcon: ac
            },
            h
          ), /* @__PURE__ */ a.createElement(
            xe,
            {
              onClick: I,
              icon: "cancel",
              svgIcon: nc
            },
            y
          ))
        ),
        ...c
      }
    ),
    document && document.body
  ) : null;
}), il = {
  dialog: zn,
  validator: () => ({})
};
Co.displayName = "KendoReactSchedulerForm";
const Zf = (e, t) => {
  const { _ref: r } = e, n = a.useRef(null), o = a.useRef(null), [, l] = qt();
  return a.useImperativeHandle(n, () => ({ element: o.current, props: e })), a.useImperativeHandle(t, () => n.current), a.useImperativeHandle(r, () => n.current), a.useEffect(
    () => (l({
      type: jr.add,
      item: n
    }), () => {
      l({
        type: jr.remove,
        item: n
      });
    })
  ), {
    slot: n,
    element: o
  };
}, Bi = a.forwardRef((e, t) => {
  const {
    // Focus
    onFocus: r,
    onBlur: n,
    // Mouse
    onClick: o,
    onMouseEnter: l,
    onMouseLeave: i,
    onMouseOut: s,
    onMouseOver: c,
    onDoubleClick: u,
    // Keyboard
    onKeyDown: d,
    onKeyPress: m,
    onKeyUp: p
  } = e, { slot: f, element: h } = Zf(e, t), y = e.tabIndex !== void 0 ? e.tabIndex === null ? void 0 : e.tabIndex : e.selected ? 0 : -1, k = a.useMemo(
    () => {
      const z = e.isWorkHour ?? sl.isWorkHour, P = e.isWorkDay ?? sl.isWorkDay;
      return ve(
        e.className,
        "k-scheduler-cell k-slot-cell",
        {
          "k-nonwork-hour": !z || !P,
          "k-selected": e.selected
        }
      );
    },
    [e.className, e.selected, e.isWorkHour, e.isWorkDay]
  ), M = a.useMemo(
    () => ({
      userSelect: "none",
      ...e.style
    }),
    [e.style]
  ), I = a.useCallback(
    (z) => {
      r && r.call(void 0, {
        syntheticEvent: z,
        target: f.current
      });
    },
    [r, f]
  ), D = a.useCallback(
    (z) => {
      n && n.call(void 0, {
        syntheticEvent: z,
        target: f.current
      });
    },
    [n, f]
  ), x = a.useCallback(
    (z) => {
      o && o.call(void 0, {
        syntheticEvent: z,
        target: f.current
      });
    },
    [o, f]
  ), A = a.useCallback(
    (z) => {
      c && c.call(void 0, {
        syntheticEvent: z,
        target: f.current
      });
    },
    [c, f]
  ), O = a.useCallback(
    (z) => {
      s && s.call(void 0, {
        syntheticEvent: z,
        target: f.current
      });
    },
    [s, f]
  ), v = a.useCallback(
    (z) => {
      l && l.call(void 0, {
        syntheticEvent: z,
        target: f.current
      });
    },
    [l, f]
  ), w = a.useCallback(
    (z) => {
      i && i.call(void 0, {
        syntheticEvent: z,
        target: f.current
      });
    },
    [i, f]
  ), T = a.useCallback(
    (z) => {
      u && u.call(void 0, {
        syntheticEvent: z,
        target: f.current
      });
    },
    [u, f]
  ), R = a.useCallback(
    (z) => {
      d && d.call(void 0, {
        syntheticEvent: z,
        target: f.current
      });
    },
    [d, f]
  ), F = a.useCallback(
    (z) => {
      m && m.call(void 0, {
        syntheticEvent: z,
        target: f.current
      });
    },
    [m, f]
  ), V = a.useCallback(
    (z) => {
      p && p.call(void 0, {
        syntheticEvent: z,
        target: f.current
      });
    },
    [p, f]
  );
  return /* @__PURE__ */ a.createElement(
    "div",
    {
      ref: h,
      id: e.id,
      style: M,
      className: k,
      tabIndex: y,
      "aria-selected": e.selected || void 0,
      onFocus: I,
      onBlur: D,
      onClick: x,
      onMouseEnter: v,
      onMouseLeave: w,
      onMouseOver: A,
      onMouseOut: O,
      onDoubleClick: T,
      onKeyDown: R,
      onKeyPress: F,
      onKeyUp: V,
      "data-slot": !0,
      "data-slot-allday": e.isAllDay,
      "data-slot-start": e.start.getTime(),
      "data-slot-end": e.end.getTime(),
      "data-slot-group": e.group.index,
      "data-slot-range": e.range.index,
      "data-slot-index": e.index
    },
    e.children
  );
}), sl = {
  isWorkHour: !0,
  isWorkDay: !0
};
Bi.displayName = "KendoReactSchedulerSlot";
const Ki = a.forwardRef((e, t) => {
  const { slot: r, _ref: n, ...o } = e, l = r || cl.slot, i = a.useRef(null), s = a.useRef(null);
  return a.useImperativeHandle(i, () => ({ props: e })), a.useImperativeHandle(n, () => s.current), a.useImperativeHandle(t, () => i.current), Qm(s, e.expandable ?? cl.expandable), /* @__PURE__ */ a.createElement(l, { ...o, _ref: s });
}), cl = {
  slot: Bi,
  expandable: !1
};
Ki.displayName = "KendoReactSchedulerViewSlot";
const Or = a.forwardRef((e, t) => {
  const {
    _ref: r,
    onDataAction: n,
    viewSlot: o,
    form: l,
    formItem: i,
    onFormItemChange: s,
    ...c
  } = e, [u, d] = a.useState(e.tabIndex), m = a.useRef(null), p = a.useRef(null);
  a.useImperativeHandle(p, () => ({ props: e })), a.useImperativeHandle(t, () => p.current), a.useImperativeHandle(r, () => m.current);
  const f = nr(e.editable), h = $e(), [y] = qt(), [k] = zr(), [M, I] = Vm(), [, D] = Oi(), x = l || ul.form, A = o || ul.viewSlot, [O, v] = Oe(null, i, e.onFormItemChange), w = M.some((C) => !!(C.current && C.current.props.start.getTime() === e.start.getTime() && C.current.props.end.getTime() === e.end.getTime() && C.current.props.index === e.index && C.current.props.group.index === e.group.index && C.current.props.range.index === e.range.index && C.current.props.isAllDay === e.isAllDay)), T = a.useCallback(
    () => {
      const C = {};
      if (J(C, h.start, new Date(e.start.getTime())), J(C, h.end, new Date(e.end.getTime())), J(C, h.isAllDay, e.isAllDay), e.group.resources.length)
        for (let $ = 0; $ < e.group.resources.length; $++) {
          const b = e.group.resources[$];
          if (cm(e.group.resources)) {
            const g = Z(e.group.resources[$], b.valueField);
            J(C, b.field, b.multiple ? [g] : g);
          } else
            J(C, b.field, b.multiple ? [] : void 0);
        }
      return C;
    },
    [
      h.start,
      h.end,
      h.isAllDay,
      e.start,
      e.end,
      e.isAllDay,
      e.group.resources
    ]
  ), R = a.useCallback(
    (C) => {
      f.select && I({
        type: Eo.select,
        slot: m
      }, C.syntheticEvent), e.onFocus && e.onFocus.call(void 0, C);
    },
    [
      I,
      f.select,
      e.onFocus
    ]
  ), F = a.useCallback(
    (C) => {
      if (f.add) {
        const $ = T();
        v($, C);
      }
      e.onDoubleClick && e.onDoubleClick.call(void 0, C);
    },
    [
      T,
      f.add,
      e.onDoubleClick,
      v
    ]
  ), V = a.useCallback(
    (C) => {
      let $;
      switch (C.syntheticEvent.keyCode) {
        case Ke.left:
          if (!y)
            return;
          C.syntheticEvent.preventDefault(), D({ type: We.left, slot: m }, C.syntheticEvent);
          break;
        case Ke.right:
          if (!y)
            return;
          C.syntheticEvent.preventDefault(), D({ type: We.right, slot: m }, C.syntheticEvent);
          break;
        case Ke.up:
          if (!y)
            return;
          C.syntheticEvent.preventDefault(), D({ type: We.up, slot: m }, C.syntheticEvent);
          break;
        case Ke.down:
          if (!y)
            return;
          C.syntheticEvent.preventDefault(), D({ type: We.down, slot: m }, C.syntheticEvent);
          break;
        case Ke.enter: {
          if (!y || !f.add)
            return;
          const b = T();
          v(b);
          break;
        }
        case Ke.tab:
          $ = gm(C.target);
          break;
      }
      $ && (C.syntheticEvent.preventDefault(), $.element && $.element.focus());
    },
    [T, D, f.add, v, y]
  ), z = a.useCallback(
    (C) => {
      n && n.call(
        void 0,
        {
          type: Ue.create,
          series: !1,
          dataItem: C.value
        },
        C
      ), v(null, C.syntheticEvent);
    },
    [
      n,
      v
    ]
  ), P = a.useCallback(
    (C) => {
      v(null, C.syntheticEvent);
    },
    [v]
  ), L = a.useCallback(
    (C) => {
      v(null, C);
    },
    [v]
  ), U = a.useCallback(
    (C, $) => {
      v && v(C, $);
    },
    [v]
  );
  return a.useEffect(() => {
    const C = y.length && y[0].current === m.current;
    d(e.tabIndex !== void 0 ? e.tabIndex === null ? void 0 : e.tabIndex : M.length === 0 && C && k.length === 0 ? 0 : void 0);
  }, [k, e.tabIndex, M.length, y]), /* @__PURE__ */ a.createElement(
    Ym,
    {
      props: e,
      form: [O, U]
    },
    /* @__PURE__ */ a.createElement(
      A,
      {
        ...c,
        _ref: m,
        selected: w,
        tabIndex: u,
        onFocus: R,
        onDoubleClick: F,
        onKeyDown: V
      }
    ),
    O && /* @__PURE__ */ a.createElement(
      x,
      {
        dataItem: O,
        onSubmit: z,
        onClose: L,
        onCancel: P
      }
    )
  );
}), ul = {
  viewSlot: Ki,
  form: Co
};
Or.displayName = "KendoReactSchedulerEditSlot";
const To = a.forwardRef((e, t) => {
  const {
    isRemove: r,
    onClose: n,
    onSeriesClick: o,
    onOccurrenceClick: l
  } = e, i = a.useRef(null);
  a.useImperativeHandle(i, () => ({ props: e })), a.useImperativeHandle(t, () => i.current);
  const s = He(), c = (w) => s.toLanguageString(w, Q[w]), u = c(ii), d = c(si), m = c(ci), p = c(ui), f = c(Ti), h = c(ki), y = c(bi), k = c(Ci), M = r ? y : p, I = r ? k : m, D = r ? f : u, x = r ? h : d, A = a.useCallback(
    ({ syntheticEvent: w }) => {
      n && n.call(void 0, { syntheticEvent: w, value: null, target: i.current });
    },
    [n]
  ), O = a.useCallback(
    (w) => {
      o && o.call(void 0, { syntheticEvent: w, value: null, target: i.current });
    },
    [o]
  ), v = a.useCallback(
    (w) => {
      l && l.call(void 0, { syntheticEvent: w, value: null, target: i.current });
    },
    [l]
  );
  return xn ? aa.createPortal(
    /* @__PURE__ */ a.createElement(zn, { title: M, onClose: A }, I, /* @__PURE__ */ a.createElement(Fn, null, /* @__PURE__ */ a.createElement(xe, { onClick: v }, D), /* @__PURE__ */ a.createElement(xe, { onClick: O }, x))),
    document && document.body
  ) : null;
});
To.displayName = "KendoReactSchedulerSchedulerOccurrenceDialog";
const ko = a.forwardRef((e, t) => {
  const { onClose: r, onCancel: n, onConfirm: o } = e, l = a.useRef(null);
  a.useImperativeHandle(l, () => ({ props: e })), a.useImperativeHandle(t, () => l.current);
  const i = He(), s = i.toLanguageString(Tr, Q[Tr]), c = i.toLanguageString(En, Q[En]), u = i.toLanguageString(Dn, Q[Dn]), d = i.toLanguageString(Cn, Q[Cn]), m = a.useCallback(
    ({ syntheticEvent: h }) => {
      if (!r)
        return;
      const y = {
        syntheticEvent: h,
        value: null,
        target: l.current
      };
      r.call(void 0, y);
    },
    [r]
  ), p = a.useCallback(
    (h) => {
      n && n.call(void 0, { syntheticEvent: h, value: null });
    },
    [n]
  ), f = a.useCallback(
    (h) => {
      o && o.call(void 0, { syntheticEvent: h, value: null });
    },
    [o]
  );
  return xn ? aa.createPortal(
    /* @__PURE__ */ a.createElement(zn, { title: d, onClose: m }, u, /* @__PURE__ */ a.createElement(Fn, null, /* @__PURE__ */ a.createElement(xe, { onClick: p }, s), /* @__PURE__ */ a.createElement(xe, { onClick: f }, c))),
    document && document.body
  ) : null;
});
ko.displayName = "KendoReactSchedulerRemoveDialog";
const Lr = a.forwardRef((e, t) => {
  const {
    // Focus
    onFocus: r,
    onBlur: n,
    // Mouse
    onMouseDown: o,
    onClick: l,
    onMouseUp: i,
    onMouseOut: s,
    onMouseOver: c,
    onMouseEnter: u,
    onMouseLeave: d,
    onDoubleClick: m,
    onRemoveClick: p,
    // Keyboard
    onKeyUp: f,
    onKeyDown: h,
    onKeyPress: y,
    // Drag
    onPress: k,
    onDrag: M,
    onRelease: I,
    // Resize
    onResizePress: D,
    onResizeEndDrag: x,
    onResizeRelease: A,
    onResizeStartDrag: O
  } = e, { item: v, element: w } = ef(e, t), T = xr(w), R = a.useRef(null), F = a.useRef(null), V = a.useRef(null), z = a.useRef(null), P = nr(e.editable), L = Qe(), U = He().toLanguageString(Cr, Q[Cr]), C = e.group.resources.find((K) => !!(K.colorField && K[K.colorField] !== "" && K[K.colorField] !== void 0)), $ = C && C.colorField && C[C.colorField], b = e.tabIndex !== void 0 ? e.tabIndex === null ? void 0 : e.tabIndex : e.selected ? 0 : -1, g = a.useMemo(
    () => ve(
      {
        "k-event": !e.resizeHint,
        "k-selected": e.selected && P.select,
        "k-event-drag-hint": e.dragHint,
        "k-scheduler-marquee": e.resizeHint,
        "k-marquee": e.resizeHint,
        "k-first": e.resizeHint && !e.tail,
        "k-last": e.resizeHint && !e.head
      },
      e.className
    ),
    [
      e.resizeHint,
      e.selected,
      e.dragHint,
      e.tail,
      e.head,
      e.className,
      P.select
    ]
  ), _ = a.useMemo(
    () => `${um(L, e.zonedStart, e.zonedEnd, e.isAllDay)}, ${e.title}`,
    [L, e.isAllDay, e.title, e.zonedEnd, e.zonedStart]
  ), W = a.useMemo(
    () => ({
      cursor: "pointer",
      userSelect: "none",
      borderColor: e.resizeHint ? void 0 : $,
      backgroundColor: e.resizeHint ? void 0 : $,
      touchAction: "none",
      ...e.style
    }),
    [$, e.style, e.resizeHint]
  ), ee = a.useCallback(
    (K) => {
      r && r.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [r, v]
  ), re = a.useCallback(
    (K) => {
      n && n.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [n, v]
  ), B = a.useCallback(
    (K) => {
      o && o.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [o, v]
  ), ae = a.useCallback(
    (K) => {
      l && l.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [l, v]
  ), ue = a.useCallback(
    (K) => {
      i && i.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [i, v]
  ), ye = a.useCallback(
    (K) => {
      c && c.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [c, v]
  ), ne = a.useCallback(
    (K) => {
      s && s.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [s, v]
  ), Ae = a.useCallback(
    (K) => {
      u && u.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [u, v]
  ), he = a.useCallback(
    (K) => {
      d && d.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [d, v]
  ), Me = a.useCallback(
    (K) => {
      m && m.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [m, v]
  ), Ee = a.useCallback(
    (K) => {
      p && p.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [p, v]
  ), Ge = a.useCallback(
    (K) => {
      h && h.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [h, v]
  ), H = a.useCallback(
    (K) => {
      y && y.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [y, v]
  ), G = a.useCallback(
    (K) => {
      f && f.call(void 0, {
        syntheticEvent: K,
        target: v.current
      });
    },
    [f, v]
  ), se = a.useCallback(
    (K) => {
      k && k.call(void 0, {
        dragEvent: K,
        target: v.current
      });
    },
    [k, v]
  ), oe = a.useCallback(
    (K) => {
      M && M.call(void 0, {
        dragEvent: K,
        target: v.current
      });
    },
    [M, v]
  ), ce = a.useCallback(
    (K) => {
      I && I.call(void 0, {
        dragEvent: K,
        target: v.current
      });
    },
    [I, v]
  ), De = a.useCallback(
    (K) => {
      D && D.call(void 0, {
        dragEvent: K,
        target: v.current
      });
    },
    [D, v]
  ), nt = a.useCallback(
    (K) => {
      O && O.call(void 0, {
        dragEvent: K,
        target: v.current
      });
    },
    [O, v]
  ), Et = a.useCallback(
    (K) => {
      x && x.call(void 0, {
        dragEvent: K,
        target: v.current
      });
    },
    [x, v]
  ), Dt = a.useCallback(
    (K) => {
      A && A.call(void 0, {
        dragEvent: K,
        target: v.current
      });
    },
    [A, v]
  );
  return ur(w, {
    onPress: se,
    onDrag: oe,
    onRelease: ce
  }), ur(R, {
    onPress: De,
    onDrag: Et,
    onRelease: Dt
  }), ur(F, {
    onPress: De,
    onDrag: nt,
    onRelease: Dt
  }), ur(V, {
    onPress: De,
    onDrag: nt,
    onRelease: Dt
  }), ur(z, {
    onPress: De,
    onDrag: Et,
    onRelease: Dt
  }), /* @__PURE__ */ a.createElement(
    "div",
    {
      ref: w,
      id: e.id,
      style: W,
      tabIndex: b,
      className: g,
      role: "button",
      "aria-label": _,
      onFocus: ee,
      onBlur: re,
      onMouseUp: ue,
      onMouseDown: B,
      onClick: ae,
      onMouseOver: ye,
      onMouseOut: ne,
      onMouseEnter: Ae,
      onMouseLeave: he,
      onDoubleClick: Me,
      onKeyDown: Ge,
      onKeyPress: H,
      onKeyUp: G,
      "data-group-index": e.group.index,
      "data-range-index": e.range.index
    },
    e.children,
    !e.resizeHint && /* @__PURE__ */ a.createElement("span", { className: "k-event-actions" }, P.remove && /* @__PURE__ */ a.createElement(
      "a",
      {
        tabIndex: -1,
        "aria-hidden": "true",
        className: "k-link k-event-delete",
        title: U,
        "aria-label": U,
        onClick: Ee
      },
      /* @__PURE__ */ a.createElement(ze, { name: "x", icon: yl })
    ), e.head && /* @__PURE__ */ a.createElement(
      ze,
      {
        name: T === "rtl" ? "caret-alt-left" : "caret-alt-right",
        icon: T === "rtl" ? Pt : Wt
      }
    )),
    P.resize && e.vertical && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("span", { className: "k-resize-handle k-resize-n", ref: V }), /* @__PURE__ */ a.createElement("span", { className: "k-resize-handle k-resize-s", ref: z })),
    P.resize && !e.vertical && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("span", { className: "k-resize-handle k-resize-w", ref: F }), /* @__PURE__ */ a.createElement("span", { className: "k-resize-handle k-resize-e", ref: R })),
    e.resizeHint && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      "div",
      {
        className: "k-marquee-color",
        style: { borderColor: $, backgroundColor: $ }
      }
    ), /* @__PURE__ */ a.createElement("div", { className: "k-marquee-text" }, !e.tail && /* @__PURE__ */ a.createElement("div", { className: "k-label-top" }, L.formatDate(e.zonedStart, e.format)), !e.head && /* @__PURE__ */ a.createElement("div", { className: "k-label-bottom" }, L.formatDate(e.zonedEnd, e.format))))
  );
});
Lr.displayName = "KendoReactSchedulerItem";
const ta = a.forwardRef((e, t) => {
  const r = a.useMemo(
    () => ve(
      "k-event-template",
      e.className
    ),
    [e.className]
  );
  return /* @__PURE__ */ a.createElement("div", { ref: t, ...e, className: r });
}), Xf = 1, da = a.forwardRef((e, t) => {
  const { item: r, _ref: n, itemRef: o, ...l } = e, i = a.useRef(), s = a.useRef(null), c = a.useRef(null), u = a.useRef(null), d = nr(e.editable);
  a.useImperativeHandle(c, () => ({ props: e, element: s.current && s.current.element })), a.useImperativeHandle(t, () => c.current), a.useImperativeHandle(n, () => s.current), a.useImperativeHandle(o, () => s.current);
  const m = r || jf.item, p = Qe(), [f] = zr(), [h] = qt(), y = Fr(), [k, M] = a.useState(!0), [I, D] = a.useState(!1), [x, A] = a.useState(0), O = xr(y), v = a.useMemo(
    () => e.isAllDay ? p.toString(e.zonedStart, "t") : p.format("{0:t} - {1:t}", e.zonedStart, e.zonedEnd),
    [p, e.isAllDay, e.zonedEnd, e.zonedStart]
  ), w = a.useMemo(() => `(${v}): ${e.title}`, [v, e.title]), T = (U, C) => {
    let $ = 1;
    return U.forEach((b) => {
      const g = C.filter((_) => F(b.current.props, _.props));
      g.length > $ && ($ = g.length);
    }), $;
  }, R = (U, C) => U.map(($) => C.filter((b) => F($.current.props, b.props))), F = (U, C) => Ye(U.start, U.end, C.start, C.end) && U.group.index === C.group.index && U.range.index === C.range.index && (e.ignoreIsAllDay || U.isAllDay === C.isAllDay), V = () => {
    const U = (h || []).filter((b) => b.current && F(b.current.props, e));
    if (U.length === 0) {
      M(!1);
      return;
    }
    const C = xt(U);
    if (!C.current || !s.current)
      return;
    const $ = Ze(C.current.element);
    rr(s.current.element, $);
  }, z = () => {
    const U = s.current && s.current.element;
    if (!U)
      return;
    const C = (h || []).filter((ue) => ue.current && F(ue.current.props, e)), $ = [], b = [], g = [];
    (f || []).forEach((ue) => {
      ue.current && (ue.current.props.dragHint ? b.push(ue.current) : ue.current.props.resizeHint ? g.push(ue.current) : $.push(ue.current));
    });
    const _ = e.dragHint || e.resizeHint ? ti(s.current, e.dragHint ? b : g, C, e.ignoreIsAllDay) : e.order || 0;
    let W = e.dragHint || e.resizeHint ? T(C, e.dragHint ? b : g) : T(C, $);
    const ee = R(C, $);
    let re = 0;
    const B = Ze(U);
    if (ee.forEach((ue) => {
      let ye = 0;
      ue.forEach((ne) => {
        Ye(ne.props.start, ne.props.end, e.start, e.end) && !(e.dragHint || e.resizeHint) && ne.props._maxSiblingsPerSlot && ne.props._maxSiblingsPerSlot > W && ne.element !== U && (W = ne.props._maxSiblingsPerSlot);
        const Ae = Ze(ne.element);
        ne.props.order !== null && ne.props.order < _ && (ye = Ae.top + Ae.height - B.top - Re * _ + Xf);
      }), ye > re && (re = ye);
    }), C.length === 0) {
      M(!1);
      return;
    }
    const ae = d.add ? 20 : 0;
    B.width = e.vertical ? B.width / W - Re - ae / W : B.width * C.length - Re, B.height = e.vertical ? B.height * C.length - Re : (e.resizeHint || e.dragHint) && W <= 1 ? B.height : e.style && e.style.height ? e.style.height : 25, B.left = e.vertical ? B.left + _ * B.width + Re * _ : B.left, B.top = e.vertical ? B.top : B.top + re + Re * _, A(W), rr(U, B), D(!0), M(!0);
  }, P = a.useCallback(
    (U) => {
      const C = U && U[0], $ = u.current;
      i.current !== void 0 && window.cancelAnimationFrame(i.current), $ && C && ($.width !== C.contentRect.width || $.height !== C.contentRect.height) && (i.current = window.requestAnimationFrame(() => {
        V(), z();
      })), u.current = { width: C.contentRect.width, height: C.contentRect.height };
    },
    [V, z]
  );
  a.useEffect(V), a.useEffect(z);
  const L = s.current && s.current.element ? s.current.element.closest(".k-scheduler-layout") : null;
  return Hi({
    element: L,
    selector: ".k-resource-row",
    horizontalAttribute: "data-depth-index",
    verticalAttribute: "data-resource-index",
    applyTo: ".k-resource-cell",
    syncHeight: e.isLast
  }), a.useEffect(
    () => {
      if (!y.current)
        return;
      const U = window.ResizeObserver, C = U && new U(P);
      return C && C.observe(y.current), () => {
        C && C.disconnect();
      };
    },
    [P, y]
  ), /* @__PURE__ */ a.createElement(
    m,
    {
      ...l,
      _ref: s,
      _maxSiblingsPerSlot: x,
      itemRef: s,
      style: {
        visibility: I ? void 0 : "hidden",
        display: k ? void 0 : "none",
        ...e.style
      }
    },
    !e.resizeHint && /* @__PURE__ */ a.createElement("span", { className: "k-event-actions" }, e.tail && /* @__PURE__ */ a.createElement(
      ze,
      {
        name: O === "rtl" ? "caret-alt-right" : "caret-alt-left",
        icon: O === "rtl" ? Wt : Pt
      }
    ), e.isRecurring && !e.isException && /* @__PURE__ */ a.createElement(ze, { name: "arrow-rotate-cw", icon: _n }), !e.isRecurring && e.isException && /* @__PURE__ */ a.createElement(ze, { name: "arrows-no-repeat", icon: hl })),
    !e.resizeHint && /* @__PURE__ */ a.createElement("div", { title: w }, !e.isAllDay && /* @__PURE__ */ a.createElement(ta, { className: "k-event-template k-event-time " }, w), /* @__PURE__ */ a.createElement(ta, { className: "k-event-template" }, e.title))
  );
}), jf = {
  item: Lr
};
da.displayName = "KendoReactSchedulerViewItem";
const Vi = (e) => {
  const t = Ui(), { timezone: r } = at(), n = Vt(), o = $e(), l = At(), [i] = qt(), s = e.viewItem || Jf.viewItem, c = a.useMemo(
    () => or([e.dataItem], { dateRange: l, fields: o, timezone: r }),
    [e.dataItem, l, o, r]
  ), u = a.useMemo(
    () => Bt(c, { timezone: r }, { groups: n, ranges: t }),
    [c, r, n, t]
  ), d = (i || []).map((m) => m.current.props);
  return Gt(u, d), /* @__PURE__ */ a.createElement(a.Fragment, null, u.map((m, p) => /* @__PURE__ */ a.createElement(
    s,
    {
      key: p,
      ...m,
      item: e.item,
      dragHint: !0,
      vertical: e.vertical,
      ignoreIsAllDay: e.ignoreIsAllDay
    }
  )));
}, Jf = {
  viewItem: da,
  item: Lr
};
Vi.displayName = "KendoReactSchedulerDrag";
const qi = (e) => {
  const t = Ui(), { timezone: r } = at(), n = Vt(), o = $e(), l = At(), [i] = qt(), s = e.viewItem || dl.viewItem, c = a.useMemo(
    () => or([e.dataItem], { dateRange: l, fields: o, timezone: r }),
    [e.dataItem, l.start.getTime(), l.end.getTime(), o, r]
  ), u = a.useMemo(
    () => Bt(c, { timezone: r }, { groups: n, ranges: t }),
    [c, r, n, t]
  ), d = (i || []).map((m) => m.current.props);
  return Gt(u, d), /* @__PURE__ */ a.createElement(a.Fragment, null, u.map((m, p) => /* @__PURE__ */ a.createElement(
    s,
    {
      key: p,
      ...m,
      format: e.format,
      item: e.item ?? dl.item,
      resizeHint: !0,
      vertical: e.vertical,
      ignoreIsAllDay: e.ignoreIsAllDay
    }
  )));
}, dl = {
  viewItem: da,
  item: Lr
};
qi.displayName = "KendoReactSchedulerResize";
var et = /* @__PURE__ */ ((e) => (e.set = "FORM_ITEM_SET", e.setMaster = "FORM_ITEM_SET_MASTER", e.reset = "FORM_ITEM_RESET", e.complete = "FORM_ITEM_COMPLETE", e))(et || {});
const Qf = (e, t) => {
  const [r, n] = Oe(...t), o = $e(), [l] = ar();
  return [r, n, (i, s) => {
    let c;
    switch (i.type) {
      case "FORM_ITEM_SET":
        c = i.payload;
        break;
      case "FORM_ITEM_RESET":
        c = null;
        break;
      case "FORM_ITEM_SET_MASTER":
        c = ie(St(i.payload, o, l));
        break;
      case "FORM_ITEM_COMPLETE":
        e.onDataAction && r && (e.onDataAction.call(void 0, {
          type: Ue.update,
          series: e.series,
          dataItem: i.payload
        }), c = null);
        break;
      default:
        c = r;
        break;
    }
    n(c, s);
  }];
};
var Ce = /* @__PURE__ */ ((e) => (e.set = "SHOW_OCCURRENCE_DIALOG_SET", e.open = "SHOW_OCCURRENCE_DIALOG_OPEN", e.close = "SHOW_OCCURRENCE_DIALOG_CLOSE", e.reset = "SHOW_OCCURRENCE_DIALOG_RESET", e.toggle = "SHOW_OCCURRENCE_DIALOG_TOGGLE", e))(Ce || {});
const ep = (e, t) => {
  switch (t.type) {
    case "SHOW_OCCURRENCE_DIALOG_RESET":
      return !1;
    case "SHOW_OCCURRENCE_DIALOG_SET":
      return t.payload;
    case "SHOW_OCCURRENCE_DIALOG_OPEN":
      return !0;
    case "SHOW_OCCURRENCE_DIALOG_CLOSE":
      return !1;
    case "SHOW_OCCURRENCE_DIALOG_TOGGLE":
      return !e;
    default:
      return e;
  }
}, tp = (e, t, r) => {
  const [n, o] = Oe(e, t, r);
  return [n, o, (l) => {
    const i = ep(n, l);
    o(i);
  }];
};
var pt = /* @__PURE__ */ ((e) => (e.set = "REMOVE_ITEM_SET", e.reset = "REMOVE_ITEM_RESET", e.complete = "REMOVE_ITEM_COMPLETE", e))(pt || {});
const rp = (e, t) => {
  const [r, n] = Oe(...t);
  return [r, n, (o) => {
    let l;
    switch (o.type) {
      case "REMOVE_ITEM_SET":
        l = o.payload;
        break;
      case "REMOVE_ITEM_RESET":
        l = null;
        break;
      case "REMOVE_ITEM_COMPLETE":
        e.onDataAction && r && e.onDataAction.call(void 0, {
          type: Ue.remove,
          series: e.series,
          dataItem: r
        }), l = null;
        break;
      default:
        l = r;
        break;
    }
    n(l);
  }];
};
var ct = /* @__PURE__ */ ((e) => (e.set = "SHOW_REMOVE_DIALOG_SET", e.open = "SHOW_REMOVE_DIALOG_OPEN", e.close = "SHOW_REMOVE_DIALOG_CLOSE", e.reset = "SHOW_REMOVE_DIALOG_RESET", e.toggle = "SHOW_REMOVE_DIALOG_TOGGLE", e))(ct || {});
const ap = (e, t) => {
  switch (t.type) {
    case "SHOW_REMOVE_DIALOG_RESET":
      return !1;
    case "SHOW_REMOVE_DIALOG_SET":
      return t.payload;
    case "SHOW_REMOVE_DIALOG_OPEN":
      return !0;
    case "SHOW_REMOVE_DIALOG_CLOSE":
      return !1;
    case "SHOW_REMOVE_DIALOG_TOGGLE":
      return !e;
    default:
      return e;
  }
}, np = (e, t, r) => {
  const [n, o] = Oe(e, t, r);
  return [n, o, (l) => {
    const i = ap(n, l);
    o(i);
  }];
};
var be = /* @__PURE__ */ ((e) => (e.set = "DRAG_ITEM_SET", e.start = "DRAG_ITEM_START", e.drag = "DRAG_ITEM_DRAG", e.complete = "DRAG_ITEM_COMPLETE", e.completeOccurrence = "DRAG_ITEM_COMPLETE_OCCURRENCE", e.completeSeries = "DRAG_ITEM_COMPLETE_SERIES", e.reset = "DRAG_ITEM_RESET", e.dragSelected = "DRAG_ITEM_DRAG_SELECTED", e))(be || {});
const op = (e, t) => {
  const r = a.useRef(0), n = a.useRef(0), o = a.useRef(0), l = a.useRef(null), [i, s] = Oe(...t), [c] = go(), u = $e(), d = Vt();
  return [i, s, (m) => {
    switch (m.type) {
      case "DRAG_ITEM_SET": {
        s(m.payload);
        break;
      }
      case "DRAG_ITEM_RESET": {
        s(null);
        break;
      }
      case "DRAG_ITEM_DRAG_SELECTED": {
        if (Math.abs(n.current - m.payload.x) < 10 && Math.abs(o.current - m.payload.y) < 10)
          return;
        const p = ft(m.payload.x, m.payload.y, 7);
        if (!p || p === l.current)
          return;
        const f = ie(e.dataItem), h = p.getAttribute("data-slot-start"), y = p.getAttribute("data-slot-allday") === "true";
        if (!e.ignoreIsAllDay && y !== e.isAllDay)
          return;
        const k = new Date(Z(f, u.start)), M = Number(h) - k.getTime(), I = c.map((D) => {
          if (!D.current)
            return null;
          const x = ie(D.current.props.dataItem), A = new Date(D.current.props.start.getTime() + M), O = new Date(D.current.props.end.getTime() + M);
          return J(x, u.start, A), J(x, u.end, O), x;
        }).filter(Boolean);
        l.current = p, s([...I]);
        break;
      }
      case "DRAG_ITEM_START": {
        const p = m.payload.x, f = m.payload.y;
        n.current = p, o.current = f;
        const h = ft(p, f, 7);
        if (!h)
          return;
        const y = ie(e.dataItem), k = h.getAttribute("data-slot-start"), M = Z(y, u.start);
        if (k === null)
          return;
        r.current = Number(k) - new Date(M).getTime();
        break;
      }
      case "DRAG_ITEM_DRAG": {
        if (Math.abs(n.current - m.payload.x) < 10 && Math.abs(o.current - m.payload.y) < 10)
          return;
        const p = ft(m.payload.x, m.payload.y, 7);
        if (!p || p === l.current)
          return;
        const f = ie(e.dataItem), h = p.getAttribute("data-slot-start"), y = p.getAttribute("data-slot-group"), k = p.getAttribute("data-slot-allday") === "true";
        if (!e.ignoreIsAllDay && k !== e.isAllDay)
          return;
        const M = new Date(Z(f, u.start)), I = new Date(Z(f, u.end)).getTime() - M.getTime(), D = new Date(Number(h) - Number(r.current)), x = new Date(Number(h) - Number(r.current) + I), A = d.find((O) => O.index === Number(y));
        J(f, u.start, D), J(f, u.end, x), A && d.length > 1 && A.resources.forEach((O) => {
          O.multiple || J(f, O.field, O[O.valueField]);
        }), l.current = p, f && s(f);
        break;
      }
      case "DRAG_ITEM_COMPLETE": {
        s(null), e.onDataAction && i && e.onDataAction.call(void 0, {
          type: Ue.update,
          series: !1,
          dataItem: i
        });
        break;
      }
      case "DRAG_ITEM_COMPLETE_OCCURRENCE": {
        const p = Array.isArray(i) ? i.slice() : ie(i);
        s(null), e.onDataAction && i && e.onDataAction.call(void 0, {
          type: Ue.update,
          series: !1,
          dataItem: p
        });
        break;
      }
      case "DRAG_ITEM_COMPLETE_SERIES": {
        let p;
        if (Array.isArray(i))
          p = i.map((f) => {
            const h = ie(f);
            return J(h, u.start, Z(f, u.start)), J(h, u.end, Z(f, u.end)), h;
          });
        else {
          const f = ie(i);
          J(f, u.start, Z(i, u.start)), J(f, u.end, Z(i, u.end)), p = f;
        }
        s(null), e.onDataAction && p && e.onDataAction.call(void 0, {
          type: Ue.update,
          series: !0,
          dataItem: p
        });
        break;
      }
      default:
        s(i);
        break;
    }
  }];
};
var pe = /* @__PURE__ */ ((e) => (e.set = "RESIZE_ITEM_SET", e.start = "RESIZE_ITEM_START", e.startDrag = "RESIZE_ITEM_START_DRAG", e.startDragSelected = "RESIZE_ITEM_START_DRAG_SELECTED", e.endDrag = "RESIZE_ITEM_END_DRAG", e.endDragSelected = "RESIZE_ITEM_END_DRAG_SELECTED", e.complete = "RESIZE_ITEM_COMPLETE", e.completeOccurrence = "RESIZE_ITEM_COMPLETE_OCCURRENCE", e.completeSeries = "RESIZE_ITEM_COMPLETE_SERIES", e.reset = "RESIZE_ITEM_RESET", e))(pe || {});
const lp = (e, t) => {
  const r = a.useRef(null), [n, o] = Oe(...t), [l] = go(), i = $e();
  return [n, o, (s, c) => {
    let u = n;
    switch (s.type) {
      case "RESIZE_ITEM_SET":
        u = s.payload;
        break;
      case "RESIZE_ITEM_RESET":
        u = null;
        break;
      case "RESIZE_ITEM_START": {
        c.stopPropagation();
        const d = s.payload.x, m = s.payload.y, p = ft(d, m, 7);
        if (!p || p === r.current)
          return;
        const f = p.getAttribute("data-slot-start"), h = new Date(Number(f)), y = ie(e.dataItem);
        if (h >= Z(y, i.end))
          return;
        J(y, i.start, h), r.current = p, u = y;
        break;
      }
      case "RESIZE_ITEM_START_DRAG_SELECTED": {
        c.stopPropagation();
        const d = s.payload.x, m = s.payload.y, p = ie(e.dataItem), f = ft(d, m, 7);
        if (!f || f === r.current)
          return;
        const h = f.getAttribute("data-slot-start"), y = new Date(Z(p, i.start)), k = new Date(Number(h)).getTime() - y.getTime();
        let M = !1;
        const I = l.map((D) => {
          if (!D.current)
            return null;
          const x = ie(D.current.props.dataItem), A = new Date(D.current.props.start.getTime() + k);
          if (A >= Z(x, i.end)) {
            M = !0;
            return;
          }
          return J(x, i.start, A), x;
        }).filter(Boolean);
        M || (u = [...I]);
        break;
      }
      case "RESIZE_ITEM_START_DRAG": {
        const d = s.payload.x, m = s.payload.y, p = ft(d, m, 7);
        if (!p || p === r.current)
          return;
        const f = p.getAttribute("data-slot-start"), h = new Date(Number(f)), y = ie(e.dataItem);
        if (h >= y.end)
          return;
        J(y, i.start, h), r.current = p, u = y;
        break;
      }
      case "RESIZE_ITEM_END_DRAG": {
        const d = s.payload.x, m = s.payload.y, p = ft(d, m, 7);
        if (!p || p === r.current)
          return;
        const f = p.getAttribute("data-slot-end"), h = new Date(Number(f)), y = ie(e.dataItem);
        if (h <= y.start)
          return;
        J(y, i.end, h), r.current = p, u = y;
        break;
      }
      case "RESIZE_ITEM_END_DRAG_SELECTED": {
        c.stopPropagation();
        const d = s.payload.x, m = s.payload.y, p = ie(e.dataItem), f = ft(d, m, 7);
        if (!f || f === r.current)
          return;
        const h = f.getAttribute("data-slot-start"), y = new Date(Z(p, i.end)), k = new Date(Number(h)).getTime() - y.getTime();
        let M;
        const I = l.map((D) => {
          if (!D.current)
            return null;
          const x = ie(D.current.props.dataItem), A = new Date(D.current.props.end.getTime() + k);
          if (A <= Z(x, i.start)) {
            M = !0;
            return;
          }
          return J(x, i.end, A), x;
        }).filter(Boolean);
        M || (u = [...I]);
        break;
      }
      case "RESIZE_ITEM_COMPLETE": {
        u = null, e.onDataAction && n && e.onDataAction.call(void 0, {
          type: Ue.update,
          series: !1,
          dataItem: n
        });
        break;
      }
      case "RESIZE_ITEM_COMPLETE_OCCURRENCE": {
        u = null, e.onDataAction && n && e.onDataAction.call(void 0, {
          type: Ue.update,
          series: !1,
          dataItem: n
        });
        break;
      }
      case "RESIZE_ITEM_COMPLETE_SERIES": {
        u = null;
        let d;
        if (Array.isArray(n))
          d = n.map((m) => {
            const p = ie(m);
            return J(p, i.start, Z(m, i.start)), J(p, i.end, Z(m, i.end)), p;
          });
        else {
          const m = ie(n);
          J(m, i.start, Z(n, i.start)), J(m, i.end, Z(n, i.end)), d = m;
        }
        e.onDataAction && d && e.onDataAction.call(void 0, {
          type: Ue.update,
          series: !0,
          dataItem: d
        });
        break;
      }
      default:
        u = null;
        break;
    }
    o(u);
  }];
};
var vt = /* @__PURE__ */ ((e) => (e.reset = "SERIES_RESET", e.set = "SERIES_SET", e.toggle = "SERIES_TOGGLE", e))(vt || {});
const ip = (e, t) => {
  switch (t.type) {
    case "SERIES_RESET":
      return null;
    case "SERIES_SET":
      return t.payload;
    case "SERIES_TOGGLE":
      return !e;
    default:
      return e;
  }
}, sp = (e, t, r) => {
  const [n, o] = Oe(e, t, r);
  return [n, o, (l) => {
    const i = ip(n, l);
    o(i);
  }];
}, ma = a.forwardRef((e, t) => {
  const {
    _ref: r,
    itemRef: n,
    onDataAction: o,
    ignoreIsAllDay: l,
    viewItem: i,
    series: s,
    onSeriesChange: c,
    form: u,
    formItem: d,
    onFormItemChange: m,
    drag: p,
    dragItem: f,
    onDragItemChange: h,
    resize: y,
    resizeItem: k,
    onResizeItemChange: M,
    removeDialog: I,
    removeItem: D,
    onRemoveItemChange: x,
    occurrenceDialog: A,
    showOccurrenceDialog: O,
    onShowOccurrenceDialogChange: v,
    showRemoveDialog: w,
    onShowRemoveDialogChange: T,
    onFocus: R,
    onFocusAction: F,
    onMouseDown: V,
    onMouseDownAction: z,
    onMouseUp: P,
    onMouseUpAction: L,
    onClick: U,
    onClickAction: C,
    onDoubleClick: $,
    onDoubleClickAction: b,
    onRemoveClick: g,
    onRemoveClickAction: _,
    onPress: W,
    onPressAction: ee,
    onDrag: re,
    onDragAction: B,
    onRelease: ae,
    onReleaseAction: ue,
    onResizePress: ye,
    onResizePressAction: ne,
    onResizeStartDrag: Ae,
    onResizeStartDragAction: he,
    onResizeEndDrag: Me,
    onResizeEndDragAction: Ee,
    onResizeRelease: Ge,
    onResizeReleaseAction: H,
    onOccurrenceClick: G,
    onOccurrenceClickAction: se,
    onSeriesClick: oe,
    onSeriesClickAction: ce,
    onKeyDown: De,
    onKeyDownAction: nt,
    onKeyUp: Et,
    onKeyUpAction: Dt,
    onRemoveConfirm: K,
    onRemoveConfirmAction: va,
    onFormSubmit: ga,
    onFormSubmitAction: ya,
    onCancel: ha,
    onCancelAction: Ea
  } = { ...Ot, ...e }, [as, ns] = a.useState(e.tabIndex), wo = a.useRef(null), q = a.useRef(null), os = Ys();
  a.useImperativeHandle(wo, () => ({ props: e, element: q.current && q.current.element })), a.useImperativeHandle(t, () => wo.current), a.useImperativeHandle(r, () => q.current), a.useImperativeHandle(n, () => q.current);
  const Da = i || Ot.viewItem, Io = p || Ot.drag, Ro = y || Ot.resize, ls = u || Ot.form, is = A || Ot.occurrenceDialog, ss = I || Ot.removeDialog, Pr = nr(e.editable), [Wr, _t] = go(), [Yr, , $r] = sp(null, s, c), [Zt, cs, Xt] = Qf(
    { series: Yr, onDataAction: o },
    [null, d, m]
  ), [Ct, us, ot] = op(
    { dataItem: e.dataItem, ignoreIsAllDay: e.ignoreIsAllDay, isAllDay: e.isAllDay, onDataAction: o },
    [null, f, h]
  ), [Tt, ds, Be] = lp(
    { dataItem: e.dataItem, onDataAction: o },
    [null, k, M]
  ), [Ft, ms, lr] = rp(
    { series: Yr, onDataAction: o },
    [null, D, x]
  ), [Gr, fs, zt] = np(!1, w, T), [ir, ps, Ut] = tp(!1, O, v), [Ca] = zr(), [, Ta] = qm(), [, sr] = Oi(), ka = !!(q.current && Wr && Wr.some((S) => S.current === q.current)), te = a.useMemo(
    () => ({
      selected: ka,
      series: Yr,
      formItem: Zt,
      dragItem: Ct,
      resizeItem: Tt,
      removeItem: Ft,
      showRemoveDialog: Gr,
      showOccurrenceDialog: ir
    }),
    [Ct, Zt, Ft, Tt, ka, Yr, ir, Gr]
  ), Y = a.useMemo(
    () => ({
      [vt.set]: $r,
      [vt.toggle]: $r,
      [vt.reset]: $r,
      [Pe.select]: _t,
      [Pe.add]: _t,
      [Pe.remove]: _t,
      [Pe.reset]: _t,
      [Pe.selectNext]: _t,
      [Pe.selectPrev]: _t,
      [et.set]: Xt,
      [et.setMaster]: Xt,
      [et.reset]: Xt,
      [et.complete]: Xt,
      [pt.set]: lr,
      [pt.reset]: lr,
      [pt.complete]: lr,
      [Ce.close]: Ut,
      [Ce.open]: Ut,
      [Ce.set]: Ut,
      [Ce.toggle]: Ut,
      [Ce.reset]: Ut,
      [ct.close]: zt,
      [ct.open]: zt,
      [ct.set]: zt,
      [ct.toggle]: zt,
      [ct.reset]: zt,
      [be.start]: ot,
      [be.drag]: ot,
      [be.complete]: ot,
      [be.completeOccurrence]: ot,
      [be.completeSeries]: ot,
      [be.set]: ot,
      [be.reset]: ot,
      [be.dragSelected]: ot,
      [pe.start]: Be,
      [pe.startDrag]: Be,
      [pe.startDragSelected]: Be,
      [pe.endDrag]: Be,
      [pe.endDragSelected]: Be,
      [pe.complete]: Be,
      [pe.completeOccurrence]: Be,
      [pe.completeSeries]: Be,
      [pe.set]: Be,
      [pe.reset]: Be,
      [Sr.next]: Ta,
      [Sr.prev]: Ta,
      [We.left]: sr,
      [We.right]: sr,
      [We.up]: sr,
      [We.down]: sr,
      null: () => {
      }
    }),
    [
      ot,
      Xt,
      _t,
      lr,
      Be,
      $r,
      Ut,
      zt,
      Ta,
      sr
    ]
  ), vs = a.useCallback(
    (S) => {
      if (F) {
        const E = F(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S)) : Y[E.type]({ ...E, item: q }));
      }
      R && R.call(void 0, S);
    },
    [Y, R, F, e, te]
  ), gs = a.useCallback(
    (S) => {
      if (z) {
        const E = z(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S)) : Y[E.type]({ ...E, item: q }));
      }
      V && V.call(void 0, S);
    },
    [Y, V, z, e, te]
  ), ys = a.useCallback(
    (S) => {
      if (L) {
        const E = L(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S)) : Y[E.type]({ ...E, item: q }));
      }
      P && P.call(void 0, S);
    },
    [Y, P, L, e, te]
  ), [, hs] = a.useContext(so), Es = a.useCallback(
    (S) => {
      if (C) {
        hs(q.current);
        const E = C(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S)) : Y[E.type]({ ...E, item: q }));
      }
      U && U.call(void 0, S);
    },
    [Y, U, C, e, te]
  ), Ds = a.useCallback(
    (S) => {
      if (b) {
        const E = b(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S)) : Y[E.type]({ ...E, item: q }));
      }
      $ && $.call(void 0, S);
    },
    [b, $, e, Y, te]
  ), Cs = a.useCallback(
    (S) => {
      if (_) {
        const E = _(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S)) : Y[E.type]({ ...E, item: q }));
      }
      g && g.call(void 0, S);
    },
    [_, g, e, Y, te]
  ), Ts = a.useCallback(
    (S) => {
      if (ee) {
        const E = ee(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S)) : Y[E.type]({ ...E, item: q }, S));
      }
      W && W.call(void 0, S);
    },
    [ee, W, e, Y, te]
  ), ks = a.useCallback(
    (S) => {
      if (B) {
        const E = B(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S.dragEvent.originalEvent)) : Y[E.type]({ ...E, item: q }, S.dragEvent.originalEvent));
      }
      re && re.call(void 0, S);
    },
    [B, re, e, Y, te]
  ), bs = a.useCallback(
    (S) => {
      if (ue) {
        const E = ue(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S.dragEvent.originalEvent)) : Y[E.type]({ ...E, item: q }, S.dragEvent.originalEvent));
      }
      ae && ae.call(void 0, S);
    },
    [ue, ae, e, Y, te]
  ), Ss = a.useCallback(
    (S) => {
      if (ne) {
        const E = ne(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S.dragEvent.originalEvent)) : Y[E.type]({ ...E, item: q }, S.dragEvent.originalEvent));
      }
      ye && ye.call(void 0, S);
    },
    [ne, ye, e, te, Y]
  ), Ms = a.useCallback(
    (S) => {
      if (he) {
        const E = he(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S.dragEvent.originalEvent)) : Y[E.type]({ ...E, item: q }, S.dragEvent.originalEvent));
      }
      Ae && Ae.call(void 0, S);
    },
    [Ae, he, e, Y, te]
  ), ws = a.useCallback(
    (S) => {
      if (Ee) {
        const E = Ee(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S.dragEvent.originalEvent)) : Y[E.type]({ ...E, item: q }, S.dragEvent.originalEvent));
      }
      Me && Me.call(void 0, S);
    },
    [Me, Ee, e, Y, te]
  ), Is = a.useCallback(
    (S) => {
      if (H) {
        const E = H(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S.dragEvent.originalEvent)) : Y[E.type]({ ...E, item: q }, S.dragEvent.originalEvent));
      }
      Ge && Ge.call(void 0, S);
    },
    [H, Ge, e, Y, te]
  ), Rs = a.useCallback(
    (S) => {
      if (ya) {
        const E = ya(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S)) : Y[E.type]({ ...E, item: q }, S));
      }
      ga && ga.call(void 0, S);
    },
    [ya, ga, e, te, Y]
  ), cr = a.useCallback(
    (S) => {
      if (Ea) {
        const E = Ea(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S)) : Y[E.type]({ ...E, item: q }, S));
      }
      ha && ha.call(void 0, S);
    },
    [Ea, ha, e, te, Y]
  ), xs = a.useCallback(
    (S) => {
      if (se) {
        const E = se(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S)) : Y[E.type]({ ...E, item: q }, S));
      }
      G && G.call(void 0, S);
    },
    [se, G, e, te, Y]
  ), Ns = a.useCallback(
    (S) => {
      if (ce) {
        const E = ce(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S)) : Y[E.type]({ ...E, item: q }, S));
      }
      oe && oe.call(void 0, S);
    },
    [ce, oe, e, te, Y]
  ), As = a.useCallback(
    (S) => {
      if (nt) {
        const E = nt(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S.syntheticEvent)) : Y[E.type]({ ...E, item: q }, S.syntheticEvent));
      }
      De && De.call(void 0, S);
    },
    [nt, De, e, te, Y]
  ), _s = a.useCallback(
    (S) => {
      if (Dt) {
        const E = Dt(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S.syntheticEvent)) : Y[E.type]({ ...E, item: q }, S.syntheticEvent));
      }
      Et && Et.call(void 0, S);
    },
    [Dt, Et, e, te, Y]
  ), Fs = a.useCallback(
    (S) => {
      if (va) {
        const E = va(S, e, te);
        E && (Array.isArray(E) ? E.filter(Boolean).map((N) => N && Y[N.type]({ ...N, item: q }, S.syntheticEvent)) : Y[E.type]({ ...E, item: q }, S.syntheticEvent));
      }
      K && K.call(void 0, S);
    },
    [va, K, e, te, Y]
  );
  return a.useEffect(() => {
    const S = Ca.length && Ca[0].current === q.current;
    ns(e.tabIndex !== void 0 ? e.tabIndex === null ? void 0 : e.tabIndex : Wr.length === 0 && S ? 0 : void 0);
  }, [Ca, e.tabIndex, Wr.length]), /* @__PURE__ */ a.createElement(
    Wm,
    {
      props: e,
      form: [Zt, cs, Xt],
      drag: [Ct, us, ot],
      resize: [Tt, ds, Be],
      remove: [Ft, ms, lr],
      showRemoveDialog: [Gr, fs, zt],
      showOccurrenceDialog: [ir, ps, Ut]
    },
    /* @__PURE__ */ a.createElement(
      Da,
      {
        ...e,
        _ref: q,
        itemRef: q,
        selected: ka,
        tabIndex: as,
        id: os,
        onKeyDown: As,
        onKeyUp: _s,
        onFocus: vs,
        onMouseUp: ys,
        onMouseDown: gs,
        onClick: Es,
        onDoubleClick: Ds,
        onRemoveClick: Cs,
        onPress: Ts,
        onDrag: ks,
        onRelease: bs,
        onResizePress: Ss,
        onResizeEndDrag: ws,
        onResizeStartDrag: Ms,
        onResizeRelease: Is
      }
    ),
    Ct && Pr.drag && (Array.isArray(Ct) ? Ct.map((S, E) => /* @__PURE__ */ a.createElement(
      Io,
      {
        key: E,
        ignoreIsAllDay: l,
        dataItem: S,
        vertical: e.vertical,
        viewItem: Da,
        item: e.item
      }
    )) : /* @__PURE__ */ a.createElement(
      Io,
      {
        ignoreIsAllDay: l,
        dataItem: Ct,
        vertical: e.vertical,
        viewItem: Da,
        item: e.item
      }
    )),
    Tt && Pr.resize && (Array.isArray(Tt) ? Tt.map((S, E) => /* @__PURE__ */ a.createElement(
      Ro,
      {
        key: E,
        format: e.format,
        ignoreIsAllDay: l,
        dataItem: S,
        viewItem: e.viewItem,
        item: e.item,
        vertical: e.vertical
      }
    )) : /* @__PURE__ */ a.createElement(
      Ro,
      {
        format: e.format,
        ignoreIsAllDay: l,
        dataItem: Tt,
        viewItem: e.viewItem,
        item: e.item,
        vertical: e.vertical
      }
    )),
    Zt && !ir && Pr.edit && /* @__PURE__ */ a.createElement(
      ls,
      {
        dataItem: Zt,
        onSubmit: Rs,
        onClose: cr,
        onCancel: cr
      }
    ),
    ir && /* @__PURE__ */ a.createElement(
      is,
      {
        dataItem: Zt || Ct || Tt || Ft,
        isRemove: Ft !== null,
        onClose: cr,
        onOccurrenceClick: xs,
        onSeriesClick: Ns
      }
    ),
    Gr && Ft && Pr.remove && /* @__PURE__ */ a.createElement(
      ss,
      {
        dataItem: Ft,
        onClose: cr,
        onCancel: cr,
        onConfirm: Fs
      }
    )
  );
}), Ot = {
  viewItem: da,
  drag: Vi,
  resize: qi,
  form: Co,
  occurrenceDialog: To,
  removeDialog: ko,
  onClickAction: (e, t, r) => [
    {
      type: e.syntheticEvent.metaKey || e.syntheticEvent.ctrlKey ? r.selected && !r.dragItem && !r.resizeItem ? Pe.remove : Pe.add : Pe.select
    }
  ],
  onDoubleClickAction: (e, t) => t.editable ? [
    { type: et.set, payload: t.dataItem },
    t.isRecurring && { type: Ce.open }
  ].filter(Boolean) : [],
  onRemoveClickAction: (e, t) => t.editable ? [
    { type: pt.set, payload: t.dataItem },
    t.isRecurring ? { type: Ce.open } : { type: ct.open }
  ] : [],
  onPressAction: (e, t) => t.editable ? { type: be.start, payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY } } : [],
  onDragAction: (e, t) => t.editable ? {
    type: e.dragEvent.originalEvent.metaKey || e.dragEvent.originalEvent.ctrlKey ? be.dragSelected : be.drag,
    payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY }
  } : [],
  onReleaseAction: (e, t, r) => t.editable && r.dragItem ? t.isRecurring && !t.isException && r.series === null ? { type: Ce.open } : {
    type: t.isRecurring ? r.series ? be.completeSeries : be.completeOccurrence : be.complete,
    payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY }
  } : [],
  onResizePressAction: (e, t) => t.editable ? { type: pe.start, payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY } } : [],
  onResizeStartDragAction: (e, t) => t.editable ? {
    type: e.dragEvent.originalEvent.metaKey || e.dragEvent.originalEvent.ctrlKey ? pe.startDragSelected : pe.startDrag,
    payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY }
  } : [],
  onResizeEndDragAction: (e, t) => t.editable ? {
    type: e.dragEvent.originalEvent.metaKey || e.dragEvent.originalEvent.ctrlKey ? pe.endDragSelected : pe.endDrag,
    payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY }
  } : [],
  onResizeReleaseAction: (e, t, r) => t.editable && r.resizeItem ? t.isRecurring && !t.isException && r.series === null ? { type: Ce.open } : {
    type: t.isRecurring ? r.series ? pe.completeSeries : pe.completeOccurrence : pe.complete,
    payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY }
  } : [],
  onOccurrenceClickAction: (e, t, r) => r.dragItem ? [
    { type: be.completeOccurrence },
    { type: Ce.close }
  ] : r.resizeItem ? [
    { type: pe.completeOccurrence },
    { type: Ce.close }
  ] : r.formItem ? [
    { type: vt.set, payload: !1 },
    { type: et.set, payload: t.dataItem },
    { type: Ce.close }
  ] : r.removeItem ? [
    { type: vt.set, payload: !1 },
    { type: pt.set, payload: t.dataItem },
    { type: ct.open },
    { type: Ce.close }
  ] : [],
  onSeriesClickAction: (e, t, r) => r.dragItem ? [
    { type: be.completeSeries },
    { type: Ce.close }
  ] : r.resizeItem ? [
    { type: pe.completeSeries },
    { type: Ce.close }
  ] : r.formItem ? [
    { type: vt.set, payload: !0 },
    { type: et.setMaster, payload: t.dataItem },
    { type: Ce.close }
  ] : r.removeItem ? [
    { type: vt.set, payload: !0 },
    { type: pt.set, payload: t.dataItem },
    { type: ct.open },
    { type: Ce.close }
  ] : [],
  onKeyDownAction: (e, t) => {
    switch (e.syntheticEvent.keyCode) {
      case Ke.enter:
        return [
          { type: et.set, payload: t.dataItem },
          t.isRecurring && { type: Ce.open }
        ];
      case Ke.tab:
        return [
          { type: e.syntheticEvent.shiftKey ? Sr.prev : Sr.next, ignoreIsAllDay: t.ignoreIsAllDay },
          { type: e.syntheticEvent.shiftKey ? Pe.selectPrev : Pe.selectNext, ignoreIsAllDay: t.ignoreIsAllDay }
        ];
      case Ke.up:
        return [
          !!(t.slots.length && t.slots[0]._ref.current) && { type: We.up, slot: t.slots[0]._ref }
        ];
      case Ke.right:
        return [
          !!(t.slots.length && t.slots[0]._ref.current) && { type: We.right, slot: t.slots[0]._ref }
        ];
      case Ke.down:
        return [
          !!(t.slots.length && t.slots[t.slots.length - 1]._ref.current) && { type: We.down, slot: t.slots[t.slots.length - 1]._ref }
        ];
      case Ke.left:
        return [
          !!(t.slots.length && t.slots[0]._ref.current) && { type: We.left, slot: t.slots[0]._ref }
        ];
      default:
        return;
    }
  },
  onFormSubmitAction: (e) => [
    { type: et.complete, payload: e.value }
  ],
  onRemoveConfirmAction: () => [
    { type: pt.complete },
    { type: Ce.close }
  ],
  onCancelAction: () => [
    { type: vt.reset },
    { type: pt.reset },
    { type: et.reset },
    { type: be.reset },
    { type: pe.reset },
    { type: ct.reset },
    { type: Ce.reset }
  ]
};
ma.displayName = "KendoReactSchedulerEditItem";
const cp = (e) => {
  let t = 0;
  return e.forEach((r) => {
    if (r.current) {
      const n = Ze(r.current.element);
      t += n.width;
    }
  }), t;
}, up = (e) => {
  let t = 0;
  return e.forEach((r) => {
    if (r.current) {
      const n = Ze(r.current.element);
      t += n.height;
    }
  }), t;
}, dp = (e, t) => {
  const r = Qt(e);
  return r.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), r;
}, ra = (e) => {
  const [t, r] = a.useState(!1), n = Fr(), o = at(), l = a.useRef(void 0), i = a.useRef(null), s = a.useRef(null), c = e.updateInterval || mp.updateInterval, [, u] = a.useState(!1), d = xr(s, o.rtl === !0 ? "rtl" : void 0), [m] = qt(), p = a.useCallback(
    () => {
      if (!m)
        return;
      const y = m.filter((k) => k.current && (e.groupIndex === void 0 || e.groupIndex === null || k.current.props.group.index === e.groupIndex) && (e.vertical ? Ye(/* @__PURE__ */ new Date(), /* @__PURE__ */ new Date(), k.current.props.start, k.current.props.end, !0) : Ve(/* @__PURE__ */ new Date(), k.current.props.start, k.current.props.end)) && !k.current.props.isAllDay);
      if (y && y.length && i.current && s.current) {
        const k = xt(y);
        if (!k.current)
          return;
        const M = e.vertical ? up(y) : cp(y), I = Ze(k.current.element), D = Ze(i.current), x = (e.vertical ? I.width : I.height) / (k.current.props.end.getTime() - k.current.props.start.getTime()), A = (Date.now() - dp(/* @__PURE__ */ new Date(), k.current.props.start).getTime()) * x, O = d === "rtl", v = e.vertical ? I.top : I.top + A - D.height / 2, w = O ? "right" : "left", T = e.vertical ? I[w] + A - D.width / 2 : I[w];
        e.vertical ? i.current.style[w] = `${T}px` : i.current.style.top = `${v}px`, s.current.style[w] = `${T}px`, s.current.style.top = `${v}px`, s.current.style[e.vertical ? "height" : "width"] = `${M - 1}px`, r(!0);
      } else
        r(!1);
    },
    [m, e.groupIndex, e.vertical, d]
  ), f = a.useCallback(
    () => {
      p(), u((y) => !y);
    },
    [p]
  );
  a.useEffect(
    () => {
      if (!n.current || !window)
        return;
      clearInterval(l.current), l.current = window.setInterval(f, c);
      const y = window.ResizeObserver, k = y && new y(f);
      return k && k.observe(n.current), () => {
        clearInterval(l.current), k && k.disconnect();
      };
    },
    [p, f, n, c]
  ), a.useEffect(p);
  const h = /* @__PURE__ */ a.createElement(
    "div",
    {
      ref: i,
      className: ve(
        "k-current-time",
        {
          "k-current-time-arrow-right": !e.vertical && d !== "rtl",
          "k-current-time-arrow-left": !e.vertical && d === "rtl",
          "k-current-time-arrow-down": e.vertical
        }
      ),
      style: {
        transform: e.vertical ? d === "rtl" ? "translateX(50%)" : "translateX(-50%)" : "translateY(-50%)",
        visibility: t ? void 0 : "hidden"
      }
    }
  );
  return /* @__PURE__ */ a.createElement(a.Fragment, null, e.attachArrow && e.attachArrow.current ? aa.createPortal(h, e.attachArrow.current) : h, /* @__PURE__ */ a.createElement(
    "div",
    {
      className: "k-current-time",
      ref: s,
      style: {
        transform: e.vertical ? "translateX(-50%)" : "translateY(-50%)",
        [e.vertical ? "width" : "height"]: "1px",
        visibility: t ? void 0 : "hidden"
      }
    }
  ));
}, mp = {
  updateInterval: 6e4
}, fa = a.forwardRef((e, t) => {
  const {
    as: r = Pa.as,
    ...n
  } = e, o = a.useRef(null), l = a.useRef(null), i = Qe(), s = a.useMemo(
    () => ve("k-scheduler-cell k-heading-cell", e.className),
    [e.className]
  );
  return a.useImperativeHandle(l, () => ({
    element: o.current && o.current.element ? o.current.element : o.current,
    props: e
  })), a.useImperativeHandle(t, () => l.current), /* @__PURE__ */ a.createElement(
    r,
    {
      ref: r !== Pa.as ? void 0 : o,
      ...n,
      className: s
    },
    /* @__PURE__ */ a.createElement("span", { className: "k-link k-nav-day" }, i.formatDate(
      e.date,
      e.format ? e.format : Pa.format
    ))
  );
}), Pa = {
  as: a.forwardRef(({ as: e, format: t, start: r, end: n, ...o }, l) => /* @__PURE__ */ a.createElement("div", { ...o, ref: l })),
  format: "d"
};
fa.displayName = "KendoReactSchedulerDateHeaderCell";
const Vr = 0, qr = 1, fp = /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-side-cell" }), Hr = (e) => {
  const {
    group: t,
    timezone: r,
    resources: n
  } = at(), o = Qe(), l = e.editItem || ma, i = e.editSlot || Or, s = e.showWorkHours, c = e.numberOfDays || it.numberOfDays, u = e.slotDivisions || it.slotDivisions, d = e.slotDuration || it.slotDuration, m = e.workWeekStart || it.workWeekStart, p = e.workWeekEnd || it.workWeekEnd, f = o.parseDate(e.workDayStart || e.isWorkDayStart || it.isWorkDayStart), h = o.parseDate(e.workDayEnd || e.isWorkDayEnd || it.isWorkDayEnd), y = o.parseDate(e.startTime || it.startTime), k = o.parseDate(e.endTime || it.endTime), [M] = ar(), I = Vt(), D = ao(), x = $e(), A = At(), O = a.useMemo(
    () => s ? f : y,
    [
      s,
      f,
      y
    ]
  ), v = a.useMemo(
    () => s ? h : k,
    [
      s,
      h,
      k
    ]
  ), w = a.useMemo(
    () => wr(
      A,
      { step: Xe * c, timezone: r }
    ).map((g) => ({ ...g, isAllDay: !0 })),
    [
      A.start.getTime(),
      A.end.getTime(),
      c
    ]
  ), T = a.useMemo(
    () => wr(
      A,
      { step: Xe, timezone: r }
    ).map((g) => ({ ...g, isAllDay: !1 })),
    [
      A.start.getTime(),
      A.end.getTime(),
      r
    ]
  ), R = a.useMemo(
    () => Mr(
      A,
      { step: Xe },
      { groups: I, ranges: w }
    ),
    [
      A.start.getTime(),
      A.end.getTime(),
      r,
      w,
      I
    ]
  ), F = a.useMemo(
    () => Mr(
      A,
      { step: d * Va / u },
      { groups: I, ranges: T }
    ).filter((g) => v.getTime() === O.getTime() || Ve(g.zonedStart, O, v)),
    [
      A.start.getTime(),
      A.end.getTime(),
      d,
      u,
      O.getTime(),
      v.getTime(),
      I,
      T
    ]
  ), V = a.useMemo(
    () => or(M, { dateRange: A, fields: x, timezone: r }),
    [M, A.start.getTime(), A.end.getTime(), x, r]
  ), z = a.useMemo(
    () => V.filter((g) => g.isAllDay),
    [V]
  ), P = a.useMemo(
    () => V.filter((g) => !g.isAllDay),
    [V]
  ), L = a.useMemo(
    () => Bt(z, { timezone: r }, { groups: I, ranges: w }),
    [V, r, I, w]
  ), U = a.useMemo(
    () => Bt(P, { timezone: r }, { groups: I, ranges: T }).filter(
      (g) => O.getTime() === v.getTime() || Ve(g.zonedStart, O, v) || Ve(g.zonedEnd, O, v) || Ve(
        new Date(g.zonedEnd.getTime() - (g.zonedEnd.getTime() - g.zonedStart.getTime()) / 2),
        O,
        v
      )
    ),
    [V, r, I, T, O.getTime(), v.getTime()]
  );
  a.useMemo(() => Gt(L, R, !1), [L, R]), a.useMemo(() => Er(L, R, !1), [L, R]), a.useMemo(() => Gt(U, F, !1), [U, F]), a.useMemo(() => Er(U, F, !1), [U, F]);
  const C = /* @__PURE__ */ a.createElement(Fe.Consumer, null, ({ groupIndex: g }) => /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row", key: g }, T.map((_, W) => /* @__PURE__ */ a.createElement(
    fa,
    {
      as: e.dateHeaderCell,
      key: W,
      date: j.fromLocalDate(
        new Date(_.zonedEnd.getTime() - (_.zonedEnd.getTime() - _.zonedStart.getTime()) / 2),
        r
      ),
      start: _.start,
      end: _.end,
      format: { skeleton: "MEd" }
    }
  )))), $ = /* @__PURE__ */ a.createElement(Fe.Consumer, null, ({ groupIndex: g }) => /* @__PURE__ */ a.createElement("div", { key: g, className: "k-scheduler-row" }, w.map((_, W) => R.filter((ee) => ee.group.index === g && ee.range.index === W).map((ee, re, B) => /* @__PURE__ */ a.createElement(
    i,
    {
      ...ee,
      onDataAction: e.onDataAction,
      form: e.form,
      slot: e.slot,
      viewSlot: e.viewSlot,
      key: `${ee.start.getTime()}:${ee.group.index}`,
      row: 0,
      col: D === "horizontal" ? B.length * (g || 0) + re : re,
      isWorkDay: 0 <= ee.zonedStart.getDay() + (c - m) && (ee.zonedStart.getDay() + (c - m)) % c <= p + (c - m),
      expandable: !0
    }
  ))))), b = a.useMemo(
    () => ve(
      "k-scheduler-day-view",
      e.className
    ),
    [e.className]
  );
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
    Ur,
    {
      id: e.id,
      props: e,
      style: e.style,
      className: b,
      ranges: [...w, ...T],
      slots: [...R, ...F]
    },
    /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-head" }, D === "horizontal" ? /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      It,
      {
        nested: !0,
        group: t,
        resources: n,
        rowContent: tl,
        childRowContent: tl
      },
      C
    ), /* @__PURE__ */ a.createElement(
      It,
      {
        group: t,
        resources: n,
        rowContent: Oa,
        childRowContent: Oa
      },
      $
    ), L.map(
      (g) => /* @__PURE__ */ a.createElement(
        l,
        {
          key: g.isRecurring ? `${g.uid}:${g.group.index}:${g.range.index}:${g.originalStart}` : `${g.uid}:${g.group.index}:${g.range.index}`,
          ...g,
          form: e.form,
          onDataAction: e.onDataAction,
          item: e.item,
          viewItem: e.viewItem,
          editable: e.editable,
          vertical: !1
        }
      )
    )) : /* @__PURE__ */ a.createElement(
      yt,
      {
        group: t,
        resources: n,
        cellContent: fp
      },
      C
    )),
    /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-body" }, D === "horizontal" ? /* @__PURE__ */ a.createElement(a.Fragment, null, F.filter((g) => g.group.index === Vr && g.range.index === Vr).map((g, _) => /* @__PURE__ */ a.createElement(a.Fragment, { key: g.index }, /* @__PURE__ */ a.createElement(
      It,
      {
        nested: !1,
        group: t,
        resources: n,
        rowContent: rl,
        rowContentProps: {
          timeHeaderCell: e.timeHeaderCell,
          isMaster: _ % u === 0,
          isLast: (_ + 1) % u === 0,
          slot: g
        }
      },
      /* @__PURE__ */ a.createElement(Fe.Consumer, null, ({ groupIndex: W }) => /* @__PURE__ */ a.createElement(
        "div",
        {
          className: ve(
            "k-scheduler-row",
            {
              "k-middle-row": (_ + 1) % u !== 0
            }
          )
        },
        T.map((ee, re) => F.filter((B) => B.index === g.index && B.range.index === re && B.group.index === W).map((B) => /* @__PURE__ */ a.createElement(
          i,
          {
            key: `${B.start.getTime()}:${B.group.index}`,
            ...B,
            onDataAction: e.onDataAction,
            slot: e.slot,
            viewSlot: e.viewSlot,
            form: e.form,
            row: _ + qr,
            col: T.length * (W || 0) + re,
            isWorkHour: Ve(B.zonedStart, f, h),
            isWorkDay: Ql(B.zonedEnd.getDay(), m, p),
            editable: e.editable
          }
        )))
      ))
    ))), e.currentTimeMarker && Ye(xt(T).start, hr(T).end, /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date(), !0) && /* @__PURE__ */ a.createElement(ra, null)) : /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      yt,
      {
        nested: !0,
        group: t,
        resources: n
      },
      /* @__PURE__ */ a.createElement(Fe.Consumer, null, ({ groupIndex: g }) => /* @__PURE__ */ a.createElement(a.Fragment, { key: g }, /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row" }, /* @__PURE__ */ a.createElement(Oa, { groupIndex: g }, w.map((_, W) => {
        const ee = F.filter((re) => re.group.index === g && re.range.index === Vr).length;
        return R.filter((re) => re.group.index === g && re.range.index === W).map((re, B) => /* @__PURE__ */ a.createElement(
          i,
          {
            slot: e.slot,
            viewSlot: e.viewSlot,
            form: e.form,
            ...re,
            onDataAction: e.onDataAction,
            key: `${re.start.getTime()}:${re.group.index}`,
            className: "k-scheduler-alldays-slot",
            row: ee * (g || 0) + (g || 0) * qr,
            col: B,
            expandable: !0
          }
        ));
      }))), F.filter((_) => _.group.index === g && _.range.index === Vr).map((_, W, ee) => /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row", key: _.index }, /* @__PURE__ */ a.createElement(
        rl,
        {
          slot: _,
          isMaster: W % u === 0,
          isLast: (W + 1) % u === 0,
          timeHeaderCell: e.timeHeaderCell
        },
        T.map(
          (re, B) => F.filter((ae) => ae.index === _.index && ae.group.index === g && ae.range.index === B).map((ae) => /* @__PURE__ */ a.createElement(
            i,
            {
              slot: e.slot,
              viewSlot: e.viewSlot,
              form: e.form,
              onDataAction: e.onDataAction,
              ...ae,
              key: `${ae.start.getTime()}:${ae.group.index}`,
              row: ee.length * (g || 0) + W + (g || 0) * qr + qr,
              col: B,
              editable: e.editable,
              isWorkHour: Ve(ae.zonedStart, f, h),
              isWorkDay: 0 <= ae.zonedStart.getDay() + (c - m) && (ae.zonedStart.getDay() + (c - m)) % c <= p + (c - m)
            }
          ))
        )
      ))), e.currentTimeMarker && Ye(xt(T).start, hr(T).end, /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date(), !0) && /* @__PURE__ */ a.createElement(ra, { groupIndex: g })))
    ), L.map((g) => /* @__PURE__ */ a.createElement(
      l,
      {
        key: g.isRecurring ? `${g.uid}:${g.group.index}:${g.range.index}:${g.originalStart}` : `${g.uid}:${g.group.index}:${g.range.index}`,
        ...g,
        onDataAction: e.onDataAction,
        viewItem: e.viewItem,
        item: e.item,
        form: e.form,
        editable: e.editable,
        vertical: !1
      }
    ))), U.map((g) => /* @__PURE__ */ a.createElement(
      l,
      {
        key: g.isRecurring ? `${g.uid}:${g.group.index}:${g.range.index}:${g.originalStart}` : `${g.uid}:${g.group.index}:${g.range.index}`,
        ...g,
        format: "t",
        onDataAction: e.onDataAction,
        viewItem: e.viewItem,
        item: e.item,
        form: e.form,
        editable: e.editable,
        vertical: !0
      }
    )))
  ));
}, pp = ({ date: e, numberOfDays: t = 1, timezone: r }) => {
  const n = j.fromLocalDate(e, r), o = tt(n), l = Rt(o, t), i = j.fromUTCDate(Le(o), r), s = j.fromUTCDate(Le(l), r), c = new Date(i.getTime()), u = new Date(s.getTime());
  return {
    start: c,
    end: u,
    zonedStart: i,
    zonedEnd: s
  };
}, it = {
  name: "multi-day",
  title: "Multi Day",
  currentTimeMarker: !0,
  dateRange: pp,
  selectedDateFormat: "{0:D} - {1:D}",
  selectedShortDateFormat: "{0:d} - {1:d}",
  numberOfDays: 1,
  startTime: "00:00",
  endTime: "23:59",
  isWorkDayStart: "08:00",
  isWorkDayEnd: "17:00",
  workWeekStart: ke.Monday,
  workWeekEnd: ke.Friday,
  step: 1,
  slotDivisions: 2,
  slotDuration: 60,
  showCurrentTime: !0,
  defaultShowWorkHours: !0
};
Hr.propTypes = {
  currentTimeMarker: X.bool,
  name: X.string,
  numberOfDays: X.number,
  startTime: X.string,
  endTime: X.string,
  workDayStart: X.string,
  workDayEnd: X.string,
  workWeekStart: X.number,
  workWeekEnd: X.any,
  slotDivisions: X.number,
  slotDuration: X.number,
  showWorkHours: X.bool,
  selectedDateFormat: X.string,
  selectedShortDateFormat: X.string
};
Hr.displayName = "KendoReactSchedulerMultiDayView";
const Rr = (e) => /* @__PURE__ */ a.createElement(Hr, { ...e }), vp = {
  ...it,
  name: "day",
  title: (e) => e.toLanguageString(en, Q[en]),
  step: 1,
  numberOfDays: 1,
  slotDuration: 60,
  slotDivisions: 2,
  selectedDateFormat: "{0:D}",
  selectedShortDateFormat: "{0:d}"
};
Rr.displayName = "KendoReactSchedulerDayView";
const ml = {
  name: "@progress/kendo-react-scheduler",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702645189,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui"
}, Zi = a.forwardRef((e, t) => {
  const {
    _ref: r,
    onRemoveClick: n
  } = e, o = a.useRef(null), l = a.useRef(null);
  a.useImperativeHandle(o, () => ({ props: e, element: l.current })), a.useImperativeHandle(t, () => o.current), a.useImperativeHandle(r, () => o.current);
  const i = nr(e.editable), s = He().toLanguageString(Cr, Q[Cr]), c = e.group.resources.find((p) => !!(p.colorField && p[p.colorField] !== void 0)), u = c && c.colorField && c[c.colorField], d = a.useCallback(
    (p) => {
      n && n.call(void 0, {
        syntheticEvent: p,
        target: o.current
      });
    },
    [n, o]
  ), m = a.useMemo(
    () => ve("k-task", e.className),
    [e.className]
  );
  return /* @__PURE__ */ a.createElement(
    "div",
    {
      id: e.id,
      ref: l,
      style: e.style,
      className: m,
      tabIndex: e.tabIndex || void 0
    },
    u && /* @__PURE__ */ a.createElement(
      "span",
      {
        className: "k-scheduler-mark",
        style: { color: u, backgroundColor: u }
      }
    ),
    e.isRecurring && /* @__PURE__ */ a.createElement(ze, { name: "arrow-rotate-cw", icon: _n }),
    e.isException && /* @__PURE__ */ a.createElement(ze, { name: "arrows-no-repeat", icon: hl }),
    e.title,
    i.remove && /* @__PURE__ */ a.createElement(
      "a",
      {
        className: "k-link k-event-delete",
        title: s,
        "aria-label": s,
        onClick: d
      },
      /* @__PURE__ */ a.createElement(ze, { name: "x", icon: yl })
    )
  );
});
Zi.displayName = "KendoReactSchedulerTask";
const Xi = a.forwardRef((e, t) => {
  const { task: r, _ref: n, ...o } = e, l = a.useRef(null), i = a.useRef(null);
  a.useImperativeHandle(i, () => ({ props: e, element: l.current && l.current.element })), a.useImperativeHandle(n, () => l.current), a.useImperativeHandle(t, () => i.current);
  const s = r || gp.task;
  return /* @__PURE__ */ a.createElement(s, { ...o, _ref: l });
}), gp = {
  task: Zi
};
Xi.displayName = "KendoReactSchedulerViewTask";
const ji = a.forwardRef((e, t) => {
  const {
    _ref: r,
    onDataAction: n,
    viewTask: o,
    removeDialog: l,
    removeItem: i,
    onRemoveItemChange: s,
    occurrenceDialog: c,
    showOccurrenceDialog: u,
    onShowOccurrenceDialogChange: d,
    showRemoveDialog: m,
    onShowRemoveDialogChange: p,
    ...f
  } = e, h = a.useRef(null);
  a.useImperativeHandle(h, () => ({ props: e, element: h.current && h.current.element })), a.useImperativeHandle(r, () => h.current), a.useImperativeHandle(t, () => h.current);
  const y = o || Wa.viewTask, k = c || Wa.occurrenceDialog, M = l || Wa.removeDialog, I = nr(e.editable), D = $e(), [x, A] = ar(), [O, v] = a.useState(null), [w, T] = Oe(null, i, s), [R, F] = Oe(!1, m, p), [V, z] = Oe(!1, u, d), P = a.useCallback(
    (W) => {
      I.remove && (T(e.dataItem, W), e.isRecurring ? z(!0, W) : F(!0, W));
    },
    [
      T,
      e.dataItem,
      e.isRecurring,
      z,
      F
    ]
  ), L = a.useCallback(
    (W) => {
      v(null), T(null, W), F(!1, W), z(!1, W);
    },
    [
      v,
      T,
      F,
      z
    ]
  ), U = a.useCallback(
    (W) => {
      n && w && n.call(void 0, {
        type: Ue.remove,
        series: O,
        dataItem: w
      }), T(null, W), F(!1, W);
    },
    [
      w,
      A,
      F
    ]
  ), C = a.useCallback(
    (W, ee) => {
      T && T(W, ee);
    },
    [T]
  ), $ = a.useCallback(
    (W, ee) => {
      F && F(W, ee);
    },
    [F]
  ), b = a.useCallback(
    (W, ee) => {
      z && z(W, ee);
    },
    [z]
  ), g = a.useCallback(
    (W) => {
      w && (v(!1), T(e.dataItem, W), F(!0, W)), z(!1, W);
    },
    [
      v,
      e.dataItem,
      w,
      T,
      F
    ]
  ), _ = a.useCallback(
    (W) => {
      if (w) {
        v(!0);
        const ee = St(w, D, x);
        T(ee, W), F(!0, W);
      }
      z(!1, W);
    },
    [
      D,
      w,
      v,
      T,
      F,
      z
    ]
  );
  return /* @__PURE__ */ a.createElement(
    Km,
    {
      remove: [w, C],
      showRemoveDialog: [R, $],
      showOccurrenceDialog: [V, b]
    },
    /* @__PURE__ */ a.createElement(
      y,
      {
        _ref: h,
        ...f,
        onRemoveClick: P
      }
    ),
    V && /* @__PURE__ */ a.createElement(
      k,
      {
        dataItem: w,
        isRemove: w !== null,
        onClose: L,
        onOccurrenceClick: g,
        onSeriesClick: _
      }
    ),
    R && /* @__PURE__ */ a.createElement(
      M,
      {
        dataItem: w,
        onClose: L,
        onCancel: L,
        onConfirm: U
      }
    )
  );
}), Wa = {
  viewTask: Xi,
  occurrenceDialog: To,
  removeDialog: ko
};
ji.displayName = "KendoReactSchedulerEditTask";
const bo = (e) => {
  const {
    group: t,
    timezone: r,
    resources: n
  } = at(), o = e.editTask || ji, l = e.editSlot || Or, i = a.useRef(null), s = xr(i), c = Qe(), u = He(), [d] = ar(), m = Vt(), p = $e(), f = At(), h = a.useMemo(
    () => wr(
      f,
      { step: Xe, timezone: r }
    ),
    [
      f.start.getTime(),
      f.end.getTime(),
      r
    ]
  ), y = a.useMemo(
    () => Mr(
      f,
      { step: Xe },
      { groups: m, ranges: h }
    ),
    [
      f.start.getTime(),
      f.end.getTime(),
      r,
      m,
      h
    ]
  ), k = a.useMemo(
    () => or(d, { dateRange: f, fields: p, timezone: r }),
    [d, f.start.getTime(), f.end.getTime(), p, r]
  ), M = a.useMemo(
    () => Bt(k, { timezone: r }, { groups: m, ranges: h }),
    [k, r, m, h]
  ), I = a.useMemo(
    () => ve(
      "k-scheduler-agendaview",
      e.className
    ),
    [e.className]
  );
  return br({ element: i, selector: ".k-scheduler-datecolumn", explicitDepth: !1 }), br({ element: i, selector: ".k-scheduler-timecolumn", explicitDepth: !1 }), a.useMemo(() => Gt(M, y, !0), [M, y]), a.useMemo(() => Er(M, y, !0), [M, y]), /* @__PURE__ */ a.createElement(
    Ur,
    {
      ref: i,
      id: e.id,
      style: e.style,
      className: I,
      props: e,
      slots: M,
      ranges: h
    },
    /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-head" }, /* @__PURE__ */ a.createElement(yt, { resources: n, group: t }, /* @__PURE__ */ a.createElement(Fe.Consumer, null, ({ groupIndex: D }) => /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row", key: D }, /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-heading-cell k-group-cell k-scheduler-datecolumn" }, u.toLanguageString(Tn, Q[Tn])), /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-heading-cell k-group-cell k-scheduler-timecolumn" }, u.toLanguageString(kn, Q[kn])), /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-heading-cell k-scheduler-eventcolumn" }, u.toLanguageString(bn, Q[bn])))))),
    /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-body" }, /* @__PURE__ */ a.createElement(yt, { resources: n, group: t, nested: !0 }, /* @__PURE__ */ a.createElement(Fe.Consumer, null, ({ groupIndex: D }) => y.filter((x) => x.group.index === (D || 0)).map((x, A, O) => /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row  k-scheduler-content", key: `${D}:${A}` }, /* @__PURE__ */ a.createElement(
      l,
      {
        ...x,
        editable: e.editable,
        row: O.length * (D || 0) + A,
        col: 0,
        slot: e.slot,
        viewSlot: e.viewSlot,
        className: "k-scheduler-datecolumn k-group-cell"
      },
      /* @__PURE__ */ a.createElement("div", null, /* @__PURE__ */ a.createElement("strong", { className: "k-scheduler-agendaday" }, c.formatDate(x.zonedStart, "dd")), /* @__PURE__ */ a.createElement("em", { className: "k-scheduler-agendaweek" }, c.formatDate(x.zonedStart, "EEEE")), /* @__PURE__ */ a.createElement("span", { className: "k-scheduler-agendadate" }, c.formatDate(x.zonedStart, "y")))
    ), /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-group-content" }, x.items.length ? x.items.map((v, w) => /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row", key: w }, /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-scheduler-timecolumn" }, /* @__PURE__ */ a.createElement("div", null, v.tail && /* @__PURE__ */ a.createElement(
      ze,
      {
        name: s === "rtl" ? "caret-alt-right" : "caret-alt-left",
        icon: s === "rtl" ? Wt : Pt
      }
    ), v.isAllDay ? u.toLanguageString(Dr, Q[Dr]) : yp(c, v), v.head && /* @__PURE__ */ a.createElement(
      ze,
      {
        name: s === "rtl" ? "caret-alt-left" : "caret-alt-right",
        icon: s === "rtl" ? Pt : Wt
      }
    ))), /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell" }, /* @__PURE__ */ a.createElement(
      o,
      {
        key: `${A}:${w}`,
        ...v,
        onDataAction: e.onDataAction,
        task: e.task,
        viewTask: e.viewTask,
        editable: e.editable
      }
    )))) : /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-heading-cell k-group-cell" }, u.toLanguageString(wn, Q[wn]))))))))
  );
}, yp = (e, t) => {
  let r = "{0:t}-{1:t}";
  return t.head ? r = "{0:t}" : t.tail && (r = "{1:t}"), e.format(r, t.zonedStart, t.zonedEnd);
}, hp = (e) => tt(e), Ep = (e, t) => tt(Rt(e, t || 1)), Dp = ({ intl: e, date: t, numberOfDays: r = 1, timezone: n }) => {
  const o = j.fromLocalDate(t, n), l = hp(r === ut ? Qr(o, e.firstDay()) : o), i = Ep(l, r), s = j.fromUTCDate(Le(l), n), c = j.fromUTCDate(Le(i), n), u = new Date(s.getTime()), d = new Date(c.getTime());
  return {
    start: u,
    end: d,
    zonedStart: s,
    zonedEnd: c
  };
}, Cp = {
  name: "agenda",
  title: (e) => e.toLanguageString(Qa, Q[Qa]),
  dateRange: Dp,
  selectedDateFormat: "{0:D} - {1:D}",
  selectedShortDateFormat: "{0:d} - {1:d}",
  slotDuration: 60 * 24,
  slotDivision: 1,
  step: ut,
  numberOfDays: ut
}, Tp = {
  title: X.any
};
bo.propTypes = Tp;
bo.displayName = "KendoReactSchedulerAgendaView";
const Ji = a.forwardRef((e, t) => {
  const r = a.useRef(null), n = a.useRef(null), o = He();
  a.useImperativeHandle(r, () => ({
    element: n.current && n.current.element,
    ...e
  })), a.useImperativeHandle(t, () => r.current);
  const l = a.useCallback(
    (s) => {
      !e.onClick || !r.current || e.onClick.call(void 0, {
        target: r.current,
        syntheticEvent: s
      });
    },
    [
      r,
      e.slot,
      e.onClick
    ]
  ), i = o.toLanguageString(In, Q[In]);
  return /* @__PURE__ */ a.createElement(
    xe,
    {
      ref: n,
      tabIndex: -1,
      className: "k-more-events",
      onClick: l,
      "aria-label": i,
      icon: "more-horizontal",
      svgIcon: oc
    }
  );
});
Ji.displayName = "KendoReactSchedulerShowMoreItemsButton";
const kp = { skeleton: "dd" }, pa = (e) => {
  const {
    group: t,
    timezone: r,
    resources: n
  } = at(), o = e.editItem || ma, l = e.editSlot || Or, [i] = ar(), [, s] = ni(), [, c] = io(), u = ai(), d = Vt(), m = ao(), p = At(), f = Qe(), h = $e(), y = e.itemsPerSlot || Qi.itemsPerSlot, k = a.useMemo(
    () => wr(
      p,
      { step: Xe * ut, timezone: r }
    ),
    [p.start.getTime(), p.end.getTime(), r]
  ), M = a.useMemo(
    () => Mr(
      p,
      { step: Xe },
      { groups: d, ranges: k }
    ),
    [
      p.start.getTime(),
      p.end.getTime(),
      d,
      k
    ]
  ), I = a.useMemo(
    () => or(i, { dateRange: p, fields: h, timezone: r }),
    [i, p.start.getTime(), p.end.getTime(), h, r]
  ), D = a.useMemo(
    () => Bt(I, { timezone: r }, { groups: d, ranges: k }),
    [I, r, d, k]
  ), x = a.useCallback(
    (v) => {
      const w = u.find((T) => T.props.name === "day");
      !c || !w || !w.props.name || !v.target.slot || (c(w.props.name, v), s(v.target.slot.start, v));
    },
    [
      c,
      u
    ]
  );
  a.useMemo(() => Gt(D, M, !0), [D, M]), a.useMemo(() => Er(D, M, !0), [D, M]);
  const A = /* @__PURE__ */ a.createElement(Fe.Consumer, null, ({ groupIndex: v }) => /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row", key: v }, M.filter((w) => w.group.index === v && w.range.index === 0).map((w, T) => /* @__PURE__ */ a.createElement(
    fa,
    {
      as: e.dateHeaderCell,
      key: T,
      "data-dayslot-index": T,
      date: j.fromLocalDate(
        new Date(w.zonedEnd.getTime() - (w.zonedEnd.getTime() - w.zonedStart.getTime()) / 2),
        r
      ),
      start: w.start,
      end: w.end,
      format: { skeleton: "EEEE" }
    }
  )))), O = /* @__PURE__ */ a.createElement(Fe.Consumer, null, ({ groupIndex: v }) => k.map((w, T) => /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row", key: T }, M.filter((R) => R.group.index === v && R.range.index === T).map((R, F, V) => /* @__PURE__ */ a.createElement(
    l,
    {
      slot: e.slot,
      viewSlot: e.viewSlot,
      key: F,
      form: e.form,
      ...R,
      expandable: { offsetTop: 30, offsetBottom: y < R.items.length ? 15 : 0 },
      onDataAction: e.onDataAction,
      col: m === "horizontal" ? V.length * (v || 0) + F : F,
      row: m === "horizontal" ? T : k.length * (v || 0) + T,
      editable: e.editable
    },
    /* @__PURE__ */ a.createElement("span", { className: "k-link k-nav-day" }, f.formatDate(
      new Date(R.end.getTime() - (R.end.getTime() - R.start.getTime()) / 2),
      kp
    )),
    y < R.items.length && /* @__PURE__ */ a.createElement(Ji, { slot: R, onClick: x })
  )))));
  return /* @__PURE__ */ a.createElement(
    Ur,
    {
      props: e,
      slots: M,
      ranges: k,
      className: ve("k-scheduler-monthview", e.className)
    },
    /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-head" }, m === "horizontal" ? /* @__PURE__ */ a.createElement(It, { nested: !0, resources: n, group: t }, A) : /* @__PURE__ */ a.createElement(yt, { resources: n, group: t }, A)),
    /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-body" }, m === "horizontal" ? /* @__PURE__ */ a.createElement(It, { resources: n, group: t }, O) : /* @__PURE__ */ a.createElement(yt, { nested: !0, resources: n, group: t }, O), D.filter((v) => v.order === null || v.order < y).sort(ri).map((v) => /* @__PURE__ */ a.createElement(
      o,
      {
        item: e.item,
        viewItem: e.viewItem,
        form: e.form,
        key: v.isRecurring ? `${v.uid}:${v.group.index}:${v.range.index}:${v.originalStart}` : `${v.uid}:${v.group.index}:${v.range.index}`,
        ...v,
        onDataAction: e.onDataAction,
        style: { transform: "translateY(30px)" },
        vertical: !1,
        editable: e.editable,
        ignoreIsAllDay: !0
      }
    )))
  );
}, bp = ({ intl: e, date: t, timezone: r }) => {
  const n = Qr(gl(tt(t)), e.firstDay()), o = Rt(Qr(Qs(tt(t)), e.firstDay()), ut), l = j.fromUTCDate(Le(n), r), i = j.fromUTCDate(Le(o), r), s = new Date(l.getTime()), c = new Date(i.getTime());
  return {
    start: s,
    end: c,
    zonedStart: l,
    zonedEnd: i
  };
}, Qi = {
  name: "month",
  dateRange: bp,
  slotDuration: 24 * 60,
  slotDivision: 1,
  itemsPerSlot: 2,
  numberOfDays: 31,
  title: (e) => e.toLanguageString(tn, Q[tn]),
  selectedDateFormat: "{0:Y}",
  selectedShortDateFormat: "{0:Y}"
}, Sp = {
  itemsPerSlot: X.number
};
pa.propTypes = Sp;
pa.displayName = "KendoReactSchedulerMonthView";
const So = (e) => /* @__PURE__ */ a.createElement(
  Hr,
  {
    ...e,
    step: ut,
    numberOfDays: e.numberOfDays
  }
), Mp = (e) => tt(e), wp = (e, t) => tt(Rt(e, t || 1)), Ip = ({ intl: e, date: t, timezone: r }) => {
  const n = j.fromLocalDate(t, r), o = Mp(Qr(n, e.firstDay())), l = wp(o, ut), i = j.fromUTCDate(Le(o), r), s = j.fromUTCDate(Le(l), r), c = new Date(i.getTime()), u = new Date(s.getTime());
  return {
    start: c,
    end: u,
    zonedStart: i,
    zonedEnd: s
  };
}, Rp = {
  name: "week",
  slotDuration: 60,
  slotDivisions: 2,
  numberOfDays: ut,
  dateRange: Ip,
  title: (e) => e.toLanguageString(ja, Q[ja]),
  selectedDateFormat: "{0:D} - {1:D}",
  selectedShortDateFormat: "{0:d} - {1:d}"
};
So.displayName = "KendoReactSchedulerWeekView";
const es = (e) => {
  const t = At(), r = Math.round((t.end.getTime() - t.start.getTime()) / Xe);
  return /* @__PURE__ */ a.createElement(
    Hr,
    {
      ...e,
      step: ut,
      numberOfDays: r
    }
  );
}, xp = (e, t = ke.Sunday) => {
  let r = e.clone();
  for (; r.getDay() !== t; )
    r = r.addDays(-1);
  return r;
}, Np = ({ intl: e, date: t, timezone: r, ...n }) => {
  const o = j.fromLocalDate(t, r), l = n.workWeekStart !== void 0 ? n.workWeekStart : ke.Monday, i = n.workWeekEnd !== void 0 ? n.workWeekEnd : ke.Friday, s = i < l ? ut + i - l + 1 : i - l + 1, c = tt(xp(o, l)), u = Rt(c, s), d = j.fromUTCDate(Le(c), r), m = j.fromUTCDate(Le(u), r), p = new Date(d.getTime()), f = new Date(m.getTime());
  return {
    start: p,
    end: f,
    zonedStart: d,
    zonedEnd: m
  };
}, Ap = {
  name: "work-week",
  slotDuration: 60,
  slotDivisions: 2,
  numberOfDays: 7,
  dateRange: Np,
  title: (e) => e.toLanguageString(Ja, Q[Ja]),
  workWeekStart: ke.Monday,
  workWeekEnd: ke.Friday,
  selectedDateFormat: "{0:D} - {1:D}",
  selectedShortDateFormat: "{0:d} - {1:d}"
};
es.displayName = "KendoReactSchedulerWorkWeekView";
const _p = /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-side-cell" }), Fp = (e) => /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("div", { className: "k-sticky-cell" }, _p), e.children), zp = (e) => {
  const t = He();
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("div", { className: "k-sticky-cell" }, /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-cell k-heading-cell k-side-cell k-scheduler-times-all-day", "data-range-index": 0 }, t.toLanguageString(qa, Q[qa]))), e.children);
}, Up = "t", Op = 0, Lp = (e) => {
  const {
    group: t,
    timezone: r,
    resources: n
  } = at(), o = a.useRef(null), l = a.useRef(null), i = e.editItem || ma, s = e.editSlot || Or, c = a.useRef(null), [u] = ar(), d = ao(), m = Vt(), p = At(), f = $e(), h = Qe(), y = e.showWorkHours, k = e.slotDivisions || st.slotDivisions, M = e.slotDuration || st.slotDuration, I = e.workWeekStart || st.workWeekStart, D = e.workWeekEnd || st.workWeekEnd, x = h.parseDate(e.workDayStart || e.isWorkDayStart || st.isWorkDayStart), A = h.parseDate(e.workDayEnd || e.isWorkDayEnd || st.isWorkDayEnd), O = h.parseDate(e.startTime || st.startTime), v = h.parseDate(e.endTime || st.endTime), w = a.useMemo(
    () => y ? x : O,
    [
      y,
      x,
      O
    ]
  ), T = a.useMemo(
    () => y ? A : v,
    [
      y,
      A,
      v
    ]
  ), R = a.useMemo(
    () => wr(
      p,
      { step: Xe, timezone: r }
    ),
    [
      p.start.getTime(),
      p.end.getTime(),
      r
    ]
  ), F = a.useMemo(
    () => Mr(
      p,
      { step: M / k * An },
      { groups: m, ranges: R }
    ).filter((b) => Ve(b.zonedStart, w, T) || w.getTime() === T.getTime()),
    [
      m,
      R,
      p.start.getTime(),
      p.end.getTime(),
      r,
      M,
      k,
      w.getTime(),
      T.getTime()
    ]
  ), V = a.useMemo(
    () => or(u, { dateRange: p, fields: f, timezone: r }),
    [u, p.start.getTime(), p.end.getTime(), f, r]
  ), z = a.useMemo(
    () => Bt(V, { timezone: r }, { groups: m, ranges: R }).filter(
      (b) => w.getTime() === T.getTime() || Ve(b.zonedStart, w, T) || Ve(b.zonedEnd, w, T) || Ve(
        new Date(b.zonedEnd.getTime() - (b.zonedEnd.getTime() - b.zonedStart.getTime()) / 2),
        w,
        T
      )
    ),
    [V, r, m, R, w.getTime(), T.getTime()]
  );
  a.useMemo(() => Gt(z, F, !0), [z, F]), a.useMemo(() => Er(z, F, !0), [z, F]);
  const P = (d === "horizontal" ? F.length : F.length / m.length) * ((e.columnWidth || st.columnWidth) + Re), L = /* @__PURE__ */ a.createElement(Fe.Consumer, null, () => /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row" }, R.map((b, g) => /* @__PURE__ */ a.createElement(
    fa,
    {
      as: e.dateHeaderCell,
      key: g,
      date: b.zonedStart,
      start: b.start,
      end: b.end,
      format: "m"
    }
  ))), /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row", ref: o }, R.map((b, g) => F.filter((_) => _.group.index === Op && _.range.index === g).map(
    (_) => _.zonedStart.getMinutes() % M === 0 ? /* @__PURE__ */ a.createElement(
      Do,
      {
        key: _.index,
        as: e.timeHeaderCell,
        format: Up,
        date: _.zonedStart,
        start: _.zonedStart,
        end: _.zonedEnd
      }
    ) : null
  ))))), U = /* @__PURE__ */ a.createElement(Fe.Consumer, null, ({ groupIndex: b }) => /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-row" }, R.map((g, _) => F.filter((W) => W.group.index === b && W.range.index === _).map((W, ee, re) => {
    const B = j.fromUTCDate(Le(W.zonedStart), r), ae = Ql(B.getDay(), I, D);
    return /* @__PURE__ */ a.createElement(
      s,
      {
        key: `${W.start.getTime()}:${W.group.index}`,
        slot: e.slot,
        viewSlot: e.viewSlot,
        ...W,
        form: e.form,
        onDataAction: e.onDataAction,
        isWorkHour: Ve(W.zonedStart, x, A),
        isWorkDay: ae,
        col: d === "horizontal" ? _ * re.length + ee + re.length * R.length * (b || 0) : _ * re.length + ee,
        row: d === "horizontal" ? 0 : b || 0,
        expandable: !0,
        editable: e.editable
      }
    );
  })))), C = a.useMemo(
    () => ve(
      "k-scheduler-timeline-view",
      e.className
    ),
    [e.className]
  );
  br({
    element: c,
    selector: ".k-resource-cell",
    attribute: "data-depth-index",
    explicitDepth: !0
  });
  const $ = c.current ? c.current.closest(".k-scheduler-layout") : null;
  return Hi({
    element: $,
    selector: ".k-resource-row",
    horizontalAttribute: "data-depth-index",
    verticalAttribute: "data-resource-index",
    applyTo: ".k-resource-cell",
    syncHeight: z && !z.length
  }), /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
    Ur,
    {
      ref: c,
      id: e.id,
      style: { ...e.style },
      className: C,
      props: e,
      slots: F,
      ranges: R
    },
    /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-head", style: { width: P } }, d === "horizontal" ? /* @__PURE__ */ a.createElement(
      It,
      {
        nested: !0,
        group: t,
        resources: n,
        rowContent: Fp
      },
      L
    ) : /* @__PURE__ */ a.createElement(
      yt,
      {
        wrapGroup: !0,
        group: t,
        resources: n
      },
      L
    )),
    /* @__PURE__ */ a.createElement("div", { className: "k-scheduler-body", style: { width: P }, ref: l }, d === "horizontal" ? /* @__PURE__ */ a.createElement(
      It,
      {
        group: t,
        resources: n,
        rowContent: zp
      },
      U,
      /* @__PURE__ */ a.createElement(Fe.Consumer, null, ({ groupIndex: b }) => e.currentTimeMarker && Ye(xt(R).start, hr(R).end, /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date(), !0) && /* @__PURE__ */ a.createElement(
        ra,
        {
          groupIndex: b,
          attachArrow: o,
          vertical: !0
        }
      ))
    ) : /* @__PURE__ */ a.createElement(
      yt,
      {
        nested: !0,
        wrapGroup: !0,
        group: t,
        resources: n
      },
      U
    ), d === "vertical" && e.currentTimeMarker && Ye(xt(R).start, hr(R).end, /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date(), !0) && /* @__PURE__ */ a.createElement(
      ra,
      {
        attachArrow: o,
        vertical: !0
      }
    ), z.sort(ri).map((b, g) => /* @__PURE__ */ a.createElement(
      i,
      {
        key: b.isRecurring ? `${b.uid}:${b.group.index}:${b.range.index}:${b.originalStart}` : `${b.uid}:${b.group.index}:${b.range.index}`,
        ...b,
        format: "t",
        form: e.form,
        onDataAction: e.onDataAction,
        item: e.item,
        viewItem: e.viewItem,
        editable: e.editable,
        ignoreIsAllDay: !0,
        vertical: !1,
        isLast: g === z.length - 1
      }
    )))
  ));
}, Hp = ({ date: e, numberOfDays: t = 1, timezone: r }) => {
  const n = j.fromLocalDate(e, r), o = tt(n), l = Rt(o, t), i = j.fromUTCDate(Le(o), r), s = j.fromUTCDate(Le(l), r), c = new Date(i.getTime()), u = new Date(s.getTime());
  return {
    start: c,
    end: u,
    zonedStart: i,
    zonedEnd: s
  };
}, st = {
  name: "multi-day-timeline",
  title: "Multi Day Timeline",
  currentTimeMarker: !0,
  dateRange: Hp,
  selectedDateFormat: "{0:D} - {1:D}",
  selectedShortDateFormat: "{0:d} - {1:d}",
  step: 1,
  numberOfDays: 1,
  startTime: "00:00",
  endTime: "00:00",
  isWorkDayStart: "8:00",
  isWorkDayEnd: "17:00",
  workWeekStart: ke.Monday,
  workWeekEnd: ke.Friday,
  slotDivisions: 2,
  slotDuration: 60,
  // showCurrentTime: true // TODO: Phase 2
  defaultShowWorkHours: !0,
  columnWidth: 100
}, ts = (e) => /* @__PURE__ */ a.createElement(Lp, { ...e }), Pp = {
  ...st,
  name: "timeline",
  title: (e) => e.toLanguageString(Xa, Q[Xa]),
  step: 1,
  slotDuration: 60,
  slotDivisions: 2,
  numberOfDays: 1,
  selectedDateFormat: "{0:D}",
  selectedShortDateFormat: "{0:d}"
};
ts.displayName = "KendoReactSchedulerTimelineView";
const Wp = "{0:D}", Yp = "{0:d}", $p = "application", Nt = /* @__PURE__ */ new Map();
Nt.set(bo, Cp);
Nt.set(Rr, vp);
Nt.set(pa, Qi);
Nt.set(So, Rp);
Nt.set(es, Ap);
Nt.set(ts, Pp);
const Mo = a.forwardRef((e, t) => {
  $s(ml);
  const r = Gs(ml), {
    timezone: n,
    onDataChange: o
  } = e, l = a.useRef(null), i = a.useRef(null);
  a.useImperativeHandle(i, () => ({ props: e, element: l.current })), a.useImperativeHandle(t, () => i.current);
  const s = Bs(l), c = Qe(), u = He(), { fields: d } = a.useMemo(() => mm(e.modelFields), [e.modelFields]), [
    m,
    p
  ] = Oe(e.defaultDate || lt.defaultDate, e.date, e.onDateChange), f = a.Children.toArray(e.children || []).map((H) => a.isValidElement(H) ? a.cloneElement(H, { ...Nt.get(H.type), ...H.props }) : H), h = a.cloneElement(/* @__PURE__ */ a.createElement(Rr, null), Nt.get(Rr)), [
    y,
    k
  ] = Oe(e.defaultView || f[0] && f[0].props.name || "day", e.view, e.onViewChange), [
    M,
    I
  ] = Oe(!0), D = f.find((H) => H.props.name === y) || f[0] || h, x = (e.data ?? lt.data) || lt.data, A = fm(e.group, e.resources), O = e.group && e.group.orientation ? e.group.orientation : "horizontal", v = D.props.selectedDateFormat || Wp, w = D.props.selectedShortDateFormat || Yp, T = D.props.slotDuration, R = D.props.dateRange !== void 0 ? typeof D.props.dateRange == "function" ? D.props.dateRange.call(void 0, {
    intl: c,
    date: m,
    timezone: n,
    numberOfDays: D.props.numberOfDays,
    workWeekStart: D.props.workWeekStart || c.firstDay(),
    workWeekEnd: D.props.workWeekEnd || (c.firstDay() + D.props.numberOfDays) % 6
  }) : D.props.dateRange : { start: lt.defaultDate, end: lt.defaultDate }, F = a.useCallback(
    ({ created: H = [], updated: G = [], deleted: se = [] }) => {
      if (o) {
        const oe = {
          created: H,
          updated: G,
          deleted: se
        };
        o.call(void 0, oe);
      }
    },
    [o]
  ), V = a.useCallback(
    (H) => {
      const G = [H.dataItem];
      F({ created: G });
    },
    [F]
  ), z = a.useCallback(
    (H) => {
      const G = [], se = [];
      if (H.series)
        if (Array.isArray(H.dataItem))
          H.dataItem.map((oe) => {
            const ce = ie(St(H.dataItem, d, x)), De = ie(oe);
            J(De, d.originalStart, Z(ce, d.originalStart)), J(De, d.recurrenceId, Z(ce, d.recurrenceId)), J(De, d.recurrenceExceptions, Z(ce, d.recurrenceExceptions)), se.push(De);
          });
        else {
          const oe = ie(St(H.dataItem, d, x)), ce = ie(H.dataItem);
          J(ce, d.originalStart, Z(oe, d.originalStart)), J(ce, d.recurrenceId, Z(oe, d.recurrenceId)), J(ce, d.recurrenceExceptions, Z(oe, d.recurrenceExceptions)), se.push(ce);
        }
      else if (Array.isArray(H.dataItem))
        H.dataItem.map((oe) => {
          const ce = Z(oe, d.recurrenceRule) !== null && Z(oe, d.recurrenceRule) !== void 0;
          if (Z(oe, d.recurrenceId) !== null && Z(oe, d.recurrenceId) !== void 0 && ce) {
            const De = ie(St(oe, d, x)), nt = Z(oe, d.originalStart), Et = Z(De, d.recurrenceExceptions) || [];
            J(De, d.recurrenceExceptions, [...Et, nt]), J(oe, d.recurrenceRule, null), se.push(De), G.push(oe);
          } else
            se.push(oe);
        });
      else {
        const oe = Z(H.dataItem, d.recurrenceRule) !== null && Z(H.dataItem, d.recurrenceRule) !== void 0;
        if (Z(H.dataItem, d.recurrenceId) !== null && Z(H.dataItem, d.recurrenceId) !== void 0 && oe) {
          const ce = ie(St(H.dataItem, d, x)), De = Z(H.dataItem, d.originalStart), nt = Z(ce, d.recurrenceExceptions) || [];
          J(ce, d.recurrenceExceptions, [...nt, De]), J(H.dataItem, d.recurrenceRule, null), se.push(ce), G.push(H.dataItem);
        } else
          se.push(H.dataItem);
      }
      F({ updated: se, created: G });
    },
    [F, d, x]
  ), P = a.useCallback(
    (H) => {
      const G = [], se = [];
      if (H.series) {
        const oe = ie(St(H.dataItem, d, x)), ce = ie(H.dataItem);
        J(ce, d.originalStart, Z(oe, d.originalStart)), J(ce, d.recurrenceId, Z(oe, d.recurrenceId)), J(ce, d.recurrenceRule, Z(oe, d.recurrenceRule)), J(ce, d.recurrenceExceptions, Z(oe, d.recurrenceExceptions)), se.push(ce);
      } else if (!(Z(H.dataItem, d.recurrenceRule) !== null && Z(H.dataItem, d.recurrenceRule) !== void 0))
        se.push(H.dataItem);
      else {
        const oe = ie(St(H.dataItem, d, x)), ce = Z(H.dataItem, d.originalStart), De = Z(oe, d.recurrenceExceptions) || [];
        J(oe, d.recurrenceExceptions, [...De, ce]), J(H.dataItem, d.recurrenceRule, null), G.push(oe);
      }
      F({ updated: G, deleted: se });
    },
    [F, d, x]
  ), L = a.useCallback(
    (H) => {
      switch (H.type) {
        case Ue.create:
          V(H);
          break;
        case Ue.update:
          z(H);
          break;
        case Ue.remove:
          P(H);
          break;
      }
    },
    [V, P, z]
  ), U = a.useCallback(
    (H, G) => {
      k(H, {
        ...G,
        target: i.current
      });
    },
    [
      k,
      i
    ]
  ), C = a.useCallback(
    (H, G) => {
      p(H, {
        ...G,
        target: i.current
      });
    },
    [
      p,
      i
    ]
  ), $ = a.useCallback(
    (H) => {
      H.value && p(H.value, {
        ...H,
        target: i.current,
        nativeEvent: H.nativeEvent
      });
    },
    [
      p,
      i
    ]
  ), b = a.useCallback(
    (H) => {
      H.preventDefault();
      const G = D.props.numberOfDays || 1, se = G > 27 ? No(m, Math.round(G / 27)) : Rt(m, G);
      p(se, event);
    },
    [m, p, D.props.numberOfDays]
  ), g = a.useCallback(
    (H) => {
      H.preventDefault();
      const G = D.props.numberOfDays || 1, se = G > 27 ? No(m, -Math.round(G / 27)) : Rt(m, -G);
      p(se, event);
    },
    [m, p, D.props.numberOfDays]
  ), _ = a.useCallback(
    (H) => {
      H.preventDefault();
      const G = dm();
      p(G, event);
    },
    [p]
  ), W = a.useCallback(
    () => {
      I(!M);
    },
    [I, M]
  ), ee = a.useCallback(
    () => {
      l.current && (l.current.style.boxShadow = "0 0.5px 0.5px 0.5px rgba(0, 0, 0, .12)");
    },
    [l]
  ), re = a.useCallback(
    () => {
      l.current && (l.current.style.boxShadow = "");
    },
    [l]
  ), B = a.useMemo(
    () => ({ ...e.style, height: e.height ?? lt.height }),
    [e.height, e.style]
  ), ae = a.useMemo(
    () => ve(
      { "k-rtl": e.rtl !== void 0 ? e.rtl : s === "rtl" },
      "k-widget k-scheduler k-floatwrap k-pos-relative",
      e.className
    ),
    [e.className, e.rtl, s]
  ), ue = u.toLanguageString(Za, Q[Za]), ye = u.toLanguageString(rn, Q[rn]), ne = u.toLanguageString(an, Q[an]), Ae = D.props.header || e.header || lt.header, he = D.props.footer || e.footer || lt.footer, Me = co, [Ee, Ge] = a.useState(null);
  return /* @__PURE__ */ a.createElement(
    hm,
    {
      element: l,
      props: e,
      views: f,
      fields: d,
      groups: A,
      dateRange: R,
      orientation: O,
      dateFormat: { dateFormat: v, shortDateFormat: w },
      date: [m, C],
      activeView: [y, U],
      selection: [Ee, Ge],
      data: [x, L]
    },
    /* @__PURE__ */ a.createElement(
      "div",
      {
        ref: l,
        id: e.id,
        style: B,
        className: ae,
        tabIndex: e.tabIndex ?? lt.tabIndex,
        dir: s,
        role: e.role || $p,
        "aria-label": e.ariaLabel,
        "aria-labelledby": e.ariaLabelledby,
        "aria-activedescendant": Ee && Ee.props.id || void 0,
        onFocus: ee,
        onBlur: re
      },
      /* @__PURE__ */ a.createElement(Ae, null, /* @__PURE__ */ a.createElement(Me, null, /* @__PURE__ */ a.createElement(Nn, { className: "k-scheduler-navigation" }, /* @__PURE__ */ a.createElement(
        xe,
        {
          role: "button",
          tabIndex: -1,
          title: ue,
          "aria-label": ue,
          onClick: _
        },
        ue
      ), /* @__PURE__ */ a.createElement(
        xe,
        {
          role: "button",
          tabIndex: -1,
          icon: s === "rtl" ? "caret-alt-right" : "caret-alt-left",
          svgIcon: s === "rtl" ? Wt : Pt,
          title: ye,
          "aria-label": ye,
          onClick: g
        }
      ), /* @__PURE__ */ a.createElement(
        xe,
        {
          role: "button",
          tabIndex: -1,
          icon: s === "rtl" ? "caret-alt-left" : "caret-alt-right",
          svgIcon: s === "rtl" ? Pt : Wt,
          title: ne,
          "aria-label": ne,
          onClick: b
        }
      ))), /* @__PURE__ */ a.createElement(
        Si,
        {
          value: m,
          onChange: $
        }
      ), /* @__PURE__ */ a.createElement(js, null), /* @__PURE__ */ a.createElement(Li, null)),
      D && /* @__PURE__ */ a.createElement(
        D.type,
        {
          editable: e.editable ?? lt.editable,
          key: D.props.name,
          item: e.item,
          viewItem: e.viewItem,
          editItem: e.editItem,
          task: e.task,
          viewTask: e.viewTask,
          editTask: e.viewTask,
          slot: e.slot,
          viewSlot: e.viewSlot,
          editSlot: e.editSlot,
          form: e.form,
          onDataAction: L,
          showWorkHours: M,
          ...D.props
        }
      ),
      /* @__PURE__ */ a.createElement(he, null, T && T < 24 * 60 && /* @__PURE__ */ a.createElement(jm, null, /* @__PURE__ */ a.createElement(
        xe,
        {
          tabIndex: -1,
          onClick: W,
          icon: "clock",
          svgIcon: lc
        },
        u.toLanguageString(
          M ? nn : on,
          Q[M ? nn : on]
        )
      ))),
      r && /* @__PURE__ */ a.createElement(Ks, null)
    )
  );
}), lt = {
  data: [],
  height: 600,
  tabIndex: -1,
  editable: !1,
  defaultDate: /* @__PURE__ */ new Date(),
  header: oi,
  footer: Em,
  navigation: co,
  viewSelector: li
};
Mo.propTypes = {
  data: X.array,
  editable: X.oneOfType([
    X.bool,
    X.shape({
      add: X.bool,
      drag: X.bool,
      edit: X.bool,
      remove: X.bool,
      resize: X.bool
    })
  ]),
  view: X.string,
  defaultView: X.string,
  date: X.any,
  defaultDate: X.any,
  rtl: X.bool,
  height: X.oneOfType([X.number, X.string]),
  children: X.any,
  timezone: X.string,
  group: X.any,
  resources: X.any,
  modelFields: X.shape({
    id: X.string,
    start: X.string,
    startTimezone: X.string,
    end: X.string,
    endTimezone: X.string,
    isAllDay: X.string,
    title: X.string,
    description: X.string,
    recurrenceRule: X.string,
    recurrenceId: X.string,
    recurrenceException: X.string
  })
};
Mo.displayName = "KendoReactScheduler";
const Gp = 1, Bp = a.forwardRef((e, t) => {
  const { item: r, _ref: n, itemRef: o, ...l } = e, i = a.useRef(), s = a.useRef(null), c = a.useRef(null), u = a.useRef(null);
  a.useImperativeHandle(c, () => ({ props: e, element: s.current && s.current.element })), a.useImperativeHandle(t, () => c.current), a.useImperativeHandle(n, () => s.current), a.useImperativeHandle(o, () => s.current);
  const d = r || Kp.item, m = Qe(), [p] = zr(), [f] = qt(), h = Fr(), [y, k] = a.useState(!0), [M, I] = a.useState(!1), [D, x] = a.useState(0), A = xr(h), O = a.useMemo(
    () => e.isAllDay ? m.toString(e.zonedStart, "t") : m.format("{0:t} - {1:t}", e.zonedStart, e.zonedEnd),
    [m, e.isAllDay, e.zonedEnd, e.zonedStart]
  ), v = a.useMemo(() => `(${O}): ${e.title}`, [O, e.title]), w = (P, L) => {
    let U = 1;
    return P.forEach((C) => {
      const $ = L.filter((b) => R(C.current.props, b.props));
      $.length > U && (U = $.length);
    }), U;
  }, T = (P, L) => P.map((U) => L.filter((C) => R(U.current.props, C.props))), R = (P, L) => Ye(P.start, P.end, L.start, L.end) && P.group.index === L.group.index && P.range.index === L.range.index && (e.ignoreIsAllDay || P.isAllDay === L.isAllDay), F = () => {
    const P = (f || []).filter((C) => C.current && R(C.current.props, e));
    if (P.length === 0) {
      k(!1);
      return;
    }
    const L = xt(P);
    if (!L.current || !s.current)
      return;
    const U = Ze(L.current.element);
    rr(s.current.element, U);
  }, V = () => {
    const P = (f || []).filter((he) => he.current && R(he.current.props, e)), L = s.current && s.current.element;
    if (!L || !P.length)
      return;
    const U = xt(P), C = hr(P);
    if (!U.current || !s.current || !C.current)
      return;
    const $ = [], b = [], g = [], _ = Ze(U.current.element), W = (e.vertical ? _.height : _.width) / (U.current.props.end.getTime() - U.current.props.start.getTime()), ee = (e.start.getTime() - U.current.props.start.getTime()) * W, re = (Math.min(e.end.getTime(), C.current.props.end.getTime()) - Math.max(e.start.getTime(), U.current.props.start.getTime())) * W;
    (p || []).forEach((he) => {
      he.current && (he.current.props.dragHint ? b.push(he.current) : he.current.props.resizeHint ? g.push(he.current) : $.push(he.current));
    });
    const B = e.dragHint || e.resizeHint ? ti(s.current, e.dragHint ? b : g, P, e.ignoreIsAllDay) : e.order || 0;
    let ae = e.dragHint || e.resizeHint ? w(P, e.dragHint ? b : g) : w(P, $);
    const ue = T(P, $);
    let ye = 0;
    const ne = Ze(L);
    if (ue.forEach((he) => {
      let Me = 0;
      he.forEach((Ee) => {
        Ye(Ee.props.start, Ee.props.end, e.start, e.end) && !(e.dragHint || e.resizeHint) && Ee.props._maxSiblingsPerSlot && Ee.props._maxSiblingsPerSlot > ae && Ee.element !== L && (ae = Ee.props._maxSiblingsPerSlot);
        const Ge = Ze(Ee.element);
        Ee.props.order !== null && Ee.props.order < B && (Me = Ge.top + Ge.height - ne.top - Re * B + Gp);
      }), Me > ye && (ye = Me);
    }), P.length === 0) {
      k(!1);
      return;
    }
    const Ae = 20;
    ne.width = e.vertical ? ne.width / ae - Re - Ae / ae : re + Re, ne.height = e.vertical ? re - Re : (e.resizeHint || e.dragHint) && ae <= 1 ? ne.height : e.style && e.style.height ? e.style.height : 25, ne.left = e.vertical ? ne.left + B * ne.width + Re * B : ne.left + (ee < 0 ? 0 : ee), ne.top = e.vertical ? ne.top + (ee < 0 ? 0 : ee) : ne.top + ye + Re * B, x(ae), rr(L, ne), I(!0), k(!0);
  }, z = a.useCallback(
    (P) => {
      const L = P && P[0], U = u.current;
      i.current !== void 0 && window.cancelAnimationFrame(i.current), U && L && (U.width !== L.contentRect.width || U.height !== L.contentRect.height) && (i.current = window.requestAnimationFrame(() => {
        F(), V();
      })), u.current = { width: L.contentRect.width, height: L.contentRect.height };
    },
    [F, V]
  );
  return a.useEffect(F), a.useEffect(V), a.useEffect(
    () => {
      if (!h.current)
        return;
      const P = window.ResizeObserver, L = P && new P(z);
      return L && L.observe(h.current), () => {
        L && L.disconnect();
      };
    },
    [z, h]
  ), /* @__PURE__ */ a.createElement(
    d,
    {
      ...l,
      _ref: s,
      _maxSiblingsPerSlot: D,
      itemRef: s,
      style: {
        visibility: M ? void 0 : "hidden",
        display: y ? void 0 : "none",
        ...e.style
      }
    },
    !e.resizeHint && /* @__PURE__ */ a.createElement("span", { className: "k-event-actions" }, e.tail && /* @__PURE__ */ a.createElement(
      ze,
      {
        name: A === "rtl" ? "caret-alt-right" : "caret-alt-left",
        icon: A === "rtl" ? Wt : Pt
      }
    ), e.isRecurring && !e.isException && /* @__PURE__ */ a.createElement(ze, { name: "reload", icon: _n }), !e.isRecurring && e.isException && /* @__PURE__ */ a.createElement(ze, { name: "non-recurrence", icon: ic })),
    !e.resizeHint && /* @__PURE__ */ a.createElement("div", { title: v }, !e.isAllDay && /* @__PURE__ */ a.createElement(ta, { className: "k-event-template k-event-time " }, v), /* @__PURE__ */ a.createElement(ta, { className: "k-event-template" }, e.title))
  );
}), Kp = {
  item: Lr
};
Bp.displayName = "KendoReactSchedulerProportionalViewItem";
var Xr = /* @__PURE__ */ ((e) => (e.Day = "day", e.Week = "week", e.Month = "month", e))(Xr || {});
const rs = zs({});
function Vp() {
  return Us(rs);
}
const qp = {
  [Xr.Day]: Rr,
  [Xr.Week]: So,
  [Xr.Month]: pa
};
function Zp(e) {
  var l;
  const { defaultUserId: t, userOptions: r } = Vp(), n = ((l = e.dataItem) == null ? void 0 : l.userId) || t, o = n && (r != null && r.length) ? r.find((i) => i.value === n) : void 0;
  return /* @__PURE__ */ Ie.jsx(
    sc,
    {
      validateOnSubmit: !0,
      initialValues: { ...e.dataItem, user: o },
      onSubmit: (i, s) => {
        var c;
        e.onSubmit({
          value: { ...i, userId: ((c = i.user) == null ? void 0 : c.value) || t },
          syntheticEvent: s,
          target: {}
        });
      },
      render: (i) => {
        const s = i.valueGetter("isAllDay");
        return /* @__PURE__ */ Ie.jsx(yc, { title: "Event", onClose: () => {
          var c;
          return (c = e.onClose) == null ? void 0 : c.call(e, {});
        }, children: /* @__PURE__ */ Ie.jsxs(cc, { style: { width: "500px" }, children: [
          /* @__PURE__ */ Ie.jsx(Jt, { name: "title", label: "Title", component: Ao, rows: 1, autoSize: !0, required: !0 }),
          (r == null ? void 0 : r.length) && /* @__PURE__ */ Ie.jsx(
            Jt,
            {
              label: "User",
              name: "user",
              component: hc,
              textField: "label",
              dataItemKey: "value",
              data: r
            }
          ),
          /* @__PURE__ */ Ie.jsx(Jt, { name: "isAllDay", label: "All Day", component: gc }),
          /* @__PURE__ */ Ie.jsx(
            Jt,
            {
              name: "start",
              label: "Start Date",
              component: s ? zo : _o,
              validator: (c) => c > i.valueGetter("end") ? "Must be before end date" : "",
              required: !0
            }
          ),
          /* @__PURE__ */ Ie.jsx(
            Jt,
            {
              name: "end",
              label: "End Date",
              component: s ? zo : _o,
              validator: (c) => c < i.valueGetter("start") ? "Must be after start date" : "",
              required: !0
            }
          ),
          /* @__PURE__ */ Ie.jsx(Jt, { name: "description", label: "Description", component: Ao }),
          /* @__PURE__ */ Ie.jsxs("div", { style: { display: "flex", marginTop: ".5rem", justifyContent: "center" }, children: [
            /* @__PURE__ */ Ie.jsx(Fo, { onClick: e.onCancel, fillMode: "outline", children: "Cancel" }),
            /* @__PURE__ */ Ie.jsx(Fo, { style: { marginLeft: ".5rem" }, type: "submit", children: "Save" })
          ] })
        ] }) });
      }
    }
  );
}
const Gv = Os(function({ includedViews: t, onViewChange: r, defaultUserId: n, userOptions: o, ...l }, i) {
  const s = Ls(
    ({ value: u }) => {
      r == null || r(u);
    },
    [r]
  ), c = Hs(
    () => [
      {
        name: "User",
        field: "userId",
        data: o || [],
        valueField: "value",
        textField: "label",
        colorField: "color"
      }
    ],
    [o]
  );
  return /* @__PURE__ */ Ie.jsx(rs.Provider, { value: { defaultUserId: n, userOptions: o }, children: /* @__PURE__ */ Ie.jsx(
    Mo,
    {
      ...l,
      resources: c,
      onViewChange: s,
      form: Zp,
      ref: i,
      children: t == null ? void 0 : t.map((u) => {
        const d = qp[u];
        return /* @__PURE__ */ Ie.jsx(d, {}, u);
      })
    }
  ) });
});
export {
  Gv as Scheduler,
  Xr as SchedulerViewType
};
